"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[33516],{

/***/ 20539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71577);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52435);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: 1px solid ",
        ";\n    color: inherit;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: none;\n    border: none;\n    box-shadow: none;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background-color: ",
        ";\n    border: unset;\n    color: ",
        ";\n    cursor: not-allowed;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      color: ",
        ";\n      :hover {\n        color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      :hover {\n        transition: 0.2s ease-in;\n        cursor: pointer;\n        background-color: ",
        ";\n        color: ",
        ";\n        border: 1px solid ",
        ";\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: 'ProximaNovaRg';\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: ",
        ";\n  margin: ",
        ";\n  width: ",
        ";\n  height: ",
        ";\n  font-size: ",
        ";\n\n  ",
        "\n  ",
        ";\n\n  :focus,\n  :hover {\n    ",
        "\n  }\n\n  [disabled] {\n    color: ",
        " !important;\n    background-color: ",
        " !important;\n  }\n\n  ::after {\n    content: unset;\n  }\n\n  ",
        "\n\n  ",
        "\n\n    ::after {\n    content: unset;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var buttonTheme = {
    primary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary),
    secondary: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    facebook: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].secondary */ .Z.secondary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    trading: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].trading */ .Z.trading, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light),
    default: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject5(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro),
    borderless: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject6()),
    muted: (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject7(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].suvaGrey */ .Z.suvaGrey, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light)
};
var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        type: props.type || "default",
        margin: props.margin || "unset",
        height: props.height || "auto",
        radius: props.radius || "2px",
        isHoverable: props.isHoverable || false,
        width: props.width,
        fontSize: props.fontSize || "14px"
    }, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-3738f451-0"
})(_templateObject11(), function(param) {
    var radius = param.radius;
    return radius;
}, function(param) {
    var margin = param.margin;
    return margin;
}, function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var height = param.height;
    return height;
}, function(param) {
    var fontSize = param.fontSize;
    return fontSize;
}, function(param) {
    var key = param.color;
    return _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject8(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit", _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[key] || "inherit");
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, function(param) {
    var type = param.type;
    return buttonTheme[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].midgray */ .Z.midgray, function(param) {
    var isHoverable = param.isHoverable;
    return isHoverable && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject9(), _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light, _style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].gainsboro */ .Z.gainsboro);
}, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject10(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props));
});
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 70187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R_": function() { return /* binding */ PopoverContentWrapper; },
/* harmony export */   "xK": function() { return /* binding */ PopoverTitleWrapper; },
/* harmony export */   "yk": function() { return /* binding */ PopoverContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10808);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var _Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 100%;\n  max-height: 400px;\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid ",
        ";\n  height: 40px;\n  padding: 0 16px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-height: 360px;\n  overflow-y: auto;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var PopoverContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        padding: props.padding || 0
    };
}).withConfig({
    componentId: "sc-b405b759-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var padding = param.padding;
    return padding;
});
var PopoverTitleWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-b405b759-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro);
var PopoverContent = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-b405b759-2"
})(_templateObject2());

/* harmony default export */ __webpack_exports__["ZP"] = (antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);


/***/ }),

/***/ 12484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      border-radius: 0px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background-color: ",
        ";\n      color: ",
        ";\n      font-weight: 700;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      border: 1px solid ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 2px 5px;\n      font-size: 11px;\n      line-height: 1;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 1px 5px;\n      font-size: 12px;\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 6px;\n      font-size: 12.5px;\n      line-height: 20px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 0 8px;\n      font-size: 14px;\n      line-height: 25px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  ",
        "\n  margin: ",
        ';\n  font-family: "ProximaNovaRg";\n  border-radius: 2px;\n  display: inline-block;\n  text-align: center;\n'
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-block;\n  background-color: ",
        ";\n  text-align: center;\n  height: 30px;\n  padding: 0 10px;\n  border-left: 5px solid;\n  border-left-color: ",
        ";\n  animation-duration: 0.6s;\n  animation-fill-mode: both;\n  animation-timing-function: ease-out;\n  font-weight: bolder;\n  font-size: 18px;\n  line-height: 30px;\n  color: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}


var tagProps = {
    theme: {
        "outline-primary": (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary),
        veryLightGrey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].veryLightGrey */ .Z.veryLightGrey, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis),
        grey: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dimgray */ .Z.dimgray, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        dark: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].nightRider */ .Z.nightRider, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light),
        default: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro)
    },
    size: {
        xs: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5()),
        s: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6()),
        m: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject7()),
        l: (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8())
    }
};
var tagColorByType = {
    up: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    down: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].primary */ .Z.primary,
    neutral: _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].midgray */ .Z.midgray
};
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        size: props.size || "m",
        type: props.type || "default",
        margin: props.margin || 0
    };
}).withConfig({
    componentId: "sc-74ce45aa-0"
})(_templateObject9(), function(param) {
    var type = param.type;
    return tagProps.theme[type];
}, function(param) {
    var size = param.size;
    return tagProps.size[size];
}, function(param) {
    var margin = param.margin;
    return margin;
});
var SymbolTag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        type: props.type || "neutral"
    };
}).withConfig({
    componentId: "sc-74ce45aa-1"
})(_templateObject10(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].highempahis */ .Z.highempahis, function(param) {
    var type = param.type;
    return tagColorByType[type];
}, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].light */ .Z.light);
/* harmony default export */ __webpack_exports__["Z"] = ({
    Tag: Tag,
    SymbolTag: SymbolTag
});


/***/ }),

/***/ 4377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69428);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22147);
/* harmony import */ var assets_base64icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54392);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: 30px;\n  border-left: 0;\n  border-right: 0;\n  border-color: ",
        " !important;\n  box-shadow: unset !important;\n\n  input {\n    text-align: center;\n  }\n\n  .ant-input-number-handler-wrap {\n    opacity: 1;\n    display: flex;\n    border: unset;\n    width: 100%;\n    background: unset;\n    justify-content: space-between;\n  }\n\n  .ant-input-number-handler-up {\n    position: absolute;\n    line-height: 30px;\n    height: 32px;\n    width: 30px;\n    right: -29px;\n    top: -1px;\n    border: 1px solid ",
        ";\n    border-left: 0;\n    border-radius: 0 2px 2px 0;\n\n    span {\n      display: none !important;\n    }\n    ::before {\n      content: url(",
        ");\n    }\n  }\n\n  .ant-input-number-handler-down {\n    position: absolute;\n    line-height: 30px;\n    height: 32px;\n    width: 30px;\n    left: -29px;\n    top: -1px;\n    border: 1px solid ",
        ";\n    border-right: 0;\n    border-radius: 2px 0 0 2px;\n\n    span {\n      display: none !important;\n      border: unset;\n    }\n\n    ::before {\n      content: url(",
        ");\n    }\n  }\n\n  .ant-input-number-handler-up:hover,\n  .ant-input-number-handler-down:hover {\n    height: 32px !important;\n  }\n\n  .ant-input-number-handler,\n  .ant-input-number-handler-wrap:hover .ant-input-number-handler {\n    background: ",
        ";\n    height: 32px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




/* harmony default export */ __webpack_exports__["Z"] = ((0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs({
    formatter: function(value) {
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    parser: function(value) {
        return value.replace(/\s?|(,*)/g, "");
    }
}).withConfig({
    componentId: "sc-d36ac3ab-0"
})(_templateObject(), _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, assets_base64icon__WEBPACK_IMPORTED_MODULE_4__/* .plusIcon */ .R7, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].gainsboro */ .Z.gainsboro, assets_base64icon__WEBPACK_IMPORTED_MODULE_4__/* .minusIcon */ .$s, _style_color__WEBPACK_IMPORTED_MODULE_1__/* ["default"].aliceBlue */ .Z.aliceBlue));


/***/ }),

/***/ 84607:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 *
 * @param {number} percentNum - accept value 0 until 100
 * eg:
 * import hexOpacity from "./hexOpacity";
 *
 * ...
 * ...
 *  color: ${color.primary + hexOpacity(80)}
 * ...
 *
 */ var percentToHex = function() {
    var percentNum = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return Math.round(percentNum / 100 * 255).toString(16).padStart(2, "0");
};
/* harmony default export */ __webpack_exports__["Z"] = (percentToHex);


/***/ }),

/***/ 38639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C3": function() { return /* binding */ ContainerTemplateWrapper; },
/* harmony export */   "kC": function() { return /* binding */ Flex; },
/* harmony export */   "l2": function() { return /* binding */ UserRdnInfoContainer; }
/* harmony export */ });
/* unused harmony exports PageContainer, CarouselContainer, RightSection, VirtualButtonContainer, Carousel, CarouselItemContainer, CarouselImage, VirtualButton, LoginButton, RegisterButton, Input, InputPINForm, InputPINContainer, RegisterContainer, BannerRegisterContainer, BackButton, InfoRegisterContainer, Iconmoon, GrayBackButton, ProfileLabel, ProfileInputGroup, InputTokenContainer */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15807);
/* harmony import */ var _deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54325);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74575);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22147);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19521);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61980);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71230);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(579);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  overflow-y: hidden;\n  position: relative;\n  margin-top: 60px;\n  height: calc(100vh - 60px);\n\n  @media ",
        " {\n    margin-top: 103px;\n    height: calc(100vh - 103px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    background: #5dcbad26;\n    padding: 30px;\n    height: calc(100vh - 60px);\n    max-height: 100%;\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  background: ",
        ";\n  padding: 30px;\n  overflow-y: auto;\n\n  @media ",
        " {\n    /* height: 95vh;\n    max-height: 100%; */\n    height: calc(100vh - 101px);\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 300px;\n  margin-bottom: 50px;\n\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 50px;\n  height: 100%;\n  max-height: 550px;\n  margin-top: 23%;\n\n  .slick-dots {\n    width: auto;\n    bottom: -60px;\n\n    li {\n      width: unset;\n    }\n\n    li button {\n      background: gray;\n      width: 5px;\n      height: 5px;\n      border-radius: 10px;\n\n      &::before {\n        display: none;\n      }\n    }\n\n    li.slick-active button {\n      width: 25px;\n      height: 5px;\n      background: ",
        ";\n      border: unset;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 240px;\n  margin: auto;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 0 auto 25px;\n  width: 180px;\n  height: 180px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 20px auto;\n  padding: 10px 15px;\n  border-radius: 10px;\n  background: transparent;\n\n  img {\n    margin-right: 10px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 5px;\n  width: 100%;\n  margin: 5px 0;\n\n  @media ",
        " {\n    width: 268px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 5px;\n  width: 100%;\n  margin: 5px 0;\n  padding: 6px;\n  border: 1px solid ",
        ";\n\n  @media ",
        " {\n    width: 268px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &\n    .ant-form-item-has-error\n    .ant-input-affix-wrapper-focused.securities-input-pin,\n  & .ant-form-item-has-error .ant-input-affix-wrapper,\n  & .ant-form-item-has-error .securities-input-pin:hover {\n    border-color: ",
        " !important;\n    box-shadow: none;\n  }\n\n  & .ant-form-item-explain.ant-form-item-explain-error {\n    margin-top: 4px;\n    min-height: 19px;\n\n    div {\n      display: flex;\n      align-items: center;\n      font-size: 12px;\n      line-height: 1.5;\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n\n  .eye {\n    position: absolute;\n    right: 10px;\n    width: 16px;\n    cursor: pointer;\n  }\n\n  .withdrawal-input-pin {\n    padding: 0;\n\n    &.ant-input-affix-wrapper {\n      padding: 0;\n      margin-bottom: 4px;\n    }\n\n    .ant-input-prefix {\n      background: ",
        ";\n      margin-right: 12px;\n      padding: 11px;\n      border-right: 1px solid ",
        ";\n    }\n  }\n\n  .ant-input-group-addon {\n    background: ",
        ";\n  }\n\n  .securities-input-pin {\n    margin: 15px 0 5px;\n    height: 35px;\n    padding-left: 45px;\n\n    &::placeholder {\n      font-family: var(--bold-font);\n      color: #e4e4e4;\n    }\n\n    &.ant-input-affix-wrapper-focused {\n      border-color: ",
        ";\n      box-shadow: none;\n    }\n  }\n\n  .ant-input-group .ant-input {\n    width: 85%;\n  }\n\n  .icon-password.input-prefix {\n    position: absolute;\n    top: 15px;\n    left: 0;\n    width: 35px;\n    height: 35px;\n    text-align: center;\n    line-height: 35px;\n    border-right: 1px solid ",
        ";\n    z-index: 2;\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  height: 585px;\n  max-width: 798px;\n  margin: 20px auto;\n  background: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n  position: relative;\n  width: 40%;\n  padding: 20px;\n\n  img {\n    position: absolute;\n    right: 0;\n    top: 170px;\n  }\n\n  @media ",
        " {\n    display: block;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  height: 35px;\n  padding: 20px;\n  border: 1px solid ",
        ";\n  border-radius: 3px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  padding: 0px 40px;\n  border-left: 1px solid ",
        ";\n  height: 100%;\n  background: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &:before {\n    color: ",
        " !important;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  position: absolute;\n  top: 25px;\n  left: 20px;\n  @media ",
        " {\n    display: none;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  margin: 0 auto;\n  height: fit-content;\n  border-radius: 4px;\n  width: ",
        ";\n\n  &.deposit-section-instruction {\n    border: none;\n    border-radius: 0;\n    min-height: 100%;\n\n    i.icon-up-arrow {\n      transform: rotate(-90deg);\n      font-size: 14px;\n      color: ",
        ";\n    }\n  }\n\n  .header {\n    height: 56px;\n    padding: 0 20px;\n    border-bottom: 1px solid ",
        ";\n\n    p {\n      margin-bottom: 0;\n    }\n\n    .back-btn {\n      background: none;\n      border: none;\n      min-width: 30px;\n      width: fit-content;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      padding: 0;\n    }\n\n    .title {\n      font-family: var(--bold-font);\n      font-size: 18px;\n      line-height: 24px;\n      text-align: center;\n      color: ",
        ";\n    }\n\n    .right-header {\n      text-align: right;\n\n      .history-link {\n        font-size: 18px;\n        line-height: 24px;\n        text-align: right;\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-wrap: nowrap;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  padding: ",
        ";\n  text-align: left;\n\n  img {\n    display: block;\n    width: 40px;\n    height: 40px;\n    border-radius: 20px;\n  }\n\n  .text-content {\n    flex-grow: 1;\n    font-size: 14px;\n    line-height: 19px;\n    padding: 0 16px;\n    overflow: hidden;\n\n    p {\n      margin-bottom: 0;\n      line-height: 21px;\n    }\n\n    .rdn-name {\n      color: ",
        ";\n      word-break: break-word;\n      margin-bottom: 4px;\n    }\n\n    .rdn-account {\n      font-family: var(--bold-font);\n      color: ",
        ";\n      font-size: 13.5px;\n    }\n  }\n\n  .btn-copy {\n    background-color: #ebf6ef;\n    font-size: 14px;\n    line-height: 17px;\n    letter-spacing: 0.02em;\n    color: ",
        ";\n    padding: 8px 10px;\n    border-radius: 4px;\n    border: none;\n    font-family: var(--bold-font);\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-right: 16px;\n  width: 30%;\n  color: ",
        ";\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  margin: 25px 0;\n  width: 100%;\n\n  &.small-margin {\n    margin: 5px 0;\n  }\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .input-token {\n    border: 1px solid ",
        ";\n    height: 36px;\n    input {\n      border: none;\n      font-size: 16px;\n      padding: 5px;\n    }\n  }\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}









var Flex = _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z;
var PageContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-0"
})(_templateObject(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var CarouselContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-1"
})(_templateObject1(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet, function(props) {
    return props.width ? props.width : "100%";
});
var RightSection = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-2"
})(_templateObject2(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet, function(props) {
    return props.width ? props.width : "100%";
});
var VirtualButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-182c06c0-3"
})(_templateObject3(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var Carousel = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-4"
})(_templateObject4(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary);
var CarouselItemContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-5"
})(_templateObject5());
var CarouselImage = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(global_Image__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-6"
})(_templateObject6());
var VirtualButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-7"
})(_templateObject7());
var LoginButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-8"
})(_templateObject8(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var RegisterButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-9"
})(_templateObject9(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var Input = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-10"
})(_templateObject10());
var InputPINForm = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-11"
})(_templateObject11(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].sunsetOrange */ .Z.sunsetOrange, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].sunsetOrange */ .Z.sunsetOrange);
var InputPINContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-182c06c0-12"
})(_templateObject12(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro);
var RegisterContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-13"
})(_templateObject13(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].downgray */ .Z.downgray);
var BannerRegisterContainer = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-182c06c0-14"
})(_templateObject14(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var BackButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-15"
})(_templateObject15(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary);
var InfoRegisterContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-16"
})(_templateObject16(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light);
var Iconmoon = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-17"
})(_templateObject17(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary);
var GrayBackButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-18"
})(_templateObject18(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_5__/* ["default"].tablet */ .Z.tablet);
var ContainerTemplateWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-19"
})(_templateObject19(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro, function(param) {
    var width = param.width;
    if (typeof width === "number") return "".concat(width, "px");
    return width;
}, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].midgray */ .Z.midgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].highempahis */ .Z.highempahis, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary);
var UserRdnInfoContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-20"
})(_templateObject20(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].downgray */ .Z.downgray, function(param) {
    var padding = param.padding;
    if (padding) {
        if (typeof padding === "number") return "".concat(padding, "px");
        return padding;
    }
    return "16px 24px";
}, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].highgray */ .Z.highgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].highempahis */ .Z.highempahis, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].primary */ .Z.primary);
var ProfileLabel = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].label.withConfig */ .ZP.label.withConfig({
    componentId: "sc-182c06c0-21"
})(_templateObject21(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].highempahis */ .Z.highempahis);
var ProfileInputGroup = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-22"
})(_templateObject22());
var InputTokenContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-182c06c0-23"
})(_templateObject23(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_6__/* ["default"].gainsboro */ .Z.gainsboro);


/***/ }),

/***/ 17921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C2": function() { return /* binding */ formatShiftedCurrency; },
/* harmony export */   "T4": function() { return /* binding */ formatPrice; },
/* harmony export */   "VZ": function() { return /* binding */ getMostMinMaxAmountRules; },
/* harmony export */   "_j": function() { return /* binding */ adjustCursorPosition; },
/* harmony export */   "_y": function() { return /* binding */ generateTimeDiffText; },
/* harmony export */   "bF": function() { return /* binding */ updateCursorPosition; },
/* harmony export */   "i$": function() { return /* binding */ isOverDailyLimit; },
/* harmony export */   "iM": function() { return /* binding */ formatPricePercentage; },
/* harmony export */   "kI": function() { return /* binding */ isUnderDailyLimit; },
/* harmony export */   "qF": function() { return /* binding */ formatBondDate; },
/* harmony export */   "uJ": function() { return /* binding */ formatBondCurrency; },
/* harmony export */   "uf": function() { return /* binding */ formatNumber; },
/* harmony export */   "xG": function() { return /* binding */ formatCurrency; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36305);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_1__);



// eslint-disable-next-line import/prefer-default-export
var formatBondDate = function(date) {
    if (!date) {
        return "-";
    }
    var formatFullMonthId = Intl.DateTimeFormat("id-ID", {
        day: "2-digit",
        month: "long",
        year: "numeric"
    });
    return formatFullMonthId.format(new Date(date));
};
var formatBondCurrency = function(value) {
    var signDisplay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "never", currency = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "IDR";
    return Intl.NumberFormat("en-US", {
        style: "currency",
        currency: currency,
        currencyDisplay: "narrowSymbol",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        signDisplay: signDisplay,
        unitDisplay: "narrow"
    }).format(value).replace(/\s+/g, "");
};
var formatPricePercentage = function(value) {
    var signDisplay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "never";
    if (typeof value !== "number") {
        return "-";
    }
    var rawValue = value / 100;
    return Intl.NumberFormat("en-US", {
        style: "percent",
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        signDisplay: signDisplay,
        unitDisplay: "narrow"
    }).format(rawValue);
};
var formatCurrency = function(value) {
    var fractionDigits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, currency = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Rp";
    return "".concat(currency).concat(Number(value).toLocaleString(undefined, {
        minimumFractionDigits: fractionDigits
    }));
};
var formatShiftedCurrency = function(value) {
    var fixZero = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, fractionDigits = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, currency = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "Rp";
    var isNegative = value <= 0;
    var absoluteValue = Math.abs(value).toLocaleString(undefined, {
        minimumFractionDigits: fractionDigits
    });
    var formattedValue = "".concat(currency).concat(absoluteValue);
    if (fixZero && value === 0) return "".concat(formattedValue);
    return "".concat(isNegative ? "- " : "").concat(formattedValue);
};
var formatPrice = function(value) {
    var fractionDigits = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return Number(value).toLocaleString(undefined, {
        minimumFractionDigits: fractionDigits
    });
};
var formatNumber = function(number) {
    return numeral__WEBPACK_IMPORTED_MODULE_1___default()(number).format("0,0");
};
var isOverDailyLimit = function(inputValue, method) {
    var code = method.code, amount = method.amount, daily_limit = method.daily_limit;
    var ref = daily_limit || {}, remaining = ref.remaining, dailyMax = ref.max;
    return code && remaining !== 0 && dailyMax !== 0 && remaining < amount.min && (inputValue > remaining || inputValue > dailyMax);
};
var isUnderDailyLimit = function(inputValue, method) {
    var code = method.code, amount = method.amount, daily_limit = method.daily_limit;
    var ref = daily_limit || {}, remaining = ref.remaining, dailyMax = ref.max;
    return code && remaining !== 0 && dailyMax !== 0 && inputValue <= dailyMax && remaining >= amount.min && inputValue > remaining;
};
var getMostMinMaxAmountRules = function(methods) {
    if (methods === null || methods === void 0 ? void 0 : methods.length) {
        var _Math, _Math1;
        var amounts = methods.map(function(method) {
            return method.amount;
        });
        var min = (_Math = Math).min.apply(_Math, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(amounts.map(function(amount) {
            return amount.min;
        })));
        var max = (_Math1 = Math).max.apply(_Math1, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(amounts.map(function(amount) {
            return amount.max;
        })));
        return {
            min: min,
            max: max
        };
    }
    return {
        min: 0,
        max: 0
    };
};
var updateCursorPosition = function(event, newCursorPosition) {
    window.requestAnimationFrame(function() {
        var inputElement = event.target;
        inputElement.setSelectionRange(newCursorPosition, newCursorPosition);
    });
};
var adjustCursorPosition = function(event, cursorPosition, originalValue, formattedValue) {
    var commaCountBefore = originalValue.slice(0, cursorPosition).split(",").length - 1;
    var commaCountAfter = formattedValue.slice(0, cursorPosition).split(",").length - 1;
    var adjustment = commaCountAfter - commaCountBefore;
    var newCursorPosition = formattedValue === "0" ? 1 : cursorPosition + adjustment;
    updateCursorPosition(event, newCursorPosition);
};
var generateTimeDiffText = function(time) {
    var futureTime = moment__WEBPACK_IMPORTED_MODULE_0___default().utc(time);
    var now = moment__WEBPACK_IMPORTED_MODULE_0___default().utc();
    var diffMilliseconds = futureTime.diff(now);
    var duration = moment__WEBPACK_IMPORTED_MODULE_0___default().duration(diffMilliseconds);
    return "".concat(duration.hours(), " Hours ").concat(duration.minutes(), " Minutes");
};


/***/ }),

/***/ 56371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DN": function() { return /* binding */ trackOrderDetailShareSelected; },
/* harmony export */   "J4": function() { return /* binding */ trackShareSelected; },
/* harmony export */   "M1": function() { return /* binding */ trackOrderShareSelected; },
/* harmony export */   "cP": function() { return /* binding */ trackTradeSharedViewed; },
/* harmony export */   "g3": function() { return /* binding */ trackOrderViewed; },
/* harmony export */   "tE": function() { return /* binding */ trackDoneSelected; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56644);
/* harmony import */ var global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2078);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48028);




var _obj;
var orderActionValue = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderAction.Buy */ .iX.Buy, "Buy"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderAction.Sell */ .iX.Sell, "Sell"), _obj);
var _obj1;
var symbolTypeValue = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_0__/* .StockType.Right */ .Z.Right, "Right"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_0__/* .StockType.Waran */ .Z.Waran, "Warrant"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj1, global_Securities_types_stockType__WEBPACK_IMPORTED_MODULE_0__/* .StockType.Saham */ .Z.Saham, "Normal"), _obj1);
var _obj2;
var expiryValue = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj2, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .Expiry.GoodForDay */ .ZM.GoodForDay, "Good for day"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj2, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .Expiry.GoodTillCancelled */ .ZM.GoodTillCancelled, "Good till canceled"), _obj2);
var _obj3;
var statusValue = (_obj3 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Open */ .iF.Open, "Open"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Partial */ .iF.Partial, "Partial"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Match */ .iF.Match, "Match"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Withdrawn */ .iF.Withdrawn, "Withdrawn"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Amended */ .iF.Amended, "Amended"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj3, global_Securities_types_transaction__WEBPACK_IMPORTED_MODULE_1__/* .OrderStatus.Rejected */ .iF.Rejected, "Rejected"), _obj3);
// Views
var trackOrderViewed = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("Share Trade Order Viewed");
};
var trackTradeSharedViewed = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("Trade Shared Viewed");
};
var trackOrderShareSelected = function(type, symbol) {
    var action = orderActionValue[type];
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("".concat(action, " Order Share Selected"), {
        Action: "".concat(action, " Order Share Selected"),
        Symbol: symbol
    });
};
// Actions
var trackOrderDetailShareSelected = function(type, orderId, symbol, symbolType, expiry, rejectReason, status) {
    var action = orderActionValue[type];
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("".concat(action, " Order Detail Share Selected"), {
        Action: "".concat(action, " Order Detail Share Selected"),
        "Order ID": orderId,
        Symbol: symbol,
        "Symbol Type": symbolTypeValue[symbolType] || "Normal",
        Expiry: expiryValue[expiry],
        "Reject Reason": rejectReason,
        Status: statusValue[status]
    });
};
var trackShareSelected = function(symbol, isAddAutoShare) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("Share Trade Action", {
        Action: "Share Selected",
        Symbol: symbol,
        "Add Auto Share": isAddAutoShare
    });
};
var trackDoneSelected = function(symbol) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("Share Trade Action", {
        Action: "Done Selected",
        Symbol: symbol
    });
};


/***/ }),

/***/ 77064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);



var initialState = {
    isVisible: false,
    selectedUsers: {},
    sharedUsers: {},
    orderType: undefined,
    expiry: undefined,
    isDayTrade: false
};
var useShareTradeModal = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        setIsVisible: function(isVisible) {
            set({
                isVisible: isVisible
            });
        },
        setSelectedUsers: function(selectedUsers) {
            set({
                selectedUsers: selectedUsers
            });
        },
        setSharedUsers: function(sharedUsers) {
            set({
                sharedUsers: sharedUsers
            });
        },
        setOrderType: function(orderType) {
            set({
                orderType: orderType
            });
        },
        setExpiry: function(expiry) {
            set({
                expiry: expiry
            });
        },
        setIsDayTrade: function(isDayTrade) {
            set({
                isDayTrade: isDayTrade
            });
        },
        resetShareTradeModal: function() {
            set(initialState);
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useShareTradeModal);


/***/ }),

/***/ 32978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PnLCurrency; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);
/* harmony import */ var utils_number__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62974);




function PnLCurrency(param) {
    var _amount = param.amount, amount = _amount === void 0 ? 0 : _amount, _dataCy = param.dataCy, dataCy = _dataCy === void 0 ? "" : _dataCy, _percentage = param.percentage, percentage = _percentage === void 0 ? null : _percentage, _family = param.family, family = _family === void 0 ? "normal" : _family, _isFillEmptyWithDash = param.isFillEmptyWithDash, isFillEmptyWithDash = _isFillEmptyWithDash === void 0 ? false : _isFillEmptyWithDash, _isColorless = param.isColorless, isColorless = _isColorless === void 0 ? false : _isColorless, _isSignless = param.isSignless, isSignless = _isSignless === void 0 ? false : _isSignless, _isOnlyPercentage = param.isOnlyPercentage, isOnlyPercentage = _isOnlyPercentage === void 0 ? false : _isOnlyPercentage, _isHidePositiveSign = param.isHidePositiveSign, isHidePositiveSign = _isHidePositiveSign === void 0 ? false : _isHidePositiveSign, _isMultiline = param.isMultiline, isMultiline = _isMultiline === void 0 ? false : _isMultiline;
    var isPositive = amount > 0;
    var sign = isPositive ? "+" : "-";
    if (isSignless || isPositive && isHidePositiveSign) {
        sign = "";
    }
    var textColor = isPositive ? _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].primary */ .Z.primary : _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].sunsetOrange */ .Z.sunsetOrange;
    if (isColorless) {
        textColor = "";
    }
    if (amount === 0) {
        sign = "";
        textColor = "";
    }
    if (amount === 0 && isFillEmptyWithDash) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            "data-cy": dataCy,
            family: family,
            children: "-"
        });
    }
    if (isOnlyPercentage) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            "data-cy": dataCy,
            color: textColor,
            family: family,
            children: [
                sign,
                (0,utils_number__WEBPACK_IMPORTED_MODULE_3__/* .formatPercentage */ .rl)(Math.abs(amount), false, "0,0.00", true)
            ]
        });
    }
    var amountDisplayed = "".concat(sign, "Rp").concat((0,utils_number__WEBPACK_IMPORTED_MODULE_3__/* .formatNumber */ .uf)(Math.abs(amount)));
    var percentageDisplayed = "";
    if (percentage !== null) {
        var percentageSign = percentage !== 0 ? sign : "";
        percentageDisplayed = "(".concat(percentageSign).concat((0,utils_number__WEBPACK_IMPORTED_MODULE_3__/* .formatPercentage */ .rl)(Math.abs(percentage), false, "0,0.00", true), ")");
    }
    var displayed = "".concat(amountDisplayed, " ").concat(percentageDisplayed);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isMultiline && displayed.length > 22 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    "data-cy": dataCy,
                    color: textColor,
                    family: family,
                    children: amountDisplayed
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    "data-cy": dataCy,
                    color: textColor,
                    family: family,
                    align: "end",
                    children: percentageDisplayed
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            "data-cy": dataCy,
            color: textColor,
            family: family,
            children: displayed
        })
    });
};


/***/ }),

/***/ 80557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_Collapsible; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/Securities/components/Icons/ChevronDownSvg.tsx
var ChevronDownSvg = __webpack_require__(68861);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/Collapsible/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: ",
        "; /* This will make the content expand upwards */\n  align-items: center;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: none;\n  cursor: pointer;\n  text-align: center;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding-right: 4px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  transition: max-height 0.5s ease-out;\n  max-height: ",
        ";\n  width: 100%;\n  margin-bottom: 4px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 16px;\n  width: 16px;\n\n  transition: all 0.25s ease-in-out;\n\n  transform: ",
        ";\n  transform: ",
        ";\n  transform: ",
        ";\n  transform: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba367647-0"
})(_templateObject(), function(props) {
    return props.direction === "top" ? "column" : "column-reverse";
});
var HeaderContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba367647-1"
})(_templateObject1());
var HeaderContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba367647-2"
})(_templateObject2());
var ContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba367647-3"
})(_templateObject3(), function(props) {
    return props.isOpen ? props.maxHeight : "0";
});
var Chevron = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba367647-4"
})(_templateObject4(), function(p) {
    return p.direction === "top" && "rotate(180deg)";
}, function(p) {
    return p.direction === "right" && "-rotate(90deg)";
}, function(p) {
    return p.direction === "bottom" && "rotate(0deg)";
}, function(p) {
    return p.direction === "left" && "rotate(90deg)";
});

;// CONCATENATED MODULE: ./src/global/Collapsible/index.tsx




function Collapsible(param) {
    var children = param.children, _defaultOpenState = param.defaultOpenState, defaultOpenState = _defaultOpenState === void 0 ? false : _defaultOpenState, _header = param.header, header = _header === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}) : _header, _maxHeight = param.maxHeight, maxHeight = _maxHeight === void 0 ? "300px" : _maxHeight, _expandDirection = param.expandDirection, expandDirection = _expandDirection === void 0 ? "top" : _expandDirection;
    var ref = (0,react.useState)(defaultOpenState), isOpen = ref[0], setIsOpen = ref[1];
    var toggleCollapsible = function() {
        setIsOpen(!isOpen);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        direction: expandDirection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentContainer, {
                isOpen: isOpen,
                maxHeight: maxHeight,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderContainer, {
                onClick: toggleCollapsible,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderContent, {
                        children: header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron, {
                        direction: isOpen ? "top" : "bottom",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownSvg/* default */.Z, {})
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var global_Collapsible = (Collapsible);


/***/ }),

/***/ 65131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useLivePriceReceiver; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49696);
/* harmony import */ var _useLivePrice_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7538);





var useLivePriceReceiver = function(symbols, key, onMessage) {
    var stringSymbols = symbols.join();
    var handleReceiveMessage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(message) {
            var liveprice, formattedLivePrice;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        liveprice = (message || {}).liveprice;
                        if (liveprice && stringSymbols.split(",").includes(liveprice.stockCode)) {
                            formattedLivePrice = (0,_useLivePrice_utils__WEBPACK_IMPORTED_MODULE_3__/* .natsLivePriceFormatter */ .XA)(liveprice);
                            onMessage(formattedLivePrice, liveprice);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(message) {
            return _ref.apply(this, arguments);
        };
    }(), [
        stringSymbols,
        onMessage
    ]);
    // Nats Socket Receiver
    (0,_useDatafeedMessageEffect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("liveprice", "".concat(key, ":").concat(symbols.join()), handleReceiveMessage);
};


/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ }),

/***/ 64924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IE": function() { return /* binding */ getBondPortfolioDetail; },
/* harmony export */   "OF": function() { return /* binding */ postBondSell; },
/* harmony export */   "QY": function() { return /* binding */ getBondSellPreview; },
/* harmony export */   "R0": function() { return /* binding */ getBondOrderList; },
/* harmony export */   "UU": function() { return /* binding */ getBondBuyPreview; },
/* harmony export */   "iC": function() { return /* binding */ getBondOrderDetail; },
/* harmony export */   "yr": function() { return /* binding */ getBondPortfolioList; },
/* harmony export */   "yt": function() { return /* binding */ postBondBuy; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53850);
/* harmony import */ var _instance_trading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96563);




var postBondBuy = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(form) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().post(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.postBuy */ .EN.postBuy, form));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postBondBuy(form) {
        return _ref.apply(this, arguments);
    };
}();
var getBondBuyPreview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getBuyPreview */ .EN.getBuyPreview, {
                        params: params
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondBuyPreview(params) {
        return _ref.apply(this, arguments);
    };
}();
var postBondSell = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(form) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().post(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.postSell */ .EN.postSell, form));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function postBondSell(form) {
        return _ref.apply(this, arguments);
    };
}();
var getBondSellPreview = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(params) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getSellPreview */ .EN.getSellPreview, {
                        params: params
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondSellPreview(params) {
        return _ref.apply(this, arguments);
    };
}();
var getBondOrderList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getOrderList */ .EN.getOrderList));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondOrderList() {
        return _ref.apply(this, arguments);
    };
}();
var getBondOrderDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getOrderDetail */ .EN.getOrderDetail(orderId)));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondOrderDetail(orderId) {
        return _ref.apply(this, arguments);
    };
}();
var getBondPortfolioList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getPortfolioList */ .EN.getPortfolioList));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondPortfolioList() {
        return _ref.apply(this, arguments);
    };
}();
var getBondPortfolioDetail = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(orderId) {
        var withCouponHistories, _args = arguments;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    withCouponHistories = _args.length > 1 && _args[1] !== void 0 ? _args[1] : false;
                    return _ctx.abrupt("return", (0,_instance_trading__WEBPACK_IMPORTED_MODULE_2__/* .getTradingApiInstance */ .j)().get(_constants_apiEndpoint__WEBPACK_IMPORTED_MODULE_1__/* .bondsEndpoints.getPortfolioDetail */ .EN.getPortfolioDetail(orderId), {
                        params: {
                            with_coupon_histories: withCouponHistories ? 1 : 0
                        }
                    }));
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getBondPortfolioDetail(orderId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 96563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ tradingApiInstance; },
/* harmony export */   "j": function() { return /* binding */ getTradingApiInstance; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var config_requestTrading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18364);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83153);
/* harmony import */ var features_securities_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4621);





var _obj;
var tradingApiInstance = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_2__/* .UserTargetAPI.LEGACY */ .FA.LEGACY, (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL */ .Cb, false, false)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_2__/* .UserTargetAPI.NEW_CORE */ .FA.NEW_CORE, (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_TRADING_URL_V2 */ .cu, false, false)), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "general", (0,config_requestTrading__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_SECURITIES_GENERAL_URL */ .kg)), _obj);
var getTradingApiInstance = function() {
    var targetAPI = (0,features_securities_utils__WEBPACK_IMPORTED_MODULE_3__/* .getTargetAPI */ .Ai)();
    return tradingApiInstance[targetAPI];
};


/***/ }),

/***/ 82093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ InfoButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: inline-flex;\n  background: none;\n  border: none;\n  padding: 4px 0;\n  margin: 0;\n\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var InfoButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-3a702b20-0"
})(_templateObject());


/***/ }),

/***/ 68861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var ChevronDownSvg = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.5",
            d: "M4 6l4 4 4-4"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ChevronDownSvg);


/***/ }),

/***/ 94550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var CloseIconSvg = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 12 13",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2",
            d: "M11 1.5l-10 10M1 1.5l10 10"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CloseIconSvg);


/***/ }),

/***/ 42958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var InfoSvg = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        fill: "none",
        viewBox: "0 0 13 13",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "1.2",
            d: "M6.5 11.167a4.667 4.667 0 100-9.334 4.667 4.667 0 000 9.334zM6.5 8.367V6.5M6.5 4.633h.004"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InfoSvg);


/***/ }),

/***/ 48871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modal_BaseSecuritiesModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 19 modules
var modal = __webpack_require__(33070);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/global/Securities/components/Icons/CloseIconSvg.tsx
var CloseIconSvg = __webpack_require__(94550);
;// CONCATENATED MODULE: ./src/global/Securities/components/Modal/BaseSecuritiesModal/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & .ant-modal-content {\n    border-radius: 3px;\n  }\n\n  & .ant-modal-body {\n    padding: 24px 0 0;\n  }\n\n  & .ant-modal-close-x {\n    width: 50px;\n    margin-top: 6px;\n\n    :hover .anticon {\n      color: #b5b5b5;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #c1c1c1;\n  font-size: 10px;\n  transition: 0.3s color linear;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  font-size: 18px;\n  line-height: normal;\n  color: #333333;\n  margin: 0 0 20px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 0;\n  bottom: -16px;\n  transform: translate(0, 100%);\n  width: 100%;\n  height: unset;\n  padding: 12px 20px;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 19px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var Modal = (0,styled_components_browser_esm/* default */.ZP)(modal/* default */.Z).withConfig({
    componentId: "sc-d885cbc0-0"
})(_templateObject());
var CloseIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.Z).attrs({
    component: CloseIconSvg/* default */.Z
}).withConfig({
    componentId: "sc-d885cbc0-1"
})(_templateObject1());
var Title = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-d885cbc0-2"
})(_templateObject2());
var FloatingButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-d885cbc0-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/global/Securities/components/Modal/BaseSecuritiesModal/index.tsx





var BaseSecuritiesModal = function(_param) /*#__PURE__*/ {
    var title = _param.title, submitText = _param.submitText, onSubmit = _param.onSubmit, submitProps = _param.submitProps, hideSubmit = _param.hideSubmit, children = _param.children, _modalWidth = _param.modalWidth, modalWidth = _modalWidth === void 0 ? 500 : _modalWidth, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "submitText",
        "onSubmit",
        "submitProps",
        "hideSubmit",
        "children",
        "modalWidth"
    ]);
    return (0,jsx_runtime.jsxs)(Modal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: modalWidth,
        footer: null,
        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
        centered: true
    }, props), {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: title
            }),
            children,
            !hideSubmit && /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                type: "primary",
                onClick: onSubmit
            }, submitProps), {
                children: submitText
            }))
        ]
    }));
};
/* harmony default export */ var Modal_BaseSecuritiesModal = (BaseSecuritiesModal);


/***/ }),

/***/ 76870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var global_Datafeed_UseLivePrice_useLivePriceSender__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35320);
/* harmony import */ var global_Datafeed_UseLivePrice_useLivePriceReceiver__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65131);
/* harmony import */ var hooks_useTradingAccount__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64999);
/* harmony import */ var global_Datafeed_UseLivePrice_liveprice_store_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27934);





var StateKey = {
    trade_page: global_Datafeed_UseLivePrice_liveprice_store_types__WEBPACK_IMPORTED_MODULE_4__/* .LivePriceSymbolsKeyEnum.TRADE_PAGE */ .j.TRADE_PAGE,
    portfolio_detail: global_Datafeed_UseLivePrice_liveprice_store_types__WEBPACK_IMPORTED_MODULE_4__/* .LivePriceSymbolsKeyEnum.PORTFOLIO_DETAIL */ .j.PORTFOLIO_DETAIL,
    orderlist_detail: global_Datafeed_UseLivePrice_liveprice_store_types__WEBPACK_IMPORTED_MODULE_4__/* .LivePriceSymbolsKeyEnum.ORDERLIST_DETAIL */ .j.ORDERLIST_DETAIL
};
var useLivePriceUpdater = function(config, updateFunction) {
    var isRealTrading = (0,hooks_useTradingAccount__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isRealTrading;
    var symbol = config.symbol, page = config.page;
    var symbols = Array.isArray(symbol) ? symbol : [
        symbol
    ];
    (0,global_Datafeed_UseLivePrice_useLivePriceSender__WEBPACK_IMPORTED_MODULE_1__/* .useLivePriceSender */ .O)(StateKey[page], symbols);
    var livePriceOnMessage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(message) {
        if (!isRealTrading) return;
        var isSymbolMatch = Array.isArray(symbol) ? symbol.includes(message.stockCode) : message.stockCode === symbol;
        if (!isSymbolMatch) return;
        updateFunction(message);
    }, [
        symbol,
        isRealTrading,
        updateFunction
    ]);
    (0,global_Datafeed_UseLivePrice_useLivePriceReceiver__WEBPACK_IMPORTED_MODULE_2__/* .useLivePriceReceiver */ .V)(symbols, page, livePriceOnMessage);
};
/* harmony default export */ __webpack_exports__["Z"] = (useLivePriceUpdater);


/***/ }),

/***/ 56644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ StockType; }
/* harmony export */ });
var StockType;
(function(StockType) {
    StockType["Saham"] = "saham";
    StockType["Right"] = "right";
    StockType["Waran"] = "waran";
    StockType["Index"] = "index";
    StockType["IndexAsing"] = "index_asing";
    StockType["Reksadana"] = "reksadana";
    StockType["Commodities"] = "commodities";
    StockType["Crypto"] = "crypto";
    StockType["Fx"] = "fx";
    StockType["Etf"] = "etf";
    StockType["Bond"] = "bond";
})(StockType || (StockType = {}));


/***/ }),

/***/ 14426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ModalBonds; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/Securities/types/api/bond.ts
var bond = __webpack_require__(73921);
// EXTERNAL MODULE: ./src/global/TradingModal/OrderPlacedModal.tsx + 1 modules
var OrderPlacedModal = __webpack_require__(70536);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/constants/trading.ts
var trading = __webpack_require__(83153);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var _style_color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 14 modules
var es_form = __webpack_require__(98294);
// EXTERNAL MODULE: ./node_modules/antd/lib/form/Form.js
var Form = __webpack_require__(50963);
// EXTERNAL MODULE: ./src/global/TradingModal/styled.ts
var styled = __webpack_require__(76805);
// EXTERNAL MODULE: ./src/features/securities/withdrawal/utils.ts
var utils = __webpack_require__(17921);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/constants.ts
var constants = __webpack_require__(38875);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useCashOnHandStore.ts
var useCashOnHandStore = __webpack_require__(78311);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondsModalStore.ts
var useBondsModalStore = __webpack_require__(81557);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondTransaction.ts
var useBondTransaction = __webpack_require__(55847);
// EXTERNAL MODULE: ./src/hooks/useDebounce.ts
var useDebounce = __webpack_require__(97486);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondPreview.ts
var useBondPreview = __webpack_require__(42427);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/hooks/useBondPreviewForm.ts







var DEBOUNCE_DURATION = 500; // 500ms
function useBondPreviewForm(param) {
    var action = param.action, productId = param.productId, _orderId = param.orderId, orderId = _orderId === void 0 ? "" : _orderId;
    var isBuy = action === bond/* BondTransactionActionEnum.BUY */.qB.BUY;
    var isSell = action === bond/* BondTransactionActionEnum.SELL */.qB.SELL;
    var ref = (0,react.useState)(), unit = ref[0], setUnit = ref[1];
    var ref1 = (0,react.useState)(""), error = ref1[0], setError = ref1[1];
    var debouncedUnit = (0,useDebounce/* default */.Z)(unit, DEBOUNCE_DURATION);
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useBondPreview/* useBondPreviewStore */.d)(function(s) {
        return [
            s.loadBuyPreview,
            s.loadSellPreview,
            s.isLoading,
            s.buy,
            s.sell, 
        ];
    }), 5), loadBuyPreview = ref2[0], loadSellPreview = ref2[1], isLoading = ref2[2], buy = ref2[3], sell = ref2[4];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return [
            s.modalType
        ];
    }), 1), modalType = ref3[0];
    var isDisabled = isLoading || !debouncedUnit || debouncedUnit <= 0;
    var handleUnitAmountChanged = function(e) {
        var value = parseInt(e.target.value, 10);
        // prevent NaN || handle negative value
        if (Number.isNaN(value)) {
            setUnit(undefined);
            return;
        }
        // handle unit more than maximum
        if (isBuy && value >= constants/* MAX_UNIT_AMOUNT */.N2) {
            setUnit(constants/* MAX_UNIT_AMOUNT */.N2);
            return;
        }
        if (isSell && value >= (sell === null || sell === void 0 ? void 0 : sell.available_units)) {
            setUnit(sell === null || sell === void 0 ? void 0 : sell.available_units);
            return;
        }
        setUnit(value);
    };
    var clearError = function() {
        setError("");
    };
    var loadPreview = (0,react.useCallback)(function() {
        // prevent NaN || handle negative value
        if (Number.isNaN(debouncedUnit)) {
            setError("Unit must be an integer");
            return;
        }
        if (debouncedUnit < 0) {
            setError("Unit cannot be a negative number.");
            return;
        }
        if (!productId) {
            setError("Product is required");
            return;
        }
        if (!productId) {
            setError("Product id is required");
            return;
        }
        if (isBuy) {
            loadBuyPreview(productId, unit);
            return;
        }
        if (!orderId) {
            setError("Order id is required");
            return;
        }
        if (isSell) {
            loadSellPreview(productId, orderId, unit);
        }
    }, [
        debouncedUnit,
        isBuy,
        isSell,
        productId,
        orderId
    ]);
    (0,react.useEffect)(function() {
        if (// prevent calling when loading / fetching
        isLoading || // prevent calling if the modalType is not enum
        modalType !== constants/* BondsModalTypeEnum.TRANSACTION */._y.TRANSACTION || // prevent calling if action is unspecified
        action === bond/* BondTransactionActionEnum.UNSPECIFIED */.qB.UNSPECIFIED) {
            // do nothing
            return;
        }
        loadPreview();
    }, [
        debouncedUnit,
        productId,
        modalType,
        action
    ]);
    return {
        preview: {
            buy: buy,
            sell: sell
        },
        handleUnitAmountChanged: handleUnitAmountChanged,
        unit: unit,
        isLoadingPreview: isLoading,
        error: error,
        clearError: clearError,
        isDisabled: isDisabled
    };
};

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/useBondsAnalytics.ts
var useBondsAnalytics = __webpack_require__(29735);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/styled.ts
var ModalBonds_styled = __webpack_require__(70098);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(16165);
// EXTERNAL MODULE: ./src/utils/number.js
var number = __webpack_require__(62974);
// EXTERNAL MODULE: ./src/global/Securities/components/Icons/InfoSvg.tsx
var InfoSvg = __webpack_require__(42958);
// EXTERNAL MODULE: ./src/global/Securities/components/Form/TransactionForm/OrderTypeFormItem/styled.ts
var OrderTypeFormItem_styled = __webpack_require__(82093);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondsBuy/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #f7f7f7;\n  border-radius: 2px;\n  height: 20px;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #ee4a49;\n  border-radius: 4px;\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 6px 20px;\n  border-radius: 4px;\n  background-color: #ebf8f3;\n  outline: none;\n  border: none;\n  color: #00ab6b;\n  font-size: 12px;\n  text-align: center;\n  font-weight: 700;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var FormItemShimmer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a9d64a61-0"
})(_templateObject());
var AlertContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a9d64a61-1"
})(_templateObject1());
var DepositButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-a9d64a61-2"
})(_templateObject2());

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/FormDisplayField.tsx












function FormDisplayField(param) {
    var _label = param.label, label = _label === void 0 ? "-" : _label, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading, _value = param.value, value = _value === void 0 ? 0 : _value, _isBold = param.isBold, isBold = _isBold === void 0 ? false : _isBold, _type = param.type, type = _type === void 0 ? "default" : _type, _isNeedInfo = param.isNeedInfo, isNeedInfo = _isNeedInfo === void 0 ? false : _isNeedInfo, _onInfoClick = param.onInfoClick, onInfoClick = _onInfoClick === void 0 ? function() {} : _onInfoClick, _isShowSign = param.isShowSign, isShowSign = _isShowSign === void 0 ? false : _isShowSign, _isDisabled = param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled, _subtitle = param.subtitle, subtitle = _subtitle === void 0 ? "" : _subtitle, _defaultColor = param.defaultColor, defaultColor = _defaultColor === void 0 ? "#333333" : _defaultColor, _plPercentage = param.plPercentage, plPercentage = _plPercentage === void 0 ? undefined : _plPercentage;
    var color = defaultColor;
    var sign = "";
    if (type === "pl") {
        color = value >= 0 ? _style_color/* default.primary */.Z.primary : _style_color/* default.sunsetOrange */.Z.sunsetOrange;
    }
    if (isShowSign || type === "pl") {
        sign = value > 0 && value !== 0 ? "+" : "-";
    }
    var handleInfoClick = function(e) {
        e.stopPropagation();
        e.preventDefault();
        onInfoClick();
    };
    var composed = "".concat(sign, "Rp").concat((0,number/* formatNumber */.uf)(Math.abs(value), true, "0,0.00")) + " (".concat(sign).concat((0,number/* formatNumber */.uf)(Math.abs(plPercentage), true, "0,0.00", true), "%)");
    var isMultiline = composed.length >= 22;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* FormItem */.xJ, {
        disabled: isDisabled,
        label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: isNeedInfo,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTypeFormItem_styled/* InfoButton */.R, {
                                type: "button",
                                onClick: handleInfoClick,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    component: InfoSvg/* default */.Z,
                                    style: {
                                        fontSize: 16,
                                        color: "#969696",
                                        marginLeft: 4
                                    }
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: subtitle,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        size: "12px",
                        color: "#B5B5B5",
                        align: "right",
                        children: subtitle
                    })
                })
            ]
        }),
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItemShimmer, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: type === "pl" && isMultiline,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        direction: "column",
                        align: "start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: color,
                                family: isBold ? "bold" : "normal",
                                children: (0,utils/* formatBondCurrency */.uJ)(value, "exceptZero")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: plPercentage !== undefined,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    color: color,
                                    family: isBold ? "bold" : "normal",
                                    align: "end",
                                    children: [
                                        " ",
                                        "(",
                                        (0,utils/* formatPricePercentage */.iM)(plPercentage, "exceptZero"),
                                        ")"
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: type === "pl" && !isMultiline,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        color: color,
                        family: isBold ? "bold" : "normal",
                        children: [
                            (0,utils/* formatBondCurrency */.uJ)(value, "exceptZero"),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                                condition: plPercentage !== undefined,
                                children: [
                                    " ",
                                    "(",
                                    (0,utils/* formatPricePercentage */.iM)(plPercentage, "exceptZero"),
                                    ")"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                    condition: type !== "pl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        family: isBold ? "bold" : "normal",
                        color: color,
                        size: "14px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: type === "currency",
                                children: (0,utils/* formatBondCurrency */.uJ)(value, isShowSign ? "exceptZero" : "never")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: type === "percentage",
                                children: (0,utils/* formatPricePercentage */.iM)(value, isShowSign ? "exceptZero" : "never")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                                condition: type === "number",
                                children: [
                                    isShowSign ? sign : "",
                                    (0,number/* formatNumber */.uf)(value, true, "0,0.00")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                                condition: type === "unit",
                                children: [
                                    value,
                                    " Unit"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: type === "default",
                                children: value
                            })
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/TradingModal/components/SearchCompany/index.tsx + 1 modules
var SearchCompany = __webpack_require__(77017);
// EXTERNAL MODULE: ./src/global/TradingModal/store.ts
var store = __webpack_require__(70362);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalProductDisplay.tsx

















function ModalProductDisplay(param) {
    var _isSearchEnabled = param.isSearchEnabled, isSearchEnabled = _isSearchEnabled === void 0 ? false : _isSearchEnabled, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? false : _isLoading;
    var stockInputRef = (0,react.useRef)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return [
            s.toggleSearch,
            s.isSearchActive,
            s.closeTransactionModal, 
        ];
    }), 3), toggleSearch = ref[0], isSearchActive = ref[1], closeTransactionModal = ref[2];
    var field = (0,useBondPreview/* useBondPreviewStore */.d)(function(s) {
        return {
            field: s.product
        };
    }).field;
    var initiateBuy = (0,useBondTransaction/* useBondTransaction */.P)(function(s) {
        return {
            initiateBuy: s.initiateBuyTransaction
        };
    }).initiateBuy;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,store/* default */.Z)(function(s) {
        return [
            s.showModal
        ];
    }), 1), showTradingModal = ref1[0];
    var handleUpdateSymbol = function(newSymbol, isBonds) {
        if (!isBonds) {
            showTradingModal({
                symbol: newSymbol,
                orderType: "BUY"
            });
        }
        if (isBonds) {
            initiateBuy(newSymbol);
        }
        if (isSearchActive) {
            toggleSearch();
        }
        closeTransactionModal();
    };
    (0,react.useEffect)(function() {
        if (isSearchActive) {
            var ref;
            (ref = stockInputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
    }, [
        isSearchActive
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* FormHeader */.ph, {
        style: {
            paddingTop: 0
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justify: "space-between",
                width: "100%",
                style: {
                    display: isSearchActive ? "none" : "flex"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    align: "flex-start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: (field === null || field === void 0 ? void 0 : field.icon_url) || constants/* FALLBACK_AVATAR_SRC */.sW,
                            style: {
                                width: "40px",
                                height: "40px",
                                background: "white"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            direction: "column",
                            pl: "15px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                    align: "center",
                                    width: "200px",
                                    children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* TextLoadingShimmer */.pT, {
                                        width: "80px",
                                        height: "16px"
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        family: "bold",
                                        size: "16px",
                                        children: field === null || field === void 0 ? void 0 : field.id
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    mt: "3px",
                                    children: [
                                        isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* TextLoadingShimmer */.pT, {
                                            width: "160px",
                                            height: "16px"
                                        }) : // @ts-expect-error
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            size: "14px",
                                            color: _style_color/* default.midgray */.Z.midgray,
                                            mr: "5px",
                                            children: field === null || field === void 0 ? void 0 : field.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                            condition: isSearchEnabled,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                                className: "icon-tradesmall_pencil2",
                                                size: "14px",
                                                hoverColor: _style_color/* default.highgray */.Z.highgray,
                                                // @ts-expect-error
                                                onClick: toggleSearch
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isSearchEnabled && isSearchActive,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    width: "100%",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCompany/* default */.Z, {
                        ref: stockInputRef,
                        isInTradingModal: true,
                        updateSymbol: handleUpdateSymbol
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalTitle.tsx






function ModalTitle(param) {
    var title = param.title, _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? "24px" : _fontSize, _color = param.color, color = _color === void 0 ? "#333333" : _color, _isCentered = param.isCentered, isCentered = _isCentered === void 0 ? false : _isCentered, onClose = param.onClose;
    var modalType = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return s.modalType;
    });
    var align = modalType === constants/* BondsModalTypeEnum.TRANSACTION */._y.TRANSACTION || modalType === constants/* BondsModalTypeEnum.ORDER */._y.ORDER || modalType === constants/* BondsModalTypeEnum.CONFIRMATION */._y.CONFIRMATION || isCentered ? "center" : "start";
    return(// @ts-expect-error
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        justify: "between",
        align: "center",
        w: "100%",
        height: "50px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                color: color,
                size: fontSize,
                align: align,
                // @ts-expect-error
                mt: "0",
                width: "100%",
                "data-cy": "bonds-modal-header",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                className: "icon-trading_x",
                color: "#333333",
                size: "12px",
                onClick: onClose
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/global/Securities/components/Icons/ChevronDownSvg.tsx
var ChevronDownSvg = __webpack_require__(68861);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/Accordion/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 16px;\n  width: 16px;\n\n  transition: all 0.25s ease-in-out;\n\n  transform: ",
        ";\n  transform: ",
        ";\n  transform: ",
        ";\n  transform: ",
        ";\n\n  position: absolute;\n  right: ",
        ";\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & + & {\n    /* margin-top: -0.125rem; */\n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  border-top: ",
        ";\n\n  margin-top: ",
        ";\n\n  .ant-row.ant-form-item {\n    width: 100%;\n  }\n\n  .ant-row.ant-form-item {\n    height: 32px;\n    margin-bottom: 0;\n  }\n  position: relative;\n  padding-top: ",
        ";\n  padding-top: ",
        ";\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: rgba(0, 0, 0, 0.75);\n  line-height: 1.5;\n\n  .ant-form-item {\n  }\n\n  .ant-row.ant-form-item {\n    height: 24px;\n  }\n\n  .ant-row.ant-form-item:last-child {\n    margin-bottom: 8px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: ",
        ";\n  max-height: ",
        ";\n  transition: max-height 0.25s ease-in-out;\n  padding-top: ",
        ";\n  overflow: hidden;\n\n  padding-top: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var Chevron = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5df286b1-0"
})(styled_templateObject(), function(p) {
    return p.direction === "top" && "rotate(180deg)";
}, function(p) {
    return p.direction === "right" && "-rotate(90deg)";
}, function(p) {
    return p.direction === "bottom" && "rotate(0deg)";
}, function(p) {
    return p.direction === "left" && "rotate(90deg)";
}, function(p) {
    return p.isTight ? "0px" : "24px";
});
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5df286b1-1"
})(styled_templateObject1());
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5df286b1-2"
})(styled_templateObject2(), function(p) {
    return !p.isExpanded && !p.isPlain ? "1px solid gainsboro" : "none";
}, function(p) {
    return p.isExpanded ? "12px" : "0px";
}, function(p) {
    return p.isExpanded ? "0px" : "20px";
}, function(p) {
    return p.isTight && !p.isExpanded && "0px";
});
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5df286b1-3"
})(_templateObject3());
var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5df286b1-4"
})(_templateObject4(), function(p) {
    return p.isExpanded && !p.isPlain ? "1px solid gainsboro" : "none";
}, function(p) {
    return "".concat(p.maxHeight, "px");
}, function(p) {
    return p.isExpanded ? "20px" : "0px";
}, function(p) {
    return p.isTight ? "0px" : "20px";
});

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/Accordion/index.tsx




function Accordion(param) {
    var children = param.children, title = param.title, _isPlain = param.isPlain, isPlain = _isPlain === void 0 ? false : _isPlain, _isTight = param.isTight, isTight = _isTight === void 0 ? false : _isTight;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setExpand = ref[1];
    var contentRef = (0,react.useRef)();
    var contentHeight = isExpanded ? contentRef.current.scrollHeight + 400 : 0;
    var handleExpandToggle = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        setExpand(!isExpanded);
    }, [
        isExpanded
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper, {
                maxHeight: contentHeight,
                isExpanded: isExpanded,
                isPlain: isPlain,
                isTight: isTight,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                    ref: contentRef,
                    children: children
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title, {
                onClick: handleExpandToggle,
                isExpanded: isExpanded,
                isPlain: isPlain,
                isTight: isTight,
                children: [
                    title,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Chevron, {
                        direction: isExpanded ? "top" : "bottom",
                        isTight: isTight,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownSvg/* default */.Z, {})
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondsBuy/component/DepositAlert.tsx






function DepositAlert() {
    var router = (0,next_router.useRouter)();
    var closeTransactionModal = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return s.closeTransactionModal;
    });
    var onDepositClick = function() {
        closeTransactionModal();
        router.push("/securities/deposit");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AlertContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        family: "bold",
                        mb: "2px",
                        children: "Deposit Sekarang"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: _style_color/* default.sunsetOrange */.Z.sunsetOrange,
                        children: "Saldo kamu tidak mencukupi"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DepositButton, {
                onClick: onDepositClick,
                children: "Deposit"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondInfoModal.ts
var useBondInfoModal = __webpack_require__(32471);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondsBuy/index.tsx
























function ModalBondsBuy() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = (0,_sliced_to_array/* default */.Z)((0,Form/* useForm */.cI)(), 1), form = ref10[0];
    var productId = (0,useBondTransaction/* useBondTransaction */.P)(function(s) {
        return s.productId;
    });
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return [
            s.transactionType,
            s.openConfirmModal,
            s.isSearchActive,
            s.toggleSearch,
            s.closeTransactionModal,
            s.sourcePage, 
        ];
    }), 6), transactionType = ref11[0], openConfirmModal = ref11[1], isSearchActive = ref11[2], toggleSearch = ref11[3], closeTransactionModal = ref11[4], sourcePage = ref11[5];
    var openInfoModal = (0,useBondInfoModal/* useBondInfoModal */.e)(function(s) {
        return s.openInfoModal;
    });
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,useCashOnHandStore/* useCashOnHandStore */.I)(function(s) {
        return [
            s.cashOnHand,
            s.isLoading, 
        ];
    }), 2), cashOnHand = ref12[0], isLoadingCash = ref12[1];
    var ref13 = useBondPreviewForm({
        action: bond/* BondTransactionActionEnum.BUY */.qB.BUY,
        productId: productId
    }), handleUnitAmountChanged = ref13.handleUnitAmountChanged, preview = ref13.preview, unit = ref13.unit, isLoadingPreview = ref13.isLoadingPreview, previewDisabled = ref13.isDisabled;
    var ref14 = (0,useBondsAnalytics/* default */.Z)(), FRBondsNavigateTrackers = ref14.FRBondsNavigateTrackers, FRBondActionTrackers = ref14.FRBondActionTrackers;
    var _transactionType = constants/* BOND_TRANSACTION_CONFIG */.H1[transactionType], textColor = _transactionType.textColor, title = _transactionType.title;
    var isExceedAmount = (preview === null || preview === void 0 ? void 0 : (ref = preview.buy) === null || ref === void 0 ? void 0 : ref.total_amount) > cashOnHand;
    var isDisabled = isLoadingCash || previewDisabled || isExceedAmount || isSearchActive;
    var handleSubmit = function() {
        FRBondActionTrackers.onOrderPlaced("Buy", productId);
        openConfirmModal();
    };
    (0,react.useEffect)(function() {
        if (productId) {
            FRBondsNavigateTrackers.onBondOrderPageViewed("Buy", productId, sourcePage);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default */.Z, {
        form: form,
        onFinish: handleSubmit,
        colon: false,
        labelCol: {
            span: 10
        },
        wrapperCol: {
            span: 8,
            offset: 2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalContainer */.F0, {
                modalType: constants/* BondsModalTypeEnum.TRANSACTION */._y.TRANSACTION,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: isSearchActive,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* FreezeLayer */.VV, {
                            onClick: function() {
                                return toggleSearch(false);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalHeader */.xB, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitle, {
                                color: textColor,
                                title: title,
                                onClose: closeTransactionModal
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalProductDisplay, {
                                isSearchEnabled: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalBody */.fe, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: isExceedAmount,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DepositAlert, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                label: "Cash On Hand",
                                isLoading: isLoadingCash,
                                value: Math.round(cashOnHand),
                                type: "currency",
                                isNeedInfo: true,
                                isBold: true,
                                onInfoClick: function() {
                                    return openInfoModal(constants/* BondInfoType.CASH_ON_HAND */.Im.CASH_ON_HAND);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: "Unit Pembelian",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* UnitInput */.OT, {
                                    value: unit,
                                    onChange: handleUnitAmountChanged,
                                    placeholder: "1 Unit = ".concat((0,utils/* formatCurrency */.xG)(constants/* BASE_UNIT_AMOUNT.toString */.MD.toString())),
                                    type: "number"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                label: "Harga Beli (%)",
                                value: preview === null || preview === void 0 ? void 0 : (ref1 = preview.buy) === null || ref1 === void 0 ? void 0 : ref1.price_rate,
                                type: "percentage",
                                onInfoClick: function() {
                                    return openInfoModal(constants/* BondInfoType.BUYING_PRICE */.Im.BUYING_PRICE);
                                },
                                isNeedInfo: true,
                                isDisabled: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                    label: "Total Pembayaran",
                                    isLoading: isLoadingPreview,
                                    value: preview === null || preview === void 0 ? void 0 : (ref2 = preview.buy) === null || ref2 === void 0 ? void 0 : ref2.total_amount,
                                    isBold: true,
                                    type: "currency",
                                    defaultColor: isExceedAmount ? _style_color/* default.sunsetOrange */.Z.sunsetOrange : "#333333"
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Nilai Pembelian",
                                        isLoading: isLoadingPreview,
                                        value: preview === null || preview === void 0 ? void 0 : (ref3 = preview.buy) === null || ref3 === void 0 ? void 0 : ref3.buy_price_amount,
                                        type: "currency"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Kupon Penjual",
                                        isLoading: isLoadingPreview,
                                        value: preview === null || preview === void 0 ? void 0 : (ref4 = preview.buy) === null || ref4 === void 0 ? void 0 : ref4.accrued_interest,
                                        type: "currency",
                                        isNeedInfo: true,
                                        onInfoClick: function() {
                                            return openInfoModal(constants/* BondInfoType.ACCRUED_INTEREST_SELLER */.Im.ACCRUED_INTEREST_SELLER);
                                        },
                                        isShowSign: (preview === null || preview === void 0 ? void 0 : (ref5 = preview.buy) === null || ref5 === void 0 ? void 0 : ref5.accrued_interest) > 0
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Bea Meterai",
                                        isLoading: isLoadingPreview,
                                        value: preview === null || preview === void 0 ? void 0 : (ref6 = preview.buy) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.fee) === null || ref7 === void 0 ? void 0 : ref7.stamp_duty,
                                        type: "currency",
                                        isShowSign: (preview === null || preview === void 0 ? void 0 : (ref8 = preview.buy) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.fee) === null || ref9 === void 0 ? void 0 : ref9.stamp_duty) > 0
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalFooter */.mz, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* OrderButton */.sg, {
                    disabled: isDisabled,
                    type: "primary",
                    htmlType: "submit",
                    block: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: "Place Order"
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondBlockers/styled.ts

function ModalBondBlockers_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  justify-content: start;\n  align-items: center;\n  text-align: center;\n\n  max-width: 355px;\n  max-height: 256px;\n"
    ]);
    ModalBondBlockers_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalBondBlockers_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 135px;\n  width: 100%;\n"
    ]);
    ModalBondBlockers_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalBondBlockers_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 24.3px;\n  padding: 0px 40px;\n  margin: 0px;\n"
    ]);
    ModalBondBlockers_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var ContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-718dac81-0"
})(ModalBondBlockers_styled_templateObject());
var Logo = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({
    componentId: "sc-718dac81-1"
})(ModalBondBlockers_styled_templateObject1());
var Heading = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-718dac81-2"
})(ModalBondBlockers_styled_templateObject2());

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondBlockers/constants.ts


var _obj;
var BOND_BLOCKER_CONFIG = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* BondBlockerType.UNSPECIFIED */.Ew.UNSPECIFIED, {
    title: "",
    textColor: "",
    content: [],
    iconSrc: ""
}), (0,_define_property/* default */.Z)(_obj, constants/* BondBlockerType.MAINTENANCE */.Ew.MAINTENANCE, {
    title: "Maintenance Sedang Berlangsung",
    textColor: "",
    content: [],
    iconSrc: "icon/fr/fr-blocker-maintenance.svg"
}), (0,_define_property/* default */.Z)(_obj, constants/* BondBlockerType.MARKET_CLOSE */.Ew.MARKET_CLOSE, {
    title: "Market Sedang Tutup",
    textColor: "#333333",
    content: [],
    iconSrc: "icon/fr/fr-blocker-market-close.svg"
}), (0,_define_property/* default */.Z)(_obj, constants/* BondBlockerType.PRICE_CHANGED */.Ew.PRICE_CHANGED, {
    title: "Terjadi Perubhan Harga",
    textColor: "",
    content: [],
    iconSrc: "icon/fr/fr-blocker-price-changed.svg"
}), (0,_define_property/* default */.Z)(_obj, constants/* BondBlockerType.TEMPORARY_UNAVAILABLE */.Ew.TEMPORARY_UNAVAILABLE, {
    title: "Sedang Tidak Tersedia",
    textColor: "",
    content: [],
    iconSrc: "icon/fr/fr-blocker-temporary-unavailable.svg"
}), (0,_define_property/* default */.Z)(_obj, constants/* BondBlockerType.UNAVAILABLE */.Ew.UNAVAILABLE, {
    title: "Sementara Tidak Dapat Dibeli",
    textColor: "",
    content: [],
    iconSrc: "icon/fr/fr-blocker-unavailable.svg"
}), (0,_define_property/* default */.Z)(_obj, constants/* BondBlockerType.SHARIA_VALIDATION */.Ew.SHARIA_VALIDATION, {
    title: "Bukan FR Syariah",
    textColor: "",
    content: [],
    iconSrc: "icon/fr/fr-blocker-sharia.svg"
}), (0,_define_property/* default */.Z)(_obj, constants/* BondBlockerType.STABLE_EARN */.Ew.STABLE_EARN, {
    title: "Produk Teridentifikasi Sebagai Stable Earn",
    textColor: "",
    content: [],
    iconSrc: "icon/fr/fr-blocker-stable-earn.svg"
}), (0,_define_property/* default */.Z)(_obj, constants/* BondBlockerType.GENERAL_ERROR */.Ew.GENERAL_ERROR, {
    title: "Unable to Load Data",
    textColor: "",
    content: [],
    iconSrc: "icon/fr/fr-blocker-general-error.svg"
}), _obj);

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondBlockers/index.tsx

function ModalBondBlockers_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                width: 200px;\n              "
    ]);
    ModalBondBlockers_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















function ModalBondBlockers(param) {
    var onClose = param.onClose;
    var router = (0,next_router.useRouter)();
    var productId = (0,useBondTransaction/* useBondTransaction */.P)(function(s) {
        return s.productId;
    });
    var blockerType = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return {
            blockerType: s.blockerType
        };
    }).blockerType;
    var _blockerType = BOND_BLOCKER_CONFIG[blockerType], iconSrc = _blockerType.iconSrc, title = _blockerType.title;
    var handleGotoSector = function() {
        router.push("/catalog/fr-bonds/");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalContainer */.F0, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalHeader */.xB, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justify: "space-between",
                    align: "start",
                    w: "100%",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                            alt: "".concat(title, " illustration"),
                            src: iconSrc
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                            className: "icon-trading_x",
                            color: "#333333",
                            size: "12px",
                            onClick: onClose
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalBody */.fe, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                            condition: blockerType === constants/* BondBlockerType.MAINTENANCE */.Ew.MAINTENANCE,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                    children: "Maintenance Sedang Berlangsung"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    align: "center",
                                    children: "Transaksi Obligasi Pasar Sekunder tidak bisa dilakukan untuk sementara. Silahkan coba lagi nanti."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                            condition: blockerType === constants/* BondBlockerType.PRICE_CHANGED */.Ew.PRICE_CHANGED,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                    children: "Terjadi Perubahan Harga"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    align: "center",
                                    children: "Harga telah berubah mengikuti harga pasar saat ini"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: blockerType === constants/* BondBlockerType.STABLE_EARN */.Ew.STABLE_EARN,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                children: "Stable Earn Hanya Dapat Dijual Melalui Aplikasi Bibit"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                            condition: blockerType === constants/* BondBlockerType.MARKET_CLOSE */.Ew.MARKET_CLOSE,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                    children: "Market Sedang Tutup"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    direction: "column",
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            children: "Market akan buka kembali dalam"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: _style_color/* default.primary */.Z.primary,
                                            children: "15-20 menit."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                            condition: blockerType === constants/* BondBlockerType.TEMPORARY_UNAVAILABLE */.Ew.TEMPORARY_UNAVAILABLE,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading, {
                                    children: [
                                        productId,
                                        " Sedang Tidak Tersedia"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    align: "center",
                                    children: [
                                        "Saat ini sedang dilakukan proses pencatatan untuk pembagian kupon obligasi ",
                                        productId,
                                        ". Transaksi ",
                                        productId,
                                        " dapat dilakukan kembali dalam",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            as: "span",
                                            color: _style_color/* default.primary */.Z.primary,
                                            children: "1 - 2 hari bursa"
                                        }),
                                        "."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                            condition: blockerType === constants/* BondBlockerType.UNAVAILABLE */.Ew.UNAVAILABLE,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                    children: "Sementara Tidak Dapat Dibeli"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Silahkan coba produk Obligasi FR lainnya."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                    type: "primary",
                                    onClick: handleGotoSector,
                                    block: true,
                                    children: "Lihat Produk Obligasi FR"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                            condition: blockerType === constants/* BondBlockerType.SHARIA_VALIDATION */.Ew.SHARIA_VALIDATION,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                    children: "Bukan FR Syariah"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    children: [
                                        "Kamu tidak bisa bertransaksi FR non-syariah.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                            children: "(Fatwa No.80/DSN-MUI/III/2011)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(_StyledButton, {
                                    type: "primary",
                                    onClick: onClose,
                                    block: true,
                                    children: "Oke"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var _StyledButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-7874dc41-0"
})(ModalBondBlockers_templateObject());

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/styled.ts
var RealTradingModal_styled = __webpack_require__(61227);
// EXTERNAL MODULE: ./src/features/trade/components/Portfolio/PnLCurrency.tsx
var PnLCurrency = __webpack_require__(32978);
// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js
var divider = __webpack_require__(27049);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondConfirm/styled.ts

function ModalBondConfirm_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n"
    ]);
    ModalBondConfirm_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalBondConfirm_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #ededed;\n  border-radius: 4px;\n  padding: 16px 20px;\n  margin: 16px 20px;\n  gap: 16px;\n  width: 335px;\n"
    ]);
    ModalBondConfirm_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalBondConfirm_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0px;\n  padding-bottom: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    ModalBondConfirm_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  :disabled {\n    background: #616161 !important;\n    color: #cbcbcb;\n    border: none;\n  }\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3dcfbbbb-0"
})(ModalBondConfirm_styled_templateObject());
var BorderedWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3dcfbbbb-1"
})(ModalBondConfirm_styled_templateObject1());
var Section = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-3dcfbbbb-2"
})(ModalBondConfirm_styled_templateObject2());
var ConfirmButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-3dcfbbbb-3"
})(styled_templateObject3());

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondConfirm/components/ContentBuy.tsx

function ContentBuy_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          margin: 0px;\n          margin-bottom: 12px;\n          border-color: #dadada;\n        "
    ]);
    ContentBuy_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













function ContentBuy() {
    var ref;
    var field = (0,useBondPreview/* useBondPreviewStore */.d)(function(s) {
        return s.buy;
    });
    var openInfoModal = (0,useBondInfoModal/* useBondInfoModal */.e)(function(s) {
        return s.openInfoModal;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justify: "space-between",
                        align: "center",
                        height: "20px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: "Unit Pembelian"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: field === null || field === void 0 ? void 0 : field.unit
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justify: "space-between",
                        align: "center",
                        height: "20px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: "Harga Beli (%)"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: (0,number/* formatPercentage */.rl)(field === null || field === void 0 ? void 0 : field.price_rate, true, "0,0.00")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_StyledDivider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justify: "space-between",
                        align: "center",
                        height: "20px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: "Nilai Pembelian"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: (0,utils/* formatBondCurrency */.uJ)(field === null || field === void 0 ? void 0 : field.buy_price_amount)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justify: "space-between",
                        align: "center",
                        height: "20px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                align: "center",
                                style: {
                                    gap: 2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Kupon Penjual"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            component: InfoSvg/* default */.Z,
                                            style: {
                                                color: "#969696"
                                            },
                                            onClick: function() {
                                                return openInfoModal(constants/* BondInfoType.ACCRUED_INTEREST_SELLER */.Im.ACCRUED_INTEREST_SELLER);
                                            }
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: (0,utils/* formatBondCurrency */.uJ)(field === null || field === void 0 ? void 0 : field.accrued_interest, "exceptZero")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justify: "space-between",
                        align: "center",
                        height: "20px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: "Bea Meterai"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: (0,utils/* formatBondCurrency */.uJ)(field === null || field === void 0 ? void 0 : (ref = field.fee) === null || ref === void 0 ? void 0 : ref.stamp_duty, "exceptZero")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justify: "space-between",
                        align: "center",
                        height: "20px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                family: "bold",
                                children: "Total Pembayaran"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                family: "bold",
                                children: (0,utils/* formatBondCurrency */.uJ)(field === null || field === void 0 ? void 0 : field.total_amount)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var _StyledDivider = (0,styled_components_browser_esm/* default */.ZP)(divider/* default */.Z).withConfig({
    componentId: "sc-2ac88232-0"
})(ContentBuy_templateObject());

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondConfirm/components/ContentSell.tsx











function ContentSell() {
    var ref, ref1;
    var field = (0,useBondPreview/* useBondPreviewStore */.d)(function(s) {
        return s.sell;
    });
    var openInfoModal = (0,useBondInfoModal/* useBondInfoModal */.e)(function(s) {
        return s.openInfoModal;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justify: "space-between",
                    align: "center",
                    height: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: "Unit Penjualan"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: field === null || field === void 0 ? void 0 : field.units
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justify: "space-between",
                    align: "center",
                    height: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: "Harga Jual (%)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: (0,number/* formatPercentage */.rl)(field === null || field === void 0 ? void 0 : field.price.sell, false, "0,0.00")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justify: "space-between",
                    align: "center",
                    height: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: "Nilai Penjualan"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: (0,utils/* formatBondCurrency */.uJ)(field === null || field === void 0 ? void 0 : field.estimation_sell_amount)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justify: "space-between",
                    align: "center",
                    height: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: "Kupon Berjalan (Nett)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: (0,utils/* formatBondCurrency */.uJ)(field === null || field === void 0 ? void 0 : field.accrued_interest_exclude_tax, "exceptZero")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justify: "space-between",
                    align: "center",
                    height: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: "Pajak"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: (0,utils/* formatBondCurrency */.uJ)((field === null || field === void 0 ? void 0 : (ref = field.fee) === null || ref === void 0 ? void 0 : ref.total_tax) * -1, "exceptZero")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justify: "space-between",
                    align: "center",
                    height: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: "Bea Meterai"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: (0,utils/* formatBondCurrency */.uJ)((field === null || field === void 0 ? void 0 : (ref1 = field.fee) === null || ref1 === void 0 ? void 0 : ref1.stamp_duty) * -1, "exceptZero")
                        })
                    ]
                }),
                (field === null || field === void 0 ? void 0 : field.seller_coupon) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justify: "space-between",
                    align: "center",
                    height: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            align: "center",
                            style: {
                                gap: 2
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Kupon Penjual"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        component: InfoSvg/* default */.Z,
                                        style: {
                                            color: "#969696"
                                        },
                                        onClick: function() {
                                            return openInfoModal(constants/* BondInfoType.ACCRUED_INTEREST_SELLER */.Im.ACCRUED_INTEREST_SELLER);
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: (0,utils/* formatBondCurrency */.uJ)(field === null || field === void 0 ? void 0 : field.seller_coupon, "exceptZero")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justify: "space-between",
                    align: "center",
                    height: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            family: "bold",
                            children: "Total Nilai Penjualan"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            family: "bold",
                            children: (0,utils/* formatBondCurrency */.uJ)(field === null || field === void 0 ? void 0 : field.amount)
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondConfirm/index.tsx

function ModalBondConfirm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n              padding-bottom: 0px;\n            "
    ]);
    ModalBondConfirm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalBondConfirm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  margin: 12px 0px;\n                "
    ]);
    ModalBondConfirm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






















function ModalBondConfirm() {
    var ref = (0,useBondsAnalytics/* default */.Z)(), FRBondActionTrackers = ref.FRBondActionTrackers, FRBondsNavigateTrackers = ref.FRBondsNavigateTrackers;
    var ref1 = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return {
            closeModal: s.closeModal,
            openTncModal: s.openTncModal,
            clearModal: s.clear,
            openOrderPlacedModal: s.openOrderPlacedModal,
            sourcePage: s.sourcePage
        };
    }), closeModal = ref1.closeModal, openTncModal = ref1.openTncModal, openOrderPlacedModal = ref1.openOrderPlacedModal, sourcePage = ref1.sourcePage;
    var ref2 = (0,useBondTransaction/* useBondTransaction */.P)(function(s) {
        return {
            type: s.transactionType,
            isTnCAccepted: s.isTnCAccepted,
            setTnC: s.setTnC,
            submitOrder: s.submitOrder,
            isSubmitSuccess: s.isSuccess,
            productId: s.productId
        };
    }), type = ref2.type, isTnCAccepted = ref2.isTnCAccepted, setTnC = ref2.setTnC, submitOrder = ref2.submitOrder, isSubmitSuccess = ref2.isSubmitSuccess, productId = ref2.productId;
    var ref3 = (0,useBondPreview/* useBondPreviewStore */.d)(function(s) {
        return {
            clearPreview: s.clear,
            sell: s.sell
        };
    }), clearPreview = ref3.clearPreview, sell = ref3.sell;
    var title = type === bond/* BondTransactionActionEnum.BUY */.qB.BUY ? "Buy ".concat(productId) : "Sell ".concat(productId);
    var handleCheckboxChange = function(event) {
        if (event.target.checked) {
            FRBondActionTrackers.onTnCConfirmed();
        }
        setTnC(event.target.checked);
    };
    var handleSubmitOrder = function() {
        submitOrder();
        FRBondActionTrackers.onOrderConfirmed(type === bond/* BondTransactionActionEnum.BUY */.qB.BUY ? "Buy" : "Sell", productId, sourcePage);
    };
    (0,react.useEffect)(function() {
        // If success, then redirect to the portfolio
        if (isSubmitSuccess) {
            clearPreview(); // clear buy/sell preview data
            // clearModal(); // clear modal state
            openOrderPlacedModal();
            FRBondsNavigateTrackers.onBondOrderSuccessViewed(type === bond/* BondTransactionActionEnum.BUY */.qB.BUY ? "Buy" : "Sell", productId, sourcePage);
        }
    }, [
        isSubmitSuccess
    ]);
    (0,react.useEffect)(function() {
        FRBondsNavigateTrackers.onBondPreviewOrderViewed(type === bond/* BondTransactionActionEnum.BUY */.qB.BUY ? "Buy" : "Sell", productId, sourcePage);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalContainer */.F0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalHeader */.xB, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitle, {
                            title: title,
                            color: "#333333",
                            onClose: closeModal
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalBody */.fe, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(_StyledBorderedWrapper, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalProductDisplay, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: type === bond/* BondTransactionActionEnum.BUY */.qB.BUY,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBuy, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: type === bond/* BondTransactionActionEnum.SELL */.qB.SELL,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentSell, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                condition: type === bond/* BondTransactionActionEnum.SELL */.qB.SELL,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BorderedWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            align: "center",
                                            justify: "space-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        family: "bold",
                                                        size: "14px",
                                                        children: "P&L (Nett)"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                                    amount: sell === null || sell === void 0 ? void 0 : sell.profit_loss_nett,
                                                    percentage: sell === null || sell === void 0 ? void 0 : sell.profit_loss_nett_percentage,
                                                    family: "bold"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondConfirm_StyledDivider, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                            align: "center",
                                            justify: "space-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            family: "bold",
                                                            size: "14px",
                                                            children: "Total Keuntungan"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                            size: "12px",
                                                            color: "#B5B5B5",
                                                            children: "Selama Investasi"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                                    amount: sell === null || sell === void 0 ? void 0 : sell.total_realized_amount,
                                                    percentage: sell === null || sell === void 0 ? void 0 : sell.total_realized_amount_percentage,
                                                    family: "bold"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                width: "335px",
                                mx: "20px",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTradingModal_styled/* Checkbox */.XZ, {
                                        checked: isTnCAccepted,
                                        onChange: handleCheckboxChange
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        pl: "8px",
                                        size: "12px",
                                        as: "span",
                                        children: [
                                            "Saya, Nasabah, telah membaca, menyetujui dan memahami",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                color: _style_color/* default.primary */.Z.primary,
                                                onClick: openTncModal,
                                                "aria-hidden": "true",
                                                size: "12px",
                                                as: "span",
                                                children: "Syarat-syarat dan Ketentuan"
                                            }),
                                            " ",
                                            "Efek Bersifat Utang dan Sukuk (EBUS) di Pasar Sekunder di atas"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalFooter */.mz, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justify: "space-between",
                    style: {
                        position: "absolute",
                        bottom: "-50px",
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: closeModal,
                            type: "danger",
                            radius: "4px",
                            block: true,
                            height: "40px",
                            style: {
                                width: "49%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                align: "inherit",
                                color: "white",
                                family: "bold",
                                size: "18px",
                                children: "Cancel"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmButton, {
                            onClick: handleSubmitOrder,
                            radius: "4px",
                            block: true,
                            height: "40px",
                            style: {
                                width: "49%"
                            },
                            disabled: !isTnCAccepted,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                align: "inherit",
                                color: isTnCAccepted ? _style_color/* default.primary */.Z.primary : "#cbcbcb",
                                family: "bold",
                                size: "18px",
                                children: "Confirm"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var _StyledBorderedWrapper = (0,styled_components_browser_esm/* default */.ZP)(BorderedWrapper).withConfig({
    componentId: "sc-cf495c6e-0"
})(ModalBondConfirm_templateObject());
var ModalBondConfirm_StyledDivider = (0,styled_components_browser_esm/* default */.ZP)(divider/* default */.Z).withConfig({
    componentId: "sc-cf495c6e-1"
})(ModalBondConfirm_templateObject1());

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondSell/index.tsx




















function ModalBondSell() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31;
    var ref32 = (0,_sliced_to_array/* default */.Z)((0,Form/* useForm */.cI)(), 1), form = ref32[0];
    var ref33 = (0,_sliced_to_array/* default */.Z)((0,useBondTransaction/* useBondTransaction */.P)(function(s) {
        return [
            s.productId,
            s.acquisitionOrderId, 
        ];
    }), 2), productId = ref33[0], orderId = ref33[1];
    var ref34 = (0,useBondsAnalytics/* default */.Z)(), FRBondsNavigateTrackers = ref34.FRBondsNavigateTrackers, FRBondActionTrackers = ref34.FRBondActionTrackers;
    var ref35 = (0,_sliced_to_array/* default */.Z)((0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return [
            s.transactionType,
            s.closeTransactionModal,
            s.openConfirmModal,
            s.sourcePage, 
        ];
    }), 4), transactionType = ref35[0], closeTransactionModal = ref35[1], openConfirmModal = ref35[2], sourcePage = ref35[3];
    var openInfoModal = (0,useBondInfoModal/* useBondInfoModal */.e)(function(s) {
        return s.openInfoModal;
    });
    var ref36 = useBondPreviewForm({
        action: bond/* BondTransactionActionEnum.SELL */.qB.SELL,
        productId: productId,
        orderId: orderId
    }), handleUnitAmountChanged = ref36.handleUnitAmountChanged, isLoadingPreview = ref36.isLoadingPreview, unit = ref36.unit, preview = ref36.preview, isDisabled = ref36.isDisabled;
    var _transactionType = constants/* BOND_TRANSACTION_CONFIG */.H1[transactionType], textColor = _transactionType.textColor, title = _transactionType.title;
    var onSubmit = function() {
        FRBondActionTrackers.onOrderPlaced("Sell", productId);
        openConfirmModal();
    };
    (0,react.useEffect)(function() {
        if (productId) {
            FRBondsNavigateTrackers.onBondOrderPageViewed("Sell", productId, sourcePage);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(es_form/* default */.Z, {
        form: form,
        onFinish: onSubmit,
        colon: false,
        labelCol: {
            span: 10
        },
        wrapperCol: {
            span: 8,
            offset: 2
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalContainer */.F0, {
                modalType: constants/* BondsModalTypeEnum.TRANSACTION */._y.TRANSACTION,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalHeader */.xB, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitle, {
                                color: textColor,
                                title: title,
                                onClose: closeTransactionModal
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalProductDisplay, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalBody */.fe, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                label: "Unit Tersedia",
                                value: preview === null || preview === void 0 ? void 0 : (ref = preview.sell) === null || ref === void 0 ? void 0 : ref.available_units,
                                type: "unit",
                                isBold: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
                                label: "Unit Penjualan",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* UnitInput */.OT, {
                                    value: unit,
                                    onChange: handleUnitAmountChanged,
                                    placeholder: "1 Unit = ".concat((0,utils/* formatCurrency */.xG)(constants/* BASE_UNIT_AMOUNT.toString */.MD.toString())),
                                    type: "number"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                label: "Harga Jual (%)",
                                value: preview === null || preview === void 0 ? void 0 : (ref1 = preview.sell) === null || ref1 === void 0 ? void 0 : ref1.price.sell,
                                type: "percentage",
                                onInfoClick: function() {
                                    return openInfoModal(constants/* BondInfoType.SELLING_PRICE */.Im.SELLING_PRICE);
                                },
                                isNeedInfo: true,
                                isDisabled: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                    label: "Total Nilai Penjualan",
                                    isLoading: isLoadingPreview,
                                    value: preview === null || preview === void 0 ? void 0 : (ref2 = preview.sell) === null || ref2 === void 0 ? void 0 : ref2.estimation_disburse_amount,
                                    type: "currency",
                                    isBold: true
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Nilai Penjualan",
                                        isLoading: isLoadingPreview,
                                        value: preview === null || preview === void 0 ? void 0 : (ref3 = preview.sell) === null || ref3 === void 0 ? void 0 : ref3.estimation_sell_amount,
                                        type: "currency"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Kupon Berjalan (Nett)",
                                        isLoading: isLoadingPreview,
                                        value: preview === null || preview === void 0 ? void 0 : (ref4 = preview.sell) === null || ref4 === void 0 ? void 0 : ref4.accrued_interest_exclude_tax,
                                        type: "currency",
                                        onInfoClick: function() {
                                            return openInfoModal(constants/* BondInfoType.ACCRUED_INTEREST */.Im.ACCRUED_INTEREST);
                                        },
                                        isNeedInfo: true,
                                        isShowSign: (preview === null || preview === void 0 ? void 0 : (ref5 = preview.sell) === null || ref5 === void 0 ? void 0 : ref5.accrued_interest_exclude_tax) > 0
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Pajak",
                                        isLoading: isLoadingPreview,
                                        value: (preview === null || preview === void 0 ? void 0 : (ref6 = preview.sell) === null || ref6 === void 0 ? void 0 : ref6.fee.total_tax) * -1,
                                        type: "currency",
                                        onInfoClick: function() {
                                            return openInfoModal(constants/* BondInfoType.TAX */.Im.TAX);
                                        },
                                        isNeedInfo: true,
                                        isShowSign: (preview === null || preview === void 0 ? void 0 : (ref7 = preview.sell) === null || ref7 === void 0 ? void 0 : ref7.fee.total_tax) !== 0
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Bea Meterai",
                                        isLoading: isLoadingPreview,
                                        value: (preview === null || preview === void 0 ? void 0 : (ref8 = preview.sell) === null || ref8 === void 0 ? void 0 : ref8.fee.stamp_duty) * -1,
                                        type: "currency",
                                        isShowSign: (preview === null || preview === void 0 ? void 0 : (ref9 = preview.sell) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.fee) === null || ref10 === void 0 ? void 0 : ref10.stamp_duty) > 0
                                    }),
                                    (preview === null || preview === void 0 ? void 0 : (ref11 = preview.sell) === null || ref11 === void 0 ? void 0 : ref11.seller_coupon) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Kupon Penjual",
                                        isLoading: isLoadingPreview,
                                        value: preview === null || preview === void 0 ? void 0 : (ref12 = preview.sell) === null || ref12 === void 0 ? void 0 : ref12.seller_coupon,
                                        type: "currency",
                                        onInfoClick: function() {
                                            return openInfoModal(constants/* BondInfoType.ACCRUED_INTEREST_SELLER */.Im.ACCRUED_INTEREST_SELLER);
                                        },
                                        isNeedInfo: true,
                                        isShowSign: (preview === null || preview === void 0 ? void 0 : (ref13 = preview.sell) === null || ref13 === void 0 ? void 0 : ref13.seller_coupon) > 0
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                    label: "P&L (Nett)",
                                    isLoading: isLoadingPreview,
                                    value: preview === null || preview === void 0 ? void 0 : (ref14 = preview.sell) === null || ref14 === void 0 ? void 0 : ref14.profit_loss_nett,
                                    type: (preview === null || preview === void 0 ? void 0 : (ref15 = preview.sell) === null || ref15 === void 0 ? void 0 : ref15.profit_loss_nett) === 0 ? "currency" : "pl",
                                    plPercentage: preview === null || preview === void 0 ? void 0 : (ref16 = preview.sell) === null || ref16 === void 0 ? void 0 : ref16.profit_loss_nett_percentage,
                                    isBold: true
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Kupon Berjalan",
                                        isLoading: isLoadingPreview,
                                        value: preview === null || preview === void 0 ? void 0 : (ref17 = preview.sell) === null || ref17 === void 0 ? void 0 : ref17.accrued_interest_exclude_tax,
                                        type: (preview === null || preview === void 0 ? void 0 : (ref18 = preview.sell) === null || ref18 === void 0 ? void 0 : ref18.accrued_interest_exclude_tax) === 0 ? "currency" : "pl",
                                        onInfoClick: function() {
                                            return openInfoModal(constants/* BondInfoType.TOTAL_DAILY_COUPON */.Im.TOTAL_DAILY_COUPON);
                                        },
                                        isNeedInfo: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Capital Gain / Loss",
                                        isLoading: isLoadingPreview,
                                        value: preview === null || preview === void 0 ? void 0 : (ref19 = preview.sell) === null || ref19 === void 0 ? void 0 : ref19.profit_loss,
                                        type: (preview === null || preview === void 0 ? void 0 : (ref20 = preview.sell) === null || ref20 === void 0 ? void 0 : ref20.profit_loss) === 0 ? "currency" : "pl"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Pajak",
                                        isLoading: isLoadingPreview,
                                        value: (preview === null || preview === void 0 ? void 0 : (ref21 = preview.sell) === null || ref21 === void 0 ? void 0 : ref21.fee.total_tax) * -1,
                                        type: "currency",
                                        onInfoClick: function() {
                                            return openInfoModal(constants/* BondInfoType.TAX */.Im.TAX);
                                        },
                                        isNeedInfo: true,
                                        isShowSign: (preview === null || preview === void 0 ? void 0 : (ref22 = preview.sell) === null || ref22 === void 0 ? void 0 : ref22.fee.total_tax) !== 0
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion, {
                                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                    label: "Total Keuntungan (Nett)",
                                    subtitle: "Selama Investasi",
                                    isLoading: isLoadingPreview,
                                    value: preview === null || preview === void 0 ? void 0 : (ref23 = preview.sell) === null || ref23 === void 0 ? void 0 : ref23.total_realized_amount,
                                    type: (preview === null || preview === void 0 ? void 0 : (ref24 = preview.sell) === null || ref24 === void 0 ? void 0 : ref24.total_realized_amount) === 0 ? "currency" : "pl",
                                    plPercentage: preview === null || preview === void 0 ? void 0 : (ref25 = preview.sell) === null || ref25 === void 0 ? void 0 : ref25.total_realized_amount_percentage,
                                    isBold: true
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Total Kupon Harian",
                                        isLoading: isLoadingPreview,
                                        value: preview === null || preview === void 0 ? void 0 : (ref26 = preview.sell) === null || ref26 === void 0 ? void 0 : ref26.daily_accrued_interest,
                                        type: (preview === null || preview === void 0 ? void 0 : (ref27 = preview.sell) === null || ref27 === void 0 ? void 0 : ref27.daily_accrued_interest) === 0 ? "currency" : "pl",
                                        onInfoClick: function() {
                                            return openInfoModal(constants/* BondInfoType.TOTAL_DAILY_COUPON */.Im.TOTAL_DAILY_COUPON);
                                        },
                                        isNeedInfo: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Pajak",
                                        isLoading: isLoadingPreview,
                                        value: (preview === null || preview === void 0 ? void 0 : (ref28 = preview.sell) === null || ref28 === void 0 ? void 0 : ref28.fee.total_tax) * -1,
                                        type: "currency",
                                        onInfoClick: function() {
                                            return openInfoModal(constants/* BondInfoType.TAX */.Im.TAX);
                                        },
                                        isNeedInfo: true,
                                        isShowSign: (preview === null || preview === void 0 ? void 0 : (ref29 = preview.sell) === null || ref29 === void 0 ? void 0 : ref29.fee.total_tax) !== 0
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormDisplayField, {
                                        label: "Capital Gain / Loss",
                                        isLoading: isLoadingPreview,
                                        value: preview === null || preview === void 0 ? void 0 : (ref30 = preview.sell) === null || ref30 === void 0 ? void 0 : ref30.profit_loss,
                                        type: (preview === null || preview === void 0 ? void 0 : (ref31 = preview.sell) === null || ref31 === void 0 ? void 0 : ref31.profit_loss) === 0 ? "currency" : "pl"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalFooter */.mz, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* OrderButton */.sg, {
                    disabled: isDisabled,
                    type: "secondary",
                    htmlType: "submit",
                    onClick: openConfirmModal,
                    block: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: "Place Order"
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/global/Securities/components/Modal/BaseSecuritiesModal/index.tsx + 1 modules
var BaseSecuritiesModal = __webpack_require__(48871);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondTnC/styled.tsx

function ModalBondTnC_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 20px;\n  margin-top: 20px;\n  box-sizing: border-box;\n  min-height: 408px;\n"
    ]);
    ModalBondTnC_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalBondTnC_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n"
    ]);
    ModalBondTnC_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalBondTnC_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & span {\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 16px;\n  }\n  margin: 0;\n"
    ]);
    ModalBondTnC_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalBondTnC_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #ededed;\n  border-radius: 4px;\n"
    ]);
    ModalBondTnC_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  border-radius: 4px;\n  width: 100%;\n  height: 408px;\n  overflow-y: scroll;\n  padding: 16px;\n  > ol {\n    padding-inline-start: 16px;\n    margin-bottom: 0px;\n  }\n  > h1.title {\n    font-size: 14px;\n    font-weight: 700;\n  }\n  > div.sensor {\n    height: 1px;\n    width: 100%;\n  }\n"
    ]);
    styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var styled_ContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d4e13d39-0"
})(ModalBondTnC_styled_templateObject());
var AgreementWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d4e13d39-1"
})(ModalBondTnC_styled_templateObject1());
var AgreementLabel = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-d4e13d39-2"
})(ModalBondTnC_styled_templateObject2());
var TnCFrameWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d4e13d39-3"
})(ModalBondTnC_styled_templateObject3());
var TnCFrame = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d4e13d39-4"
})(styled_templateObject4());

// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/dist/visibility-sensor.js
var visibility_sensor = __webpack_require__(33082);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondTnC/TnCContent.tsx


function TnCContent(param) {
    var onReachedBottom = param.onReachedBottom;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "title",
                children: "Syarat Dan Ketentuan Transaksi Efek Bersifat Utang dan Sukuk (EBUS) di Pasar Sekunder"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Investasi pada EBUS mengandung risiko investasi, termasuk namun tidak terbatas pada adanya risiko pasar, risiko likuiditas, dan risiko gagal bayar yang dapat berakibat pada berkurang atau hilangnya pokok investasi."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Kinerja EBUS di masa lalu bukan merupakan jaminan atas kinerja dan hasil investasi di masa mendatang."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Harga yang tertera pada Aplikasi PT Stockbit Sekuritas Digital (Stockbit) merupakan harga indikasi dan dapat berubah sewaktu-waktu."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Instruksi pembelian/penjualan EBUS yang disampaikan oleh Nasabah melalui Stockbit tidak dapat dibatalkan. Transaksi yang terlaksana atas instruksi pembelian/penjualan EBUS yang diajukan oleh nasabah dan disetujui oleh Stockbit adalah transaksi yang sah, mengikat dan tidak dapat diubah dan/atau dibatalkan oleh Nasabah. Konfirmasi atas transaksi tersebut akan dikirimkan secara elektronik, bersifat akurat dan benar serta mengikat bagi Nasabah."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Nasabah wajib memastikan kecukupan dana di Rekening Dana Nasabah (RDN) pada saat menyampaikan instruksi pembelian EBUS, instruksi dari Nasabah akan ditolak oleh Stockbit apabila dana di RDN Nasabah tidak mencukupi pada saat penyampaian instruksi dan/atau pada saat verifikasi instruksi."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Apabila transaksi pembelian atas instruksi tersebut terlaksana, maka Stockbit berhak untuk melakukan pendebetan dana di RDN Nasabah pada tanggal settlement sejumlah nominal yang harus dibayarkan oleh Nasabah."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Apabila transaksi penjualan atas instruksi tersebut terlaksana, maka Dana hasil penjualan akan dicairkan langsung ke RDN pada tanggal settlement (T+2)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Distribusi Kupon EBUS akan dicairkan langsung ke RDN."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Transaksi EBUS pada Pasar Sekunder dikenakan pemotongan Pajak Penghasilan (PPh) final sebesar 10% atas penghasilan berupa kupon berjalan dan keuntungan (capital gain) yang diterima, serta biaya Bea Meterai yang akan dikenakan sesuai dengan ketentuan hukum dan peraturan perundang-undangan yang berlaku."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Nasabah wajib membaca dan mempelajari seluruh informasi, manfaat, dan risiko terkait dengan EBUS, termasuk dan tidak terbatas pada informasi yang dimuat dalam Syarat dan Ketentuan, Produk Info, Memorandum Informasi, dan/atau dokumen lainnya yang berkaitan dengan keterbukaan informasi."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Nasabah membebaskan Stockbit dari segala bentuk tuntutan, ganti rugi, gugatan, dan/atau tindakan hukum lainnya dari pihak manapun yang timbul sehubungan dengan Transaksi EBUS di Pasar Sekunder yang telah diajukan dan disetujui."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
                onChange: function(value) {
                    if (value) {
                        onReachedBottom();
                    }
                },
                scrollCheck: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sensor",
                    children: "\xa0"
                })
            }, "visibility-sensor")
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondTnC/index.tsx













function ModalBondTnC(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var ref = (0,react.useState)(false), isReachedBottom = ref[0], setReachingBottom = ref[1];
    var acceptTnC = (0,useBondTransaction/* useBondTransaction */.P)(function(s) {
        return s.setTnC;
    });
    var closeModal = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return s.closeModal;
    });
    var FRBondActionTrackers = (0,useBondsAnalytics/* default */.Z)().FRBondActionTrackers;
    var handleTncSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (isReachedBottom) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        acceptTnC(true);
                        FRBondActionTrackers.onTnCConfirmed();
                        closeModal();
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleTncSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleReachedBottom = function() {
        setReachingBottom(true);
    };
    (0,react.useEffect)(function() {
        return function() {
            setReachingBottom(false);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseSecuritiesModal/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        title: "Syarat & Ketentuan",
        submitText: "Saya Setuju",
        submitProps: {
            disabled: !isReachedBottom,
            loading: false
        },
        onSubmit: handleTncSubmit
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_ContentContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TnCFrameWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TnCFrame, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TnCContent, {
                        onReachedBottom: handleReachedBottom
                    })
                })
            })
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/features/trade/components/DetailModal/InfoTable.tsx
var InfoTable = __webpack_require__(51981);
// EXTERNAL MODULE: ./src/features/securities/styled.ts
var securities_styled = __webpack_require__(38639);
// EXTERNAL MODULE: ./src/features/day-trade/components/Icons/index.ts + 6 modules
var Icons = __webpack_require__(40892);
// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondOrder.ts
var useBondOrder = __webpack_require__(29541);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/BondProductDisplay/index.tsx





function BondProductDisplay(param) {
    var product = param.product, cta = param.cta, isStableEarn = param.isStableEarn;
    var iconSrc = isStableEarn ? constants/* STABLE_EARN_ICON_SRC */.gG : (product === null || product === void 0 ? void 0 : product.icon_url) || constants/* FALLBACK_AVATAR_SRC */.sW;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        justify: "space-between",
        align: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                style: {
                    gap: 12
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: iconSrc,
                        style: {
                            width: "40px",
                            height: "40px",
                            background: "white"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        direction: "column",
                        style: {
                            gap: 2
                        },
                        justify: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                family: "bold",
                                size: "14px",
                                children: isStableEarn ? "Stable Earn" : product === null || product === void 0 ? void 0 : product.id
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "#969696",
                                size: "12px",
                                children: product === null || product === void 0 ? void 0 : product.name
                            })
                        ]
                    })
                ]
            }),
            cta
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondOrder/styled.ts

function ModalBondOrder_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px;\n  margin: 16px 0px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  border: 1px solid #ededed;\n  border-radius: 4px;\n"
    ]);
    ModalBondOrder_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalBondOrder_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n"
    ]);
    ModalBondOrder_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalBondOrder_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  gap: 8px;\n"
    ]);
    ModalBondOrder_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalBondOrder_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: start;\n  gap: 12px;\n"
    ]);
    ModalBondOrder_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModalBondOrder_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  height: 44px;\n"
    ]);
    ModalBondOrder_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 2px;\n  height: 12px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  height: 24px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n\n  gap: 12px;\n\n  height: 56px;\n  width: 100%;\n  padding: 12px 16px;\n\n  background-color: #f2f1fe;\n  border-radius: 4px;\n\n  > p {\n    height: 100%;\n    margin: 0;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 32px;\n  height: 32px;\n  border-radius: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  background-color: #e0ddfd;\n\n  > img {\n    width: 16px;\n    height: 16px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  font-weight: 700;\n  color: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}

var ModalBondOrder_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aa24a7bd-0"
})(ModalBondOrder_styled_templateObject());
var Paragraph = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aa24a7bd-1"
})(ModalBondOrder_styled_templateObject1());
var StepperContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aa24a7bd-2"
})(ModalBondOrder_styled_templateObject2());
var StepperItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aa24a7bd-3"
})(ModalBondOrder_styled_templateObject3());
var StepperImageFrame = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aa24a7bd-4"
})(ModalBondOrder_styled_templateObject4());
var StepperLine = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aa24a7bd-5"
})(_templateObject5(), function(props) {
    return props.isActive ? "#00ab6b" : "#96969699";
});
var StepperLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aa24a7bd-6"
})(_templateObject6());
var PanelContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aa24a7bd-7"
})(_templateObject7());
var PanelIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-aa24a7bd-8"
})(_templateObject8());
var OrderStatusLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-aa24a7bd-9"
})(_templateObject9(), function(props) {
    return props.isNegative ? "#EE4A49" : "#00AB6B";
});

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondOrder/components/InfoPanel.tsx



function InfoPanel(param) {
    var _imageSrc = param.imageSrc, imageSrc = _imageSrc === void 0 ? "icon/fr/icon-sand-clock.svg" : _imageSrc, _text = param.text, text = _text === void 0 ? "" : _text;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PanelContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PanelIconContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: imageSrc
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: text
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondOrder/types.ts
var StepperStep;
(function(StepperStep) {
    StepperStep["SUBMITTED"] = "STEPPER_STEP_SUBMITTED";
    StepperStep["VERIFIED"] = "STEPPER_STEP_VERIFIED";
    StepperStep["SUCCESS"] = "STEPPER_STEP_SUCCESS";
    StepperStep["REJECTED"] = "STEPPER_STEP_REJECTED";
})(StepperStep || (StepperStep = {}));

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondOrder/constants.ts

var StatusIndicatorMap = {
    UNSPECIFIED: "icon/fr/icon-stepper-unspecified.svg",
    REJECTED: "icon/fr/icon-stepper-rejected.svg",
    SUCCESS: "icon/fr/icon-stepper-success.svg",
    ON_PROGRESS: "icon/fr/icon-stepper-on_progress.svg"
};
var BondOrderStatusMap = {
    BOND_ORDER_STATUS_UNSPECIFIED: "UNSPECIFIED",
    BOND_ORDER_STATUS_REJECTED: "REJECTED",
    BOND_ORDER_STATUS_SUBMITTED: "ON_PROGRESS",
    BOND_ORDER_STATUS_SUCCEEDED: "SUCCESS",
    BOND_ORDER_STATUS_VERIFIED: "SUCCESS"
};
var BondOrderStatusLabelMap = {
    BOND_ORDER_STATUS_UNSPECIFIED: "Unspecified",
    BOND_ORDER_STATUS_REJECTED: "Rejected",
    BOND_ORDER_STATUS_SUBMITTED: "Submitted",
    BOND_ORDER_STATUS_SUCCEEDED: "Success",
    BOND_ORDER_STATUS_VERIFIED: "Verified"
};
var BondOrderStatusStepMap = {
    BOND_ORDER_STATUS_UNSPECIFIED: StepperStep.REJECTED,
    BOND_ORDER_STATUS_REJECTED: StepperStep.REJECTED,
    BOND_ORDER_STATUS_SUBMITTED: StepperStep.SUBMITTED,
    BOND_ORDER_STATUS_SUCCEEDED: StepperStep.SUCCESS,
    BOND_ORDER_STATUS_VERIFIED: StepperStep.SUBMITTED
};
var stepperContentList = [
    {
        prev: undefined,
        next: StepperStep.VERIFIED,
        current: StepperStep.SUBMITTED,
        content: {
            date: undefined,
            status: "UNSPECIFIED",
            descriptions: undefined,
            label: BondOrderStatusLabelMap.BOND_ORDER_STATUS_SUBMITTED
        }
    },
    {
        prev: StepperStep.SUBMITTED,
        next: StepperStep.SUCCESS,
        current: StepperStep.VERIFIED,
        content: {
            date: undefined,
            status: "UNSPECIFIED",
            descriptions: undefined,
            label: BondOrderStatusLabelMap.BOND_ORDER_STATUS_VERIFIED
        }
    },
    {
        prev: StepperStep.VERIFIED,
        next: undefined,
        current: StepperStep.SUCCESS,
        content: {
            date: undefined,
            status: "UNSPECIFIED",
            descriptions: undefined,
            label: BondOrderStatusLabelMap.BOND_ORDER_STATUS_SUCCEEDED
        }
    }, 
];

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondOrder/components/TimelineItem.tsx







function TimelineItem(param) {
    var label = param.label, date = param.date, status = param.status, index = param.index, length = param.length, _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive, _descriptions = param.descriptions, descriptions = _descriptions === void 0 ? "" : _descriptions;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepperItem, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepperImageFrame, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: StatusIndicatorMap[status]
                    }),
                    index < length - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperLine, {
                        isActive: isActive
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepperContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepperLabel, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                family: "bold",
                                children: label
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                                condition: date,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "•"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "#858585",
                                        children: moment_default()(date).utc().format("DD MMM YYYY HH:mm")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        children: descriptions
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondOrder/components/Timeline.tsx






function Timeline(param) {
    var _contents = param.contents, contents = _contents === void 0 ? [] : _contents, _message = param.message, message = _message === void 0 ? "" : _message;
    // handle the rejected content first
    var rejectedContent = contents === null || contents === void 0 ? void 0 : contents.find(function(content) {
        return content.status === bond/* BondOrderStatus.REJECTED */.ro.REJECTED;
    });
    if (rejectedContent) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineItem, {
            index: 0,
            length: 1,
            status: "REJECTED",
            date: rejectedContent.occurred_at,
            label: BondOrderStatusLabelMap[rejectedContent === null || rejectedContent === void 0 ? void 0 : rejectedContent.status],
            descriptions: message,
            isActive: false
        });
    }
    var statuses = [
        bond/* BondOrderStatus.SUBMITTED */.ro.SUBMITTED,
        bond/* BondOrderStatus.VERIFIED */.ro.VERIFIED,
        bond/* BondOrderStatus.SUCCEEDED */.ro.SUCCEEDED, 
    ];
    var reduced = statuses.reduce(function(prev, current, index) {
        var status = "UNSPECIFIED";
        var isActive = false;
        var currentContent = contents.find(function(content) {
            return content.status === current;
        });
        // Bond status is found in the array
        if (currentContent) {
            status = "SUCCESS";
            isActive = true;
        } else if (prev[index - 1] && prev[index - 1].status === "SUCCESS") {
            status = "ON_PROGRESS";
        }
        if (currentContent && index > 0 && prev[index]) {
            status = prev[index].status === "SUCCESS" ? "ON_PROGRESS" : "UNSPECIFIED";
        }
        return (0,_to_consumable_array/* default */.Z)(prev).concat([
            {
                index: index,
                status: status,
                length: statuses.length,
                date: currentContent === null || currentContent === void 0 ? void 0 : currentContent.occurred_at,
                label: BondOrderStatusLabelMap[current],
                descriptions: message,
                isActive: isActive
            }, 
        ]);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                family: "bold",
                mb: "16px",
                children: "Order Status"
            }),
            reduced.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineItem, {
                    index: item.index,
                    length: item.length,
                    date: item.date,
                    label: item.label,
                    descriptions: item.message,
                    status: item.status,
                    isActive: item.isActive
                }, "status-history-".concat(item.index));
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondOrder/components/OrderContentBuy.tsx











function OrderContentBuy(param) {
    var _finalAmount = param.finalAmount, finalAmount = _finalAmount === void 0 ? 0 : _finalAmount, _tradeAmount = param.tradeAmount, tradeAmount = _tradeAmount === void 0 ? 0 : _tradeAmount, _sellerAccruedInterest = param.sellerAccruedInterest, sellerAccruedInterest = _sellerAccruedInterest === void 0 ? 0 : _sellerAccruedInterest, _stampDuty = param.stampDuty, stampDuty = _stampDuty === void 0 ? 0 : _stampDuty;
    var openInfoModal = (0,useBondInfoModal/* useBondInfoModal */.e)(function(s) {
        return s.openInfoModal;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion, {
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* FieldSet */.C3, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                isAccordion: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Total Pembayaran"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        family: "bold",
                        children: [
                            "Rp",
                            (0,utils/* formatPrice */.T4)(finalAmount.toString())
                        ]
                    })
                ]
            })
        }),
        isPlain: true,
        isTight: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* FieldSet */.C3, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: "Nilai Pembelian"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                "Rp",
                                (0,utils/* formatPrice */.T4)(tradeAmount.toString())
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    children: "Kupon Penjual"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTypeFormItem_styled/* InfoButton */.R, {
                                    type: "button",
                                    onClick: function() {
                                        return openInfoModal(constants/* BondInfoType.ACCRUED_INTEREST_SELLER */.Im.ACCRUED_INTEREST_SELLER);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                        component: InfoSvg/* default */.Z,
                                        style: {
                                            fontSize: 16,
                                            color: "#969696",
                                            marginLeft: 4
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                children: [
                                    sellerAccruedInterest > 0 && "+",
                                    "Rp",
                                    (0,utils/* formatPrice */.T4)(sellerAccruedInterest.toString())
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: "Bea Meterai"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            children: [
                                stampDuty > 0 && "+",
                                "Rp",
                                (0,utils/* formatPrice */.T4)(stampDuty.toString())
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/global/Collapsible/index.tsx + 1 modules
var Collapsible = __webpack_require__(80557);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondTaxStore.ts



var initialState = {
    isVisible: false,
    accruedInterest: 0,
    pl: 0,
    amount: 0,
    totalTax: 0
};
var useBondTaxStore = (0,esm/* default */.ZP)(function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        openTaxModal: function openTaxModal(payload) {
            set((0,_object_spread/* default */.Z)({
                isVisible: true
            }, payload));
        },
        closeTaxModal: function closeTaxModal() {
            set(initialState);
        }
    });
});

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondOrder/components/OrderContentSell.tsx















function OrderContentSell(param) {
    var _finalAmount = param.finalAmount, finalAmount = _finalAmount === void 0 ? 0 : _finalAmount, _tradeAmount = param.tradeAmount, tradeAmount = _tradeAmount === void 0 ? 0 : _tradeAmount, _accruedInterest = param.accruedInterest, accruedInterest = _accruedInterest === void 0 ? 0 : _accruedInterest, _totalTax = param.totalTax, totalTax = _totalTax === void 0 ? 0 : _totalTax, _stampDuty = param.stampDuty, stampDuty = _stampDuty === void 0 ? 0 : _stampDuty, _capitalGain = param.capitalGain, capitalGain = _capitalGain === void 0 ? 0 : _capitalGain, _profitLossAmount = param.profitLossAmount, profitLossAmount = _profitLossAmount === void 0 ? 0 : _profitLossAmount, _profitLossPercentage = param.profitLossPercentage, profitLossPercentage = _profitLossPercentage === void 0 ? 0 : _profitLossPercentage, _sellerCoupon = param.sellerCoupon, sellerCoupon = _sellerCoupon === void 0 ? 0 : _sellerCoupon, _accruedInterestExcludeTax = param.// for tax
    accruedInterestExcludeTax, accruedInterestExcludeTax = _accruedInterestExcludeTax === void 0 ? 0 : _accruedInterestExcludeTax, _estimationAmountExcludeTax = param.estimationAmountExcludeTax, estimationAmountExcludeTax = _estimationAmountExcludeTax === void 0 ? 0 : _estimationAmountExcludeTax, _realizedAmount = param.realizedAmount, realizedAmount = _realizedAmount === void 0 ? 0 : _realizedAmount;
    var openTaxModal = useBondTaxStore(function(s) {
        return s.openTaxModal;
    });
    var openInfoModal = (0,useBondInfoModal/* useBondInfoModal */.e)(function(s) {
        return s.openInfoModal;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondOrder_styled_Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion, {
                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* FieldSet */.C3, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                            isAccordion: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    children: "Nominal Diterima"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    family: "bold",
                                    children: (0,utils/* formatBondCurrency */.uJ)(finalAmount)
                                })
                            ]
                        })
                    }),
                    isPlain: true,
                    isTight: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* FieldSet */.C3, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Nilai Penjualan"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (0,utils/* formatBondCurrency */.uJ)(tradeAmount)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                children: "Kupon Berjalan"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTypeFormItem_styled/* InfoButton */.R, {
                                                type: "button",
                                                onClick: function() {
                                                    return openInfoModal(constants/* BondInfoType.ACCRUED_INTEREST */.Im.ACCRUED_INTEREST);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    component: InfoSvg/* default */.Z,
                                                    style: {
                                                        fontSize: 16,
                                                        color: "#969696",
                                                        marginLeft: 4
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (0,utils/* formatBondCurrency */.uJ)(accruedInterest, "exceptZero")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                children: "Pajak Obligasi"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTypeFormItem_styled/* InfoButton */.R, {
                                                type: "button",
                                                onClick: function() {
                                                    return openTaxModal({
                                                        accruedInterest: accruedInterestExcludeTax,
                                                        amount: estimationAmountExcludeTax,
                                                        pl: realizedAmount,
                                                        totalTax: totalTax
                                                    });
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    component: InfoSvg/* default */.Z,
                                                    style: {
                                                        fontSize: 16,
                                                        color: "#969696",
                                                        marginLeft: 4
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (0,utils/* formatBondCurrency */.uJ)(totalTax * -1, "exceptZero")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Bea Meterai"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (0,utils/* formatBondCurrency */.uJ)(stampDuty * -1, "exceptZero")
                                    })
                                ]
                            }),
                            sellerCoupon > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        align: "center",
                                        children: [
                                            "Kupon Penjual",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTypeFormItem_styled/* InfoButton */.R, {
                                                type: "button",
                                                onClick: function() {
                                                    return openInfoModal(constants/* BondInfoType.ACCRUED_INTEREST_SELLER */.Im.ACCRUED_INTEREST_SELLER);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    component: InfoSvg/* default */.Z,
                                                    style: {
                                                        fontSize: 16,
                                                        color: "#969696",
                                                        marginLeft: 4
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (0,utils/* formatBondCurrency */.uJ)(sellerCoupon, "exceptZero")
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondOrder_styled_Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapsible/* default */.Z, {
                    header: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* FieldSet */.C3, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    children: "P&L (Nett)"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                    amount: profitLossAmount,
                                    percentage: profitLossPercentage,
                                    family: "bold"
                                })
                            ]
                        })
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* FieldSet */.C3, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                children: "Kupon Berjalan"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTypeFormItem_styled/* InfoButton */.R, {
                                                type: "button",
                                                onClick: function() {
                                                    return openInfoModal(constants/* BondInfoType.ACCRUED_INTEREST */.Im.ACCRUED_INTEREST);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    component: InfoSvg/* default */.Z,
                                                    style: {
                                                        fontSize: 16,
                                                        color: "#969696",
                                                        marginLeft: 4
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                        amount: accruedInterest,
                                        isColorless: accruedInterest === 0,
                                        isSignless: accruedInterest <= 0
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Capital Gain / Loss"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                        amount: capitalGain,
                                        isColorless: capitalGain === 0,
                                        isSignless: capitalGain === 0
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        align: "center",
                                        mb: "16px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                children: "Pajak"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderTypeFormItem_styled/* InfoButton */.R, {
                                                type: "button",
                                                onClick: function() {
                                                    return openInfoModal(constants/* BondInfoType.TAX */.Im.TAX);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    component: InfoSvg/* default */.Z,
                                                    style: {
                                                        fontSize: 16,
                                                        color: "#969696",
                                                        marginLeft: 4
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: (0,utils/* formatBondCurrency */.uJ)(totalTax * -1, "exceptZero")
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondOrder/index.tsx



function ModalBondOrder_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          width: 502px;\n        "
    ]);
    ModalBondOrder_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






















var getTitle = function() {
    var productId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", action = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : bond/* BondTransactionActionEnum.UNSPECIFIED */.qB.UNSPECIFIED;
    var _obj;
    return (_obj = {}, (0,_define_property/* default */.Z)(_obj, bond/* BondTransactionActionEnum.BUY */.qB.BUY, "Buy ".concat(productId)), (0,_define_property/* default */.Z)(_obj, bond/* BondTransactionActionEnum.SELL */.qB.SELL, "Sell ".concat(productId)), (0,_define_property/* default */.Z)(_obj, bond/* BondTransactionActionEnum.UNSPECIFIED */.qB.UNSPECIFIED, productId), _obj)[action];
};
function ModalBondOrder() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return [
            s.closeModal,
            s.closeTransactionModal, 
        ];
    }), 2), closeModal = ref9[0], closeTransactionModal = ref9[1];
    var selected = (0,useBondOrder/* useBondOrder */.o)(function(s) {
        return {
            selected: s.selected,
            isLoading: s.isLoading
        };
    }).selected;
    var productId = selected === null || selected === void 0 ? void 0 : (ref = selected.product) === null || ref === void 0 ? void 0 : ref.id;
    var action = (selected === null || selected === void 0 ? void 0 : selected.action) || bond/* BondTransactionActionEnum.BUY */.qB.BUY;
    var title = getTitle(productId, action);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalContainer */.F0, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalHeader */.xB, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitle, {
                    title: title,
                    onClose: closeModal
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(_StyledModalBody, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondOrder_styled_Container, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/symbol/".concat(selected === null || selected === void 0 ? void 0 : selected.product.id),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(securities_styled/* Flex */.kC, {
                                as: "a",
                                justify: "space-between",
                                align: "center",
                                onClickCapture: closeTransactionModal,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BondProductDisplay, {
                                        product: selected === null || selected === void 0 ? void 0 : selected.product
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons/* ChevronRightSvg */.dj, {})
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTable/* InfoTable */.C, {
                        dataSource: [
                            {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    "data-cy": "bond-status-label",
                                    children: "Status"
                                }),
                                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderStatusLabel, {
                                    isNegative: selected.status === bond/* BondOrderStatus.REJECTED */.ro.REJECTED,
                                    children: (ref1 = BondOrderStatusLabelMap[selected.status]) === null || ref1 === void 0 ? void 0 : ref1.toLocaleUpperCase()
                                })
                            },
                            {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    "data-cy": "bond-order-id-label",
                                    children: "Order ID"
                                }),
                                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    "data-cy": "bond-order-id-content",
                                    children: selected.id
                                })
                            },
                            {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    "data-cy": "bond-order-time-label",
                                    children: "Order Time"
                                }),
                                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    "data-cy": "bond-order-time-content",
                                    children: moment_default()(selected === null || selected === void 0 ? void 0 : selected.ordered_at).utc().format("DD MMM YY, HH:mm:ss")
                                })
                            },
                            {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    "data-cy": "bond-unit-label",
                                    children: action === bond/* BondTransactionActionEnum.BUY */.qB.BUY ? "Unit Pembelian" : "Unit Penjualan"
                                }),
                                value: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    "data-cy": "coupon-distribution-content",
                                    children: [
                                        selected === null || selected === void 0 ? void 0 : selected.trade_unit,
                                        " Unit"
                                    ]
                                })
                            },
                            {
                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    "data-cy": "bond-unit-label",
                                    children: action === bond/* BondTransactionActionEnum.BUY */.qB.BUY ? "Harga Beli (%)" : "Harga Jual (%)"
                                }),
                                value: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    "data-cy": "coupon-distribution-content",
                                    children: (0,number/* formatPercentage */.rl)(selected === null || selected === void 0 ? void 0 : selected.price_rate.toString(), false, "0,0.00", true)
                                })
                            }, 
                        ],
                        title: action === bond/* BondTransactionActionEnum.BUY */.qB.BUY ? "Buy Order" : "Sell Order"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: action === bond/* BondTransactionActionEnum.BUY */.qB.BUY,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondOrder_styled_Container, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderContentBuy, {
                                finalAmount: selected === null || selected === void 0 ? void 0 : selected.final_amount,
                                sellerAccruedInterest: selected === null || selected === void 0 ? void 0 : selected.accrued_interest_amount,
                                stampDuty: selected === null || selected === void 0 ? void 0 : (ref2 = selected.fee) === null || ref2 === void 0 ? void 0 : ref2.stamp_duty,
                                tradeAmount: selected === null || selected === void 0 ? void 0 : selected.trade_amount
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: action === bond/* BondTransactionActionEnum.SELL */.qB.SELL,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderContentSell, {
                            finalAmount: selected === null || selected === void 0 ? void 0 : selected.final_amount,
                            tradeAmount: selected === null || selected === void 0 ? void 0 : selected.trade_amount,
                            accruedInterest: selected === null || selected === void 0 ? void 0 : (ref3 = selected.fee) === null || ref3 === void 0 ? void 0 : ref3.accrued_interest_exclude_tax,
                            totalTax: selected === null || selected === void 0 ? void 0 : (ref4 = selected.fee) === null || ref4 === void 0 ? void 0 : ref4.total_tax,
                            stampDuty: selected === null || selected === void 0 ? void 0 : (ref5 = selected.fee) === null || ref5 === void 0 ? void 0 : ref5.stamp_duty,
                            capitalGain: selected === null || selected === void 0 ? void 0 : selected.capital_gain_loss,
                            profitLossAmount: selected === null || selected === void 0 ? void 0 : selected.profit_loss_nett.amount,
                            profitLossPercentage: selected === null || selected === void 0 ? void 0 : selected.profit_loss_nett.percentage,
                            sellerCoupon: selected === null || selected === void 0 ? void 0 : selected.seller_coupon,
                            accruedInterestExcludeTax: selected === null || selected === void 0 ? void 0 : (ref6 = selected.fee) === null || ref6 === void 0 ? void 0 : ref6.accrued_interest_exclude_tax,
                            estimationAmountExcludeTax: selected === null || selected === void 0 ? void 0 : (ref7 = selected.fee) === null || ref7 === void 0 ? void 0 : ref7.estimation_amount_exclude_tax,
                            realizedAmount: selected === null || selected === void 0 ? void 0 : selected.realized_amount
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondOrder_styled_Container, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Timeline, {
                            contents: selected === null || selected === void 0 ? void 0 : selected.status_timeline,
                            message: selected === null || selected === void 0 ? void 0 : (ref8 = selected.reject_reason) === null || ref8 === void 0 ? void 0 : ref8.message
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: (selected === null || selected === void 0 ? void 0 : selected.status) !== bond/* BondOrderStatus.REJECTED */.ro.REJECTED && (selected === null || selected === void 0 ? void 0 : selected.status) !== bond/* BondOrderStatus.SUCCEEDED */.ro.SUCCEEDED,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoPanel, {
                            text: "Estimasi pembelian kamu akan selesai dalam 2 sampai 3 hari kerja."
                        })
                    })
                ]
            })
        ]
    });
};
var _StyledModalBody = (0,styled_components_browser_esm/* default */.ZP)(ModalBonds_styled/* ModalBody */.fe).withConfig({
    componentId: "sc-6f2d436b-0"
})(ModalBondOrder_templateObject());

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondPortfolioStore.ts
var useBondPortfolioStore = __webpack_require__(29176);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalProductSelection/styled.ts

function ModalProductSelection_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 20px;\n  max-height: 560px;\n  overflow-y: scroll;\n  scrollbar-width: none;\n"
    ]);
    ModalProductSelection_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalProductSelection_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    ModalProductSelection_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalProductSelection_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 460px;\n\n  border-radius: 4px;\n  border: 1px solid #ededed;\n\n  padding: 12px 16px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n"
    ]);
    ModalProductSelection_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ModalProductSelection_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px solid #ededed;\n  padding-bottom: 12px;\n"
    ]);
    ModalProductSelection_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ModalProductSelection_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    ModalProductSelection_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var ScrollableContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-83fc53d1-0"
})(ModalProductSelection_styled_templateObject());
var ProductListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-83fc53d1-1"
})(ModalProductSelection_styled_templateObject1());
var ProductCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-83fc53d1-2"
})(ModalProductSelection_styled_templateObject2());
var ProductCardHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-83fc53d1-3"
})(ModalProductSelection_styled_templateObject3());
var ProductCardBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-83fc53d1-4"
})(ModalProductSelection_styled_templateObject4());

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalProductSelection/components/ProductListItem.tsx

function ProductListItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                width: 100px;\n                height: 30px;\n              "
    ]);
    ProductListItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










function ProductListItem(param) {
    var investmentModal = param.investmentModal, orderDate = param.orderDate, orderId = param.orderId, product = param.product, totalUnits = param.totalUnits, _isStableEarn = param.isStableEarn, isStableEarn = _isStableEarn === void 0 ? false : _isStableEarn;
    var FRBondActionTrackers = (0,useBondsAnalytics/* default */.Z)().FRBondActionTrackers;
    var openSellModal = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return s.openSellModal;
    });
    var onChooseClick = function() {
        FRBondActionTrackers.onOrderButtonClicked("Sell", product.id);
        openSellModal(product.id, orderId);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardHeader, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BondProductDisplay, {
                    product: product,
                    isStableEarn: isStableEarn,
                    cta: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListItem_StyledButton, {
                        type: "primary",
                        onClick: onChooseClick,
                        children: "Pilih"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardBody, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* FieldSet */.C3, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Modal Investasi"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                    children: [
                                        "Rp",
                                        (0,number/* formatNumber */.uf)(investmentModal, true, "0,0.00")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Jumlah Unit"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                    children: [
                                        totalUnits,
                                        " Unit"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "Tanggal Pembelian"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: moment_default()(orderDate).format("DD MMM YY, HH:mm")
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var ProductListItem_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-ab12df94-0"
})(ProductListItem_templateObject());

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalProductSelection/index.tsx








function ModalProductSelection() {
    var closeModal = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return s.closeModal;
    });
    var transactions = (0,useBondPortfolioStore/* useBondPortfolioStore */.Z)(function(s) {
        return s.transactions;
    });
    var product = (0,useBondPortfolioStore/* useBondPortfolioStore */.Z)(function(s) {
        return s.product;
    });
    var clearAssets = (0,useBondPortfolioStore/* useBondPortfolioStore */.Z)(function(s) {
        return s.clearAssets;
    });
    var onClose = function() {
        clearAssets();
        closeModal();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalContainer */.F0, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalHeader */.xB, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitle, {
                    title: "Pilih Produk untuk Dijual",
                    fontSize: "18px",
                    onClose: onClose,
                    isCentered: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalBody */.fe, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollableContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListContainer, {
                        children: transactions.map(function(transaction) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProductListItem, {
                                investmentModal: transaction.invested_amount,
                                orderDate: new Date(transaction.created_at),
                                orderId: transaction.order_code,
                                product: {
                                    icon_url: product === null || product === void 0 ? void 0 : product.icon_url,
                                    id: product === null || product === void 0 ? void 0 : product.identifier,
                                    min_order: "1",
                                    name: product === null || product === void 0 ? void 0 : product.label,
                                    type: bond/* BondProductTypeEnum.FR */.Sn.FR
                                },
                                totalUnits: parseInt(transaction.total_unit, 10),
                                isStableEarn: transaction === null || transaction === void 0 ? void 0 : transaction.is_stable_earn
                            }, transaction.order_code);
                        })
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/__mocks__/bonds.mock.ts

var BOND_PRODUCT_MOCK = {
    icon_url: undefined,
    id: "FR0081",
    min_order: "1",
    name: "Obligasi Fixed Rate Pemerintah",
    type: bond/* BondProductTypeEnum.FR */.Sn.FR
};
var BOND_ASSET_MOCK = [
    {
        investmentModal: 4000000,
        orderId: "ABC120",
        orderDate: new Date(),
        product: BOND_PRODUCT_MOCK,
        totalUnits: 4
    },
    {
        investmentModal: 3000000,
        orderId: "ABC121",
        orderDate: new Date(),
        product: BOND_PRODUCT_MOCK,
        totalUnits: 1
    },
    {
        investmentModal: 2000000,
        orderId: "ABC122",
        orderDate: new Date(),
        product: BOND_PRODUCT_MOCK,
        totalUnits: 1
    }, 
];

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondHistory/index.tsx


function ModalBondHistory_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  margin: 0;\n                "
    ]);
    ModalBondHistory_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalBondHistory_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          width: 502px;\n        "
    ]);
    ModalBondHistory_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}















function ModalBondHistory() {
    var ref;
    var closeModal = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return s.closeModal;
    });
    var selected = (0,useBondOrder/* useBondOrder */.o)(function(s) {
        return {
            selected: s.selected,
            isLoading: s.isLoading
        };
    }).selected;
    var productId = selected === null || selected === void 0 ? void 0 : (ref = selected.product) === null || ref === void 0 ? void 0 : ref.id;
    var action = (selected === null || selected === void 0 ? void 0 : selected.action) || bond/* BondTransactionActionEnum.BUY */.qB.BUY;
    var _obj;
    var actionLabel = (_obj = {}, (0,_define_property/* default */.Z)(_obj, bond/* BondTransactionActionEnum.BUY */.qB.BUY, ""), (0,_define_property/* default */.Z)(_obj, bond/* BondTransactionActionEnum.SELL */.qB.SELL, "Sell"), (0,_define_property/* default */.Z)(_obj, bond/* BondTransactionActionEnum.UNSPECIFIED */.qB.UNSPECIFIED, "Unspecified"), _obj)[action];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalContainer */.F0, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalHeader */.xB, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitle, {
                    title: "".concat(actionLabel, " ").concat(productId),
                    onClose: closeModal,
                    isCentered: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBondHistory_StyledModalBody, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* BorderedContainer */.a$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BondProductDisplay, {
                            product: BOND_PRODUCT_MOCK
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* BorderedContainer */.a$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* FieldSet */.C3, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: "Date"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: moment_default()(selected === null || selected === void 0 ? void 0 : selected.ordered_at).format("DD MMM YY, HH:mm:ss")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: "Unit"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: selected === null || selected === void 0 ? void 0 : selected.trade_unit
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                actionLabel,
                                                " Price (%)"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                (0,number/* formatNumber */.uf)(selected === null || selected === void 0 ? void 0 : selected.trade_amount, true, "0,0.00"),
                                                "%"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                actionLabel,
                                                " Amount"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: (0,utils/* formatBondCurrency */.uJ)(selected === null || selected === void 0 ? void 0 : selected.trade_amount)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: "Accrued Interest"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: (0,utils/* formatBondCurrency */.uJ)(selected === null || selected === void 0 ? void 0 : selected.trade_amount)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                                    condition: action === bond/* BondTransactionActionEnum.BUY */.qB.BUY,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: "Stamp Duty"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: (0,utils/* formatBondCurrency */.uJ)(selected === null || selected === void 0 ? void 0 : selected.trade_amount)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: "Total Payment"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    family: "bold",
                                                    children: (0,utils/* formatBondCurrency */.uJ)(selected === null || selected === void 0 ? void 0 : selected.trade_amount)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                                    condition: action === bond/* BondTransactionActionEnum.SELL */.qB.SELL,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: "Total Fee"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: (0,utils/* formatBondCurrency */.uJ)(selected === null || selected === void 0 ? void 0 : selected.trade_amount)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondHistory_StyledDivider, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    family: "bold",
                                                    children: "Total Amount"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    family: "bold",
                                                    children: (0,utils/* formatBondCurrency */.uJ)(selected === null || selected === void 0 ? void 0 : selected.trade_amount)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* Field */.gN, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    family: "bold",
                                                    children: "Realized Gain"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    family: "bold",
                                                    children: (0,utils/* formatBondCurrency */.uJ)(selected === null || selected === void 0 ? void 0 : selected.trade_amount)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var ModalBondHistory_StyledDivider = (0,styled_components_browser_esm/* default */.ZP)(divider/* default */.Z).withConfig({
    componentId: "sc-f2f64e78-0"
})(ModalBondHistory_templateObject());
var ModalBondHistory_StyledModalBody = (0,styled_components_browser_esm/* default */.ZP)(ModalBonds_styled/* ModalBody */.fe).withConfig({
    componentId: "sc-f2f64e78-1"
})(ModalBondHistory_templateObject1());

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondInformation/styled.ts

function ModalBondInformation_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 16px 0px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 14px;\n  line-height: 21px;\n\n  > p {\n    margin-bottom: 12px;\n  }\n\n  > p:last-of-type {\n    margin-bottom: 0px;\n  }\n\n  b {\n    font-weight: 700;\n  }\n"
    ]);
    ModalBondInformation_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ModalBondInformation_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8db2ec5a-0"
})(ModalBondInformation_styled_templateObject());

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondInformation/infoContent.tsx



var infoContent_obj;
var InfoContent = (infoContent_obj = {}, (0,_define_property/* default */.Z)(infoContent_obj, constants/* BondInfoType.UNSPECIFIED */.Im.UNSPECIFIED, {
    title: "Informasi Tidak tersedia",
    content: []
}), (0,_define_property/* default */.Z)(infoContent_obj, constants/* BondInfoType.ACCRUED_INTEREST */.Im.ACCRUED_INTEREST, {
    title: "Kupon Berjalan",
    content: [
        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: "Sebelum kupon pertama diterima:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Kupon yang kamu bayar pada saat pembelian + Kupon Harian yang akan kamu terima pada kupon date selanjutnya."
            ]
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: "Sesudah kupon pertama diterima:"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                "Total kupon harian dari tanggal pembagian kupon terakhir hingga tanggal hari ini."
            ]
        }), 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, constants/* BondInfoType.ACCRUED_INTEREST_SELLER */.Im.ACCRUED_INTEREST_SELLER, {
    title: "Kupon Penjual",
    content: [
        "Kupon yang perlu dibayarkan oleh pembeli sebagai hak yang harus diterima oleh penjual.",
        "Nominal kupon ini akan kamu terima kembali pada tanggal pencairan kupon berikutnya atau ketika kamu menjual unit kamu.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, constants/* BondInfoType.CAPITAL_GAIN_LOSS */.Im.CAPITAL_GAIN_LOSS, {
    title: "Capital Gain / Loss",
    content: [
        "Capital Gain = Nilai Sekarang - Modal Investasi",
        "Merupakan keuntungan atau kerugian dari selisih nilai sekarang dan modal investasi jika kamu menjual obligasi FR kamu pada saat ini.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, constants/* BondInfoType.PNL_UNREALIZED */.Im.PNL_UNREALIZED, {
    title: "P&L (Unrealized)",
    content: [
        "P&L = Kupon Berjalan + Capital Gain",
        "Total keuntungan atau kerugian yang akan kamu dapatkan ketika kamu melakukan penjualan saat ini belum termasuk pajak dan bea materai.",
        "Perhitungan P&L (Unrealized) tidak termasuk total kupon yang sudah kamu terima sebelumnya", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, constants/* BondInfoType.TOTAL_DAILY_COUPON */.Im.TOTAL_DAILY_COUPON, {
    title: "Total Kupon Harian",
    content: [
        "Total kupon yang merupakan hak kamu yang diakumulasi setiap hari dari tanggal pembelian termasuk kupon yang telah kamu terima.",
        "Namun tidak menghitung kupon berjalan yang kamu bayarkan pada saat pembelian.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, constants/* BondInfoType.TOTAL_INVESTMENT_PROFIT */.Im.TOTAL_INVESTMENT_PROFIT, {
    title: "Total Keuntungan Selama Investasi",
    content: [
        "Total Keuntungan = Total Kupon Harian + Capital Gain",
        "Total keuntungan (selama investasi) merupakan seluruh keuntungan/kerugian selama kamu memegang obligasi FR ini.",
        "Total keuntungan tersebut merupakan seluruh kupon yang telah/akan kamu terima dan Capital Gain / Loss pada saat penjualan saat ini.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, constants/* BondInfoType.TOTAL_UNIT */.Im.TOTAL_UNIT, {
    title: "Total Unit Obligasi",
    content: [
        "1 Unit Obligasi senilai dengan Rp1,000,000"
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, constants/* BondInfoType.PROJECTED_RETURN */.Im.PROJECTED_RETURN, {
    title: "Proyeksi Return",
    content: [
        "Proyeksi keuntungan dari investasi kamu pada saat jatuh tempo"
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, constants/* BondInfoType.PNL_NETT */.Im.PNL_NETT, {
    title: "P&L (Nett)",
    content: [
        "P&L = Kupon Berjalan + Capital Gain - Pajak",
        "Total keuntungan atau kerugian yang akan kamu dapatkan ketika kamu melakukan penjualan saat ini yang sudah termasuk pajak dan bea meterai.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, constants/* BondInfoType.TOTAL_PROFIT_NETT */.Im.TOTAL_PROFIT_NETT, {
    title: "Total Keuntungan (Nett)",
    content: [
        "Total Keuntungan = Total Kupon Harian + Capital Gain",
        "Total keuntungan (selama investasi) merupakan seluruh keuntungan/kerugian selama kamu memegang obligasi FR ini.",
        "Total keuntungan tersebut merupakan seluruh kupon yang telah/akan kamu terima dan Capital Gain / Loss pada saat penjualan saat ini.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, constants/* BondInfoType.BUYING_PRICE */.Im.BUYING_PRICE, {
    title: "Harga Beli",
    content: [
        "Harga indikatif (dalam satuan persentase) yang mengindikasikan harga beli Obligasi di Pasar Sekunder saat ini.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, constants/* BondInfoType.SELLING_PRICE */.Im.SELLING_PRICE, {
    title: "Harga Jual",
    content: [
        "Harga indikatif (dalam satuan persentase) yang mengindikasikan harga jual Obligasi di Pasar Sekunder saat ini.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, constants/* BondInfoType.PROFIT */.Im.PROFIT, {
    title: "Keuntungan",
    content: [
        "Keuntungan dihitung berdasarkan pergerakan harga dari produk Obligasi FR.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, constants/* BondInfoType.CASH_ON_HAND */.Im.CASH_ON_HAND, {
    title: "Cash on Hand",
    content: [
        "Saldo RDN yang telah mengalami Siklus Penyelesaian T+2 hari bursa.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, constants/* BondInfoType.TAX */.Im.TAX, {
    title: "Pajak",
    content: [
        "Pajak sebesar 10% dikenakan dari nilai capital gain unit FR yang kamu jual. Penjualan kamu tidak dikenakan pajak apabila kamu sedang mengalami kerugian.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, constants/* BondInfoType.BOND_TAX */.Im.BOND_TAX, {
    title: "Pajak Obligasi",
    content: [
        "Pajak sebesar 10% dikenakan dari nilai capital gain unit FR yang kamu jual. Penjualan kamu tidak dikenakan pajak apabila kamu sedang mengalami kerugian.", 
    ]
}), (0,_define_property/* default */.Z)(infoContent_obj, constants/* BondInfoType.USER_COUPON */.Im.USER_COUPON, {
    title: "Kupon Hak Kamu",
    content: [
        "Kupon Hak Kamu = Kupon Diterima - Kupon Penjual",
        "Total kupon diterima yang merupakan hak kamu setelah dikurangi kupon yang kamu bayarkan kepada penjual pada saat pembelian.", 
    ]
}), infoContent_obj);
/* harmony default export */ var infoContent = (InfoContent);

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondInformation/index.tsx


function ModalBondInformation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            width: 375px;\n          "
    ]);
    ModalBondInformation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













function ModalBondInformation() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useBondInfoModal/* useBondInfoModal */.e)(function(s) {
        return [
            s.modalInfoType,
            s.closeInfoModal, 
        ];
    }), 2), modalInfoType = ref[0], closeInfoModal = ref[1];
    var portfolioProduct = (0,useBondPortfolioStore/* useBondPortfolioStore */.Z)(function(s) {
        return s.product;
    });
    var _modalInfoType = infoContent[modalInfoType], content = _modalInfoType.content, title = _modalInfoType.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalRoot */.Y0, {
        visible: modalInfoType !== constants/* BondInfoType.UNSPECIFIED */.Im.UNSPECIFIED,
        onCancel: closeInfoModal,
        zIndex: 2000,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalContainer */.F0, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalHeader */.xB, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justify: "between",
                        align: "center",
                        w: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                family: "bold",
                                size: "18px",
                                // @ts-expect-error
                                mt: "0",
                                width: "100%",
                                "data-cy": "bonds-modal-header",
                                align: "center",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                className: "icon-trading_x",
                                color: "#333333",
                                size: "12px",
                                onClick: closeInfoModal
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondInformation_StyledModalBody, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondInformation_styled_Container, {
                        children: content.map(function(item, i) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    item,
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                                        condition: modalInfoType === constants/* BondInfoType.PROJECTED_RETURN */.Im.PROJECTED_RETURN,
                                        children: [
                                            " ",
                                            moment_default()(portfolioProduct === null || portfolioProduct === void 0 ? void 0 : (ref = portfolioProduct.meta) === null || ref === void 0 ? void 0 : ref.maturity_date).format("DD MMMM YYYY")
                                        ]
                                    })
                                ]
                            }, "content-item-".concat(i + 1));
                        })
                    })
                })
            ]
        })
    });
};
var ModalBondInformation_StyledModalBody = (0,styled_components_browser_esm/* default */.ZP)(ModalBonds_styled/* ModalBody */.fe).withConfig({
    componentId: "sc-4020f6bd-0"
})(ModalBondInformation_templateObject());

// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondTax/styled.ts

function ModalBondTax_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 16px 0px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  border: 1px solid #ededed;\n  border-radius: 4px;\n"
    ]);
    ModalBondTax_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalBondTax_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"
    ]);
    ModalBondTax_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ModalBondTax_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 0;\n"
    ]);
    ModalBondTax_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var ModalBondTax_styled_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-12340d50-0"
})(ModalBondTax_styled_templateObject());
var Field = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-12340d50-1"
})(ModalBondTax_styled_templateObject1());
var FieldSet = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-12340d50-2"
})(ModalBondTax_styled_templateObject2());

;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/components/ModalBondTax/index.tsx


function ModalBondTax_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                  margin: 0px;\n                "
    ]);
    ModalBondTax_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ModalBondTax_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            width: 375px;\n          "
    ]);
    ModalBondTax_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














function ModalBondTax() {
    var ref = (0,_sliced_to_array/* default */.Z)(useBondTaxStore(function(s) {
        return [
            s.isVisible,
            s.closeTaxModal,
            s.accruedInterest,
            s.pl,
            s.amount,
            s.totalTax, 
        ];
    }, shallow/* default */.Z), 6), isVisible = ref[0], closeTaxModal = ref[1], accruedInterest = ref[2], pl = ref[3], amount = ref[4], totalTax = ref[5];
    var isFree = totalTax <= 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalRoot */.Y0, {
        visible: isVisible,
        onCancel: closeTaxModal,
        zIndex: 2000,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBonds_styled/* ModalContainer */.F0, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalHeader */.xB, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        justify: "between",
                        align: "center",
                        w: "100%",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                family: "bold",
                                size: "18px",
                                // @ts-expect-error
                                mt: "0",
                                width: "100%",
                                "data-cy": "bonds-modal-header",
                                align: "center",
                                children: "Pajak Obligasi"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                className: "icon-trading_x",
                                color: "#333333",
                                size: "12px",
                                onClick: closeTaxModal
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBondTax_StyledModalBody, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalBondTax_styled_Container, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FieldSet, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Field, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        children: "Kupon Berjalan Kena Pajak"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                                        amount: accruedInterest,
                                                        isColorless: true,
                                                        isHidePositiveSign: true
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Field, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: pl >= 0 ? "Keuntungan" : "Kerugian"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                                        amount: pl,
                                                        isHidePositiveSign: true,
                                                        isColorless: true
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondTax_StyledDivider, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Field, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "Nominal Kena Pajak"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PnLCurrency/* default */.Z, {
                                                amount: amount,
                                                isHidePositiveSign: true,
                                                isColorless: true
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondTax_styled_Container, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Field, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Pajak Obligasi (10%)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: !isFree,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            family: "bold",
                                            children: (0,utils/* formatBondCurrency */.uJ)(totalTax)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: isFree,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            family: "bold",
                                            color: _style_color/* default.primary */.Z.primary,
                                            children: "Bebas Pajak"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var ModalBondTax_StyledDivider = (0,styled_components_browser_esm/* default */.ZP)(divider/* default */.Z).withConfig({
    componentId: "sc-c21aa004-0"
})(ModalBondTax_templateObject());
var ModalBondTax_StyledModalBody = (0,styled_components_browser_esm/* default */.ZP)(ModalBonds_styled/* ModalBody */.fe).withConfig({
    componentId: "sc-c21aa004-1"
})(ModalBondTax_templateObject1());

// EXTERNAL MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/stores/useBondError.ts
var useBondError = __webpack_require__(10893);
;// CONCATENATED MODULE: ./src/global/TradingModal/RealTradingModal/ModalBonds/index.tsx























var useBondErrorStore = (0,esm/* default */.ZP)(useBondError/* default */.Z);
function ModalBonds() {
    var router = (0,next_router.useRouter)();
    var ref = useBondErrorStore(function(s) {
        return {
            blockerType: s.blockerType,
            resetErrorCode: s.resetErrorCode,
            error: s.errorCode
        };
    }), blockerType = ref.blockerType, resetErrorCode = ref.resetErrorCode, error = ref.error;
    var ref1 = (0,useBondsModalStore/* useBondsModalStore */.H)(function(s) {
        return {
            modalType: s.modalType,
            closeModal: s.closeModal,
            clearModal: s.clear,
            transactionType: s.transactionType,
            openBlockerModal: s.openBlockerModal,
            closeTransactionModal: s.closeTransactionModal,
            reOpenTransactionModal: s.reOpenTransactionModal
        };
    }), modalType = ref1.modalType, closeModal = ref1.closeModal, clearModal = ref1.clearModal, transactionType = ref1.transactionType, openBlockerModal = ref1.openBlockerModal, closeTransactionModal = ref1.closeTransactionModal, reOpenTransactionModal = ref1.reOpenTransactionModal;
    var ref2 = (0,useBondTransaction/* useBondTransaction */.P)(function(s) {
        return {
            productId: s.productId,
            clearTransaction: s.clearData,
            reInitiateTransaction: s.reInitiateTransaction
        };
    }), productId = ref2.productId, clearTransaction = ref2.clearTransaction, reInitiateTransaction = ref2.reInitiateTransaction;
    var handleOrderPlacedClose = function() {
        clearModal();
        clearTransaction();
        closeModal();
        router.push("/securities/order/?t=".concat(Date.now()));
    };
    var handleBlockerClose = function() {
        resetErrorCode();
        clearTransaction();
        closeModal();
    };
    var handleReturnToTransactionModal = function() {
        reOpenTransactionModal();
        reInitiateTransaction();
    };
    (0,react.useEffect)(function() {
        if (!error) {
            return;
        }
        if (modalType === constants/* BondsModalTypeEnum.BLOCKERS */._y.BLOCKERS) {
            return;
        }
        // if only alert, we immidately reset the error code
        if (!blockerType) {
            resetErrorCode();
            return;
        }
        openBlockerModal(blockerType);
    }, [
        blockerType,
        modalType,
        error
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalRoot */.Y0, {
                visible: modalType === constants/* BondsModalTypeEnum.BLOCKERS */._y.BLOCKERS,
                onCancel: handleBlockerClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondBlockers, {
                    onClose: handleBlockerClose
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalRoot */.Y0, {
                visible: modalType === constants/* BondsModalTypeEnum.CONFIRMATION */._y.CONFIRMATION,
                onCancel: closeModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondConfirm, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                condition: modalType === constants/* BondsModalTypeEnum.TRANSACTION */._y.TRANSACTION,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: transactionType === bond/* BondTransactionActionEnum.BUY */.qB.BUY,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalRoot */.Y0, {
                            visible: modalType === constants/* BondsModalTypeEnum.TRANSACTION */._y.TRANSACTION && transactionType === bond/* BondTransactionActionEnum.BUY */.qB.BUY,
                            onCancel: closeTransactionModal,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondsBuy, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: transactionType === bond/* BondTransactionActionEnum.SELL */.qB.SELL,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalRoot */.Y0, {
                            visible: modalType === constants/* BondsModalTypeEnum.TRANSACTION */._y.TRANSACTION && transactionType === bond/* BondTransactionActionEnum.SELL */.qB.SELL,
                            onCancel: closeTransactionModal,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondSell, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondTnC, {
                visible: modalType === constants/* BondsModalTypeEnum.TNC */._y.TNC,
                onCancel: closeModal
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalRoot */.Y0, {
                visible: modalType === constants/* BondsModalTypeEnum.ORDER */._y.ORDER,
                onCancel: closeModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondOrder, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalRoot */.Y0, {
                visible: modalType === constants/* BondsModalTypeEnum.HISTORY */._y.HISTORY,
                onCancel: closeModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondHistory, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBonds_styled/* ModalRoot */.Y0, {
                visible: modalType === constants/* BondsModalTypeEnum.ASSETS */._y.ASSETS,
                onCancel: closeModal,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalProductSelection, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderPlacedModal/* default */.Z, {
                visible: modalType === constants/* BondsModalTypeEnum.ORDER_PLACED */._y.ORDER_PLACED,
                onSubmit: handleOrderPlacedClose,
                orderType: trading/* ORDER_TYPE.BOND */.Jm.BOND,
                onReturnToTransaction: handleReturnToTransactionModal,
                onCloseModal: closeModal,
                returnTransactionLabel: "Return to ".concat(productId)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondInformation, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBondTax, {})
        ]
    });
};


/***/ }),

/***/ 32471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ useBondInfoModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14671);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38875);




var initialState = {
    modalInfoType: _constants__WEBPACK_IMPORTED_MODULE_0__/* .BondInfoType.UNSPECIFIED */ .Im.UNSPECIFIED
};
var useBondInfoModal = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, initialState), {
        openInfoModal: function openInfoModal(infoType) {
            set({
                modalInfoType: infoType
            });
        },
        closeInfoModal: function closeInfoModal() {
            set({
                modalInfoType: _constants__WEBPACK_IMPORTED_MODULE_0__/* .BondInfoType.UNSPECIFIED */ .Im.UNSPECIFIED
            });
        }
    });
});


/***/ }),

/***/ 29176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBondPortfolioStore; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14671);
/* harmony import */ var global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64924);
/* harmony import */ var utils_securities_transformData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75413);








var initialState = {
    detailBySymbol: undefined,
    details: undefined,
    portfolios: [],
    bondPortfolioState: [],
    transactions: [],
    product: undefined,
    couponHistories: undefined,
    isLoading: false,
    isLoadingList: false
};
var useBondPortfolioStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, initialState), {
        loadPortfolioList: function loadPortfolioList() {
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data, portfolios, rest;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoadingList: true
                            });
                            _ctx.next = 4;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondPortfolioList */ .yr)();
                        case 4:
                            response = _ctx.sent;
                            data = response.data.data;
                            portfolios = data.portfolios, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(data, [
                                "portfolios"
                            ]);
                            set({
                                portfolios: portfolios,
                                bondPortfolioState: portfolios.map(utils_securities_transformData__WEBPACK_IMPORTED_MODULE_2__/* ["default"].portfolioItemFromBonds */ .Z.portfolioItemFromBonds),
                                details: rest,
                                isLoadingList: false
                            });
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoadingList: false,
                                portfolios: initialState.portfolios,
                                details: initialState.details,
                                bondPortfolioState: initialState.bondPortfolioState
                            });
                            Promise.reject(_ctx.t0);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }))();
        },
        loadPortfolioDetails: function loadPortfolioDetails(id) {
            var withCouponHistories = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response, data, transactions, coupon_histories, product, rest;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            set({
                                isLoading: true
                            });
                            _ctx.next = 4;
                            return (0,global_Securities_api_bond__WEBPACK_IMPORTED_MODULE_1__/* .getBondPortfolioDetail */ .IE)(id, withCouponHistories);
                        case 4:
                            response = _ctx.sent;
                            data = response.data.data;
                            transactions = data.transactions, coupon_histories = data.coupon_histories, product = data.product, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(data, [
                                "transactions",
                                "coupon_histories",
                                "product"
                            ]);
                            set({
                                transactions: transactions,
                                product: product,
                                couponHistories: coupon_histories,
                                detailBySymbol: rest,
                                isLoading: false
                            });
                            _ctx.next = 14;
                            break;
                        case 10:
                            _ctx.prev = 10;
                            _ctx.t0 = _ctx["catch"](0);
                            set({
                                isLoading: false
                            });
                            Promise.reject(_ctx.t0);
                        case 14:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        10
                    ]
                ]);
            }))();
        },
        clear: function clear() {
            set(initialState);
        },
        clearPortfolioList: function clearPortfolioList() {
            set({
                portfolios: initialState.portfolios,
                transactions: initialState.transactions,
                product: initialState.product
            });
        },
        clearAssets: function clearAssets() {
            set({
                transactions: initialState.transactions,
                detailBySymbol: initialState.detailBySymbol
            });
        }
    });
});


/***/ }),

/***/ 70098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C3": function() { return /* binding */ FieldSet; },
/* harmony export */   "CQ": function() { return /* binding */ CouponHistoryContainer; },
/* harmony export */   "F0": function() { return /* binding */ ModalContainer; },
/* harmony export */   "OT": function() { return /* binding */ UnitInput; },
/* harmony export */   "Y0": function() { return /* binding */ ModalRoot; },
/* harmony export */   "a$": function() { return /* binding */ BorderedContainer; },
/* harmony export */   "fe": function() { return /* binding */ ModalBody; },
/* harmony export */   "gN": function() { return /* binding */ Field; },
/* harmony export */   "mz": function() { return /* binding */ ModalFooter; },
/* harmony export */   "pT": function() { return /* binding */ TextLoadingShimmer; },
/* harmony export */   "w2": function() { return /* binding */ HistoryGroupContainer; },
/* harmony export */   "xB": function() { return /* binding */ ModalHeader; },
/* harmony export */   "xJ": function() { return /* binding */ FormItem; }
/* harmony export */ });
/* unused harmony export InputSectionWrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16368);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7648);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38875);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-height: 264px;\n  min-width: 415px;\n\n  padding: 20px;\n\n  max-width: 100%;\n\n  .ant-modal-close {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      min-width: 503px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  min-height: 126px;\n\n  background-color: #ffffff;\n  border-radius: 4px;\n  padding: 24px;\n  margin-bottom: 16px;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-form-item {\n    margin-bottom: 20px;\n  }\n  .ant-slider-rail {\n    background-color: #dadada;\n    display: block;\n  }\n  .ant-row.ant-form-item {\n    height: 24px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-bottom: 1px solid #dadada;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-right: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  padding: 0;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 16px 20px;\n  margin: 16px 0px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  border: 1px solid #ededed;\n  border-radius: 4px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: block;\n  background-color: #ededed;\n  border-radius: 4px;\n  height: ",
        ";\n  width: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-form-item-control-input {\n    background-color: ",
        ";\n    border: ",
        ";\n    padding-left: ",
        ";\n    color: ",
        ";\n    border-radius: 2px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  /* Firefox */\n  -moz-appearance: textfield !important;\n\n  :focus::placeholder {\n    color: transparent;\n  }\n  ::placeholder {\n    letter-spacing: -1px;\n  }\n\n  /* Chrome, Safari, Edge, Opera */\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n\n    margin: 0;\n  }\n\n  caret-color: #1db87a;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  width: 100%;\n  padding: 8px 0px;\n  border-bottom: 1px solid #f1f1f1;\n\n  :last-of-type {\n    border-bottom: none;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  padding: 0px 2px;\n\n  min-height: 360px;\n  max-height: 400px;\n\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  scroll-behavior: smooth;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}




var ModalRoot = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    width: "auto",
    type: "transparent",
    centered: true
}).withConfig({
    componentId: "sc-38eda78f-0"
})(_templateObject());
var ModalContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-1"
})(_templateObject2(), function(p) {
    return p.modalType === _constants__WEBPACK_IMPORTED_MODULE_2__/* .BondsModalTypeEnum.TRANSACTION */ ._y.TRANSACTION && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject1());
});
var ModalHeader = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-2"
})(_templateObject3());
var ModalBody = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-3"
})(_templateObject4());
var ModalFooter = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-4"
})(_templateObject5());
var InputSectionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-5"
})(_templateObject6());
var Field = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-6"
})(_templateObject7(), function(p) {
    return p.isAccordion ? "16px" : 0;
});
var FieldSet = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-7"
})(_templateObject8());
var BorderedContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-8"
})(_templateObject9());
var TextLoadingShimmer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-9"
})(_templateObject10(), function(p) {
    return p.height || "16px";
}, function(p) {
    return p.width || "100%";
});
var FormItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Item */ .Z.Item).withConfig({
    componentId: "sc-38eda78f-10"
})(_templateObject11(), function(props) {
    return props.disabled ? "#f7f7f7" : "transparent";
}, function(props) {
    return props.disabled ? "1px solid #dadada" : "none";
}, function(props) {
    return props.disabled ? "8px" : "unset";
}, function(props) {
    return props.disabled ? "#858585" : "unset";
});
var UnitInput = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-38eda78f-11"
})(_templateObject12());
var HistoryGroupContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-12"
})(_templateObject13());
var CouponHistoryContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-38eda78f-13"
})(_templateObject14());


/***/ }),

/***/ 29735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useBondsAnalytics; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48028);



var EVENTS_NAMES = {
    bondsPageViewed: "FR Bonds Page Viewed",
    bondProductPageViewed: "FR Bonds Product Page Viewed",
    bondOrderPageViewed: "FR Bonds Order Page Viewed",
    bondPreviewOrderViewed: "FR Bonds Preview Order Viewed",
    bondOrderSuccessViewed: "FR Bonds Order Success Viewed",
    bondsAction: "FR Bonds Action"
};
var PAGE_NAMES = {
    "/stream": "Stream Page",
    "/symbol": "Product Page",
    "/securities": "Portofolio List",
    "/watchlist": "Watchlist Page",
    "/screener": "Screener Page",
    "/valuation": "Valuation Page",
    "/sector": "Sector Page",
    "/community": "Community Page"
};
function useBondsAnalytics() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    // fill the search related page
    var defaultPageSource = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var pageNames = Object.keys(PAGE_NAMES);
        var pageIndex = pageNames.find(function(path) {
            return router.pathname.startsWith(path) ? path : undefined;
        });
        if (pageIndex) {
            return PAGE_NAMES[pageIndex];
        }
        return "Search Page";
    }, [
        router.pathname
    ]);
    var FRBondsNavigateTrackers = {
        // When user landing on FR Bonds page
        onBondPageViewed: function onBondPageViewed(section) {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsPageViewed, {
                Section: section
            });
        },
        // When user landing on FR Bonds Product page
        onBondProductPageViewed: function onBondProductPageViewed(symbol, yieldValue) {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondProductPageViewed, {
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user landing on FR Bonds Order page
        onBondOrderPageViewed: function onBondOrderPageViewed(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondOrderPageViewed, {
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user landing on FR Bonds Preview Order page
        onBondPreviewOrderViewed: function onBondPreviewOrderViewed(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondPreviewOrderViewed, {
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user landing on FR Bonds Order Success page
        onBondOrderSuccessViewed: function onBondOrderSuccessViewed(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondOrderSuccessViewed, {
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        }
    };
    var FRBondActionTrackers = {
        // When user click FR Bonds introduction banner
        onIntroductionBannerClicked: function onIntroductionBannerClicked(sourcePage) {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "Introduction Banner Clicked",
                SourcePage: sourcePage || defaultPageSource
            });
        },
        // When user click “Saya Setuju” on FR Bonds TnC
        onTnCConfirmed: function onTnCConfirmed() {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "TnC Confirmed"
            });
        },
        // When user click FR Bonds Section/Catalog to be redirected to FR Bonds list
        onFRProductListClicked: function onFRProductListClicked(sourcePage) {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "FR Product List Clicked",
                SourcePage: sourcePage || defaultPageSource
            });
        },
        // When user click buy/sell button on FR product to initiate order
        onOrderButtonClicked: function onOrderButtonClicked(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "FR Order Button Clicked",
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user click buy/sell button on FR order page to finalize order
        onOrderPlaced: function onOrderPlaced(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "FR Order Placed",
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        },
        // When user click buy/sell button on FR order page, confirming the order
        onOrderConfirmed: function onOrderConfirmed(orderType, symbol, sourcePage) {
            var yieldValue = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "-";
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(EVENTS_NAMES.bondsAction, {
                Action: "FR Order Confirmed",
                SourcePage: sourcePage || defaultPageSource,
                "Order Type": orderType,
                Symbol: symbol,
                Yield: yieldValue
            });
        }
    };
    return {
        FRBondsNavigateTrackers: FRBondsNavigateTrackers,
        FRBondActionTrackers: FRBondActionTrackers
    };
};


/***/ }),

/***/ 61227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AP": function() { return /* binding */ CustomSelect; },
/* harmony export */   "Jm": function() { return /* binding */ TabPane; },
/* harmony export */   "UE": function() { return /* binding */ TabWrapper; },
/* harmony export */   "XZ": function() { return /* binding */ Checkbox; },
/* harmony export */   "av": function() { return /* binding */ TriggerPriceInfo; },
/* harmony export */   "d2": function() { return /* binding */ TriggerPriceSelect; },
/* harmony export */   "hv": function() { return /* binding */ DayTradeInfoBanner; },
/* harmony export */   "iR": function() { return /* binding */ Slider; },
/* harmony export */   "mQ": function() { return /* binding */ Tabs; },
/* harmony export */   "yJ": function() { return /* binding */ AutoBuySubmitButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Checkbox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81190);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_trading_Slider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22613);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76750);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-tabs-nav-list {\n    width: 100%;\n  }\n  .ant-tabs-nav-list {\n    .ant-tabs-tab {\n      width: 50%;\n      text-align: center;\n      font-family: var(--bold-font);\n\n      &.ant-tabs-tab-active {\n        color: ",
        ";\n        .ant-tabs-tab-btn {\n          color: ",
        ";\n        }\n      }\n\n      .ant-tabs-tab-btn {\n        width: 100%;\n        color: ",
        ";\n\n        :hover {\n          color: ",
        ";\n        }\n      }\n    }\n  }\n\n  .ant-tabs-ink-bar {\n    background-color: #0bba7a !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  border: solid 1px ",
        ";\n  height: 32px;\n  padding: 0 10px;\n  border-radius: 2px;\n\n  /* Add style when disabled*/\n  &:disabled {\n    color: #b5b5b5;\n    background: #f5f5f5;\n    cursor: not-allowed;\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 36px;\n  width: 36px;\n  margin-right: 0px;\n  text-indent: 0;\n  padding-left: 5px;\n  padding-right: 16px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  bottom: -55px;\n  width: 100%;\n\n  :disabled {\n    background: #616161;\n    border-color: #616161;\n    color: #bcbcbc;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {\n    color: ",
        " !important;\n  }\n\n  .ant-tabs-tab-active {\n    color: ",
        " !important;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-slider-step {\n    background-color: ",
        " !important;\n    height: 4px;\n    top: 4px;\n    z-index: 0;\n    border-radius: 2px;\n  }\n\n  .ant-slider-track {\n    border-radius: 2px;\n    height: 4px;\n    z-index: 1;\n  }\n\n  .ant-slider-handle {\n    z-index: 2;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-checkbox-checked .ant-checkbox-inner,\n  .ant-checkbox-indeterminate .ant-checkbox-inner {\n    background-color: #0bba7a;\n    border-color: #0bba7a;\n  }\n\n  .ant-checkbox-wrapper:hover .ant-checkbox-inner,\n  .ant-checkbox:hover .ant-checkbox-inner,\n  .ant-checkbox-input:focus + .ant-checkbox-inner {\n    border-color: #0bba7a !important;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  max-width: 318px;\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  background: #f2f1fe;\n  border-radius: 4px;\n  margin-top: 16px;\n  color: #333333;\n  font-size: 12px;\n  line-height: 16px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 2px;\n\n  .icon {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 2px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}






var BaseTabPane = antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"].TabPane */ .Z.TabPane;
var TabWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-be087765-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].mountainMeadow */ .Z.mountainMeadow, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].mountainMeadow */ .Z.mountainMeadow, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].highgray */ .Z.highgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].highgray */ .Z.highgray);
var CustomSelect = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].select.withConfig */ .ZP.select.withConfig({
    componentId: "sc-be087765-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gainsboro */ .Z.gainsboro);
var TriggerPriceSelect = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(CustomSelect).withConfig({
    componentId: "sc-be087765-2"
})(_templateObject2());
var AutoBuySubmitButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-be087765-3"
})(_templateObject3());
var TabPane = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(BaseTabPane).withConfig({
    componentId: "sc-be087765-4"
})(_templateObject4());
var Tabs = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-be087765-5"
})(_templateObject5(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary);
var Slider = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_trading_Slider__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-be087765-6"
})(_templateObject6(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gainsboro */ .Z.gainsboro);
var Checkbox = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Checkbox__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-be087765-7"
})(_templateObject7());
var DayTradeInfoBanner = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-be087765-8"
})(_templateObject8());
var TriggerPriceInfo = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-be087765-9"
})(_templateObject9());



/***/ }),

/***/ 77017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_SearchCompany; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tag.js
var Tag = __webpack_require__(12484);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Input.js
var Input = __webpack_require__(54325);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./src/global/TradingModal/constant.ts
var constant = __webpack_require__(29097);
// EXTERNAL MODULE: ./src/global/TradingModal/components/SearchCompany/slice.ts
var slice = __webpack_require__(33908);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Autocomplete.js
var Autocomplete = __webpack_require__(94526);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
;// CONCATENATED MODULE: ./src/global/TradingModal/components/SearchCompany/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 8px;\n  border: 1px solid ",
        ";\n  color: ",
        ";\n  width: fit-content;\n  :hover {\n    background: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: ",
        ";\n  background: ",
        ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  padding: 15px 16px;\n  z-index: 2;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  border-left: none;\n  border-radius: 2px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 99999 !important;\n  .rc-virtual-list-holder-inner > :first-child {\n    display: none !important;\n  }\n\n  .ant-select-dropdown {\n    width: 60% !important;\n    top: -55px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  &:focus {\n    border-right-width: 0px !important;\n  }\n  &:hover {\n    border-right-width: 0px !important;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  top: 60px;\n  right: 60px;\n  cursor: pointer;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







var Relative = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1b956054-0"
})(_templateObject(), color/* default.light */.Z.light);
var CatalogItem = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    size: "13px",
    p: "3px 5px"
}).withConfig({
    componentId: "sc-1b956054-1"
})(_templateObject1(), color/* default.primary */.Z.primary, color/* default.primary */.Z.primary, color/* default.primary */.Z.primary, color/* default.light */.Z.light);
var SearchBarWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-1b956054-2"
})(_templateObject2(), // @ts-expect-error
function(param) {
    var _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible;
    return isVisible ? "flex" : "none";
}, color/* default.light */.Z.light);
var IconClose = (0,styled_components_browser_esm/* default */.ZP)(Iconmoon/* IconWrapper */.a).withConfig({
    componentId: "sc-1b956054-3"
})(_templateObject3(), color/* default.lowgray */.Z.lowgray, color/* default.light */.Z.light);
var styled_Autocomplete = (0,styled_components_browser_esm/* default */.ZP)(Autocomplete/* default */.Z).withConfig({
    componentId: "sc-1b956054-4"
})(_templateObject4());
var CustomInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-1b956054-5"
})(_templateObject5());
var IconmoonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1b956054-6"
})(_templateObject6());


;// CONCATENATED MODULE: ./src/global/TradingModal/components/SearchCompany/index.tsx
/* eslint-disable react-hooks/exhaustive-deps */ 













var SearchCompany_Tag = Tag/* default.Tag */.Z.Tag;
var checkIsBonds = function() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return text.indexOf("FR") >= 0;
};
var SearchCompany = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var updateSymbol = param.updateSymbol, isInTradingModal = param.isInTradingModal, _isBonds = param.isBonds, isBonds = _isBonds === void 0 ? false : _isBonds;
    var dispatch = (0,es/* useDispatch */.I0)();
    var _$ref = (0,es/* useSelector */.v9)(slice/* selectors */.wl), searchResult = _$ref.result;
    var result = isBonds ? searchResult === null || searchResult === void 0 ? void 0 : searchResult.filter(function(item) {
        return checkIsBonds(item === null || item === void 0 ? void 0 : item.desc);
    }) : searchResult;
    var debouncedSearch = (0,react.useCallback)(lodash_debounce_default()(function(value) {
        dispatch(slice/* effects.getSearchResult */.Sz.getSearchResult(value));
    }, 500), []);
    var onChange = function(e) {
        var value = e.target.value;
        debouncedSearch(value);
    };
    var onSelect = function(name, isSelectedBonds) {
        dispatch(slice/* default.actions.resetResult */.ZP.actions.resetResult());
        updateSymbol(name, isSelectedBonds);
    };
    var onPressEnter = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var _result, item;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (result) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _result = (0,_sliced_to_array/* default */.Z)(result, 1), item = _result[0];
                        if (item) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 5:
                        if (!isBonds) {
                            _ctx.next = 8;
                            break;
                        }
                        updateSymbol(item.name, isBonds);
                        return _ctx.abrupt("return");
                    case 8:
                        updateSymbol(item.name, checkIsBonds(item.desc));
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onPressEnter() {
            return _ref.apply(this, arguments);
        };
    }();
    var renderLabel = function(item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: function() {
                return onSelect(item.name, checkIsBonds(item.desc));
            },
            "aria-hidden": true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchCompany_Tag, {
                        size: "xs",
                        type: "grey",
                        children: item.keyword || item.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        pl: "10px",
                        size: "13px",
                        children: item.desc || item.name
                    })
                ]
            })
        });
    };
    var options = function(suggestions) {
        if (!suggestions) {
            return [];
        }
        var company = suggestions.length > 0 ? {
            options: suggestions.map(function(item) {
                return {
                    value: item.keyword || item.name,
                    label: renderLabel(item)
                };
            })
        } : undefined;
        var list = [
            company
        ];
        return list.filter(function(item) {
            return item !== undefined;
        });
    };
    (0,react.useEffect)(function() {
        dispatch(slice/* default.actions.resetResult */.ZP.actions.resetResult());
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled_Autocomplete, {
        options: options(result),
        width: "100%",
        getPopupContainer: function(trigger) {
            return trigger.parentElement;
        },
        children: [
            isInTradingModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                // @ts-expect-error
                ref: ref,
                placeholder: "Type company symbol here",
                height: "40px",
                onChange: onChange,
                width: "100%",
                loading: true,
                onPressEnter: onPressEnter,
                style: {
                    maxWidth: "460px"
                },
                "data-cy": constant/* DATA_CY_MODAL_TRADING.HEADER_SEARCH_COMPANY */.eG.HEADER_SEARCH_COMPANY
            }),
            !isInTradingModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomInput, {
                // @ts-expect-error
                ref: ref,
                placeholder: "",
                height: "60px",
                onChange: onChange,
                width: "100%",
                onPressEnter: onPressEnter,
                style: {
                    outline: 0,
                    fontSize: "26px",
                    padding: "0px",
                    borderWidth: "0 0 2px"
                }
            })
        ]
    });
});
/* harmony default export */ var components_SearchCompany = (SearchCompany);


/***/ }),

/***/ 33908:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; },
/* harmony export */   "wl": function() { return /* binding */ selectors; }
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61876);
/* harmony import */ var lib_api_search__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44590);




// Action type
var CONTEXT = "@global/searchCompany";
var actionType = {
    GET_SEARCH_RESULT: "".concat(CONTEXT, "/GET_SEARCH_RESULT"),
    GET_SEARCH_RECENT_RESULT: "".concat(CONTEXT, "/GET_SEARCH_RECENT_RESULT")
};
// Initial state
var initialState = {
    error: null,
    isLoading: false,
    keyword: "",
    result: []
};
var searchCompanyState = function(state) {
    return state.searchCompany;
};
var selectors = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(searchCompanyState, function(state) {
    return {
        error: state.error,
        isLoading: state.isLoading,
        keyword: state.keyword,
        result: state.result
    };
}, function(state) {
    return state;
});
// Effects
var effects = {
    getSearchResult: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.GET_SEARCH_RESULT, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(keyword) {
            var response;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_search__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getSearch */ .Z.getSearch(keyword);
                    case 3:
                        response = _ctx.sent;
                        return _ctx.abrupt("return", response.data);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", _ctx.t0.message);
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function(keyword) {
            return _ref.apply(this, arguments);
        };
    }())
};
var reducers = {
    resetResult: function(state) {
        state.result = [];
    }
};
var extraReducers = function(builder) {
    builder.addCase(effects.getSearchResult.pending, function(state, action) {
        state.isLoading = true;
    }).addCase(effects.getSearchResult.fulfilled, function(state, action) {
        var ref, ref1;
        state.result = action === null || action === void 0 ? void 0 : (ref = action.payload) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.company;
        state.isLoading = false;
    }).addCase(effects.getSearchResult.rejected, function(state, action) {
        state.isLoading = false;
        state.error = action.payload;
    });
};
// Slice
var searchSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "searchCompany",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (searchSlice);


/***/ }),

/***/ 29097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ expiryOption; },
/* harmony export */   "CQ": function() { return /* binding */ lotSize; },
/* harmony export */   "eG": function() { return /* binding */ DATA_CY_MODAL_TRADING; },
/* harmony export */   "mr": function() { return /* binding */ triggerPriceOption; }
/* harmony export */ });
/* unused harmony export stockType */
var stockType = {
    saham: "saham",
    right: "right",
    waran: "waran",
    index: "index",
    index_asing: "index_asing",
    reksadana: "reksadana",
    commodities: "commodities",
    crypto: "crypto",
    fx: "fx",
    etf: "etf"
};
var expiryOption = [
    "Good For Day",
    "Good Till Cancelled"
];
var triggerPriceOption = [
    "≥",
    "≤"
];
var lotSize = 100; // number of shares per lot
var DATA_CY_MODAL_TRADING = {
    HEADER_TITLE: "trading-modal-header-title",
    HEADER_CHANGE_EMITEN_BUTTON_PENCIL: "trading-modal-emitten-button-pencil",
    HEADER_SEARCH_COMPANY: "trading-modal-header-search-company",
    ORDER_TYPE_BUTTON_INFO: "trading-modal-order-type-button-info",
    ORDER_TYPE_SELECT: "trading-modal-order-type-select",
    ORDER_TYPE_SELECT_DROPDOWN: "trading-modal-order-type-select-dropdown",
    FORM_TRIGGER_PRICE: "trading-modal-form-trigger-price",
    TRIGGER_PRICE_BUTTON_INFO: "trading-modal-trigger-price-button-info",
    TRIGGER_PRICE_SELECT: "trading-modal-trigger-price-select",
    FORM_PRICE: "trading-modal-form-price",
    FORM_BUY_PRICE: "trading-modal-form-buy-price",
    FORM_LOT: "trading-modal-form-lot",
    EXPIRY_SELECT: "trading-modal-expiry-select",
    EXPIRY_SELECT_DROPDOWN: "trading-modal-expiry-select-dropdown",
    BUTTON_PLACE_ORDER: "trading-modal-button-place-order",
    AVAILABLE_LOT_VALUE: "trading-modal-available-lot",
    FORM_SELL_ORDER_LOT: "trading-modal-form-sell-order-lot",
    PROFIT_LOSS_VALUE: "trading-modal-profit-loss"
};


/***/ }),

/***/ 97486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useDebounce(value, delay) {
    // State and setters for debounced value
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // Update debounced value after delay
        var handler = setTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        // Cancel the timeout if value changes (also on delay change or unmount)
        // This is how we prevent debounced value from updating if value is changed ...
        // .. within the delay period. Timeout gets cleared and restarted.
        return function() {
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
/* harmony default export */ __webpack_exports__["Z"] = (useDebounce);


/***/ }),

/***/ 64999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71158);
/* harmony import */ var global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20620);


var useTradingAccount = function() {
    var tradingType = (0,global_Securities_stores_useSecuritiesCredentialStore__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(s) {
        return s.accountType;
    });
    var isRealTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.REAL */ .Q5.REAL;
    var isVirtualTrading = tradingType === global_TradingModal_RealTradingModal_types__WEBPACK_IMPORTED_MODULE_1__/* .ACCOUNT_TYPE.VIRTUAL */ .Q5.VIRTUAL;
    return {
        tradingType: tradingType,
        isRealTrading: isRealTrading,
        isVirtualTrading: isVirtualTrading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useTradingAccount);


/***/ }),

/***/ 66959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bi": function() { return /* binding */ trackAutoBuyOrderReceivedView; },
/* harmony export */   "FY": function() { return /* binding */ trackAutoBuyOrderConfirmed; },
/* harmony export */   "Fs": function() { return /* binding */ trackAutoBuyDetailView; },
/* harmony export */   "GK": function() { return /* binding */ trackAutoSellAlterOrderView; },
/* harmony export */   "HJ": function() { return /* binding */ trackAutoSellAlterOrderSelected; },
/* harmony export */   "Jl": function() { return /* binding */ trackAutoSellOrderTypeSelected; },
/* harmony export */   "K": function() { return /* binding */ trackAutoSellOrderCanceled; },
/* harmony export */   "PH": function() { return /* binding */ trackAutoBuyOrderView; },
/* harmony export */   "Pz": function() { return /* binding */ trackAutoSellOrderDeleted; },
/* harmony export */   "RI": function() { return /* binding */ trackAutoSellOrderConfirmed; },
/* harmony export */   "Rj": function() { return /* binding */ trackAutoBuyOrderDone; },
/* harmony export */   "V0": function() { return /* binding */ trackAutoSellInfoSelected; },
/* harmony export */   "Vf": function() { return /* binding */ trackAutoSellDeleteCanceled; },
/* harmony export */   "ZY": function() { return /* binding */ trackAutoBuyTriggerConditionSelected; },
/* harmony export */   "_3": function() { return /* binding */ trackAutoBuyConfirmOrderCanceled; },
/* harmony export */   "_E": function() { return /* binding */ trackAutoBuyOrderTypeInfoSelected; },
/* harmony export */   "bG": function() { return /* binding */ trackAutoSellOrderQuantityAdjusted; },
/* harmony export */   "bm": function() { return /* binding */ trackAutoSellOrderSelected; },
/* harmony export */   "dM": function() { return /* binding */ trackAutoBuyOrderTypeSelected; },
/* harmony export */   "fY": function() { return /* binding */ trackAutoBuyOrderCanceled; },
/* harmony export */   "fh": function() { return /* binding */ trackAutoSellOrderInfoClosed; },
/* harmony export */   "gT": function() { return /* binding */ trackAutoBuyTriggerPriceInfoSelected; },
/* harmony export */   "i7": function() { return /* binding */ trackAutoSellFormView; },
/* harmony export */   "iY": function() { return /* binding */ trackAutoOrderCanceled; },
/* harmony export */   "jU": function() { return /* binding */ trackAutoBuyPreviewOrderView; },
/* harmony export */   "pR": function() { return /* binding */ trackAutoBuyOrderPlaced; },
/* harmony export */   "ur": function() { return /* binding */ trackAutoSellAutoOrderView; },
/* harmony export */   "vD": function() { return /* binding */ trackAutoSellInfoView; }
/* harmony export */ });
/* unused harmony exports trackAutoBuyAction, trackAutoBuyTncSelected, trackAutoBuyCancelOrderSelected, trackAutoBuyAmendSelected, trackAutoSellDetailOrderView, trackAutoSellOrderDetailClosed, trackAutoSellOrderTncSelected */
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

var trackAutoBuyOrderView = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Buy Buy Order Viewed");
};
var trackAutoBuyPreviewOrderView = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Buy Buy Order Previewed");
};
var trackAutoBuyOrderReceivedView = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Buy Buy Order Received Viewed");
};
var trackAutoBuyDetailView = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Buy Order Detail Viewed");
};
var trackAutoBuyAction = function(eventObject) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Buy Action", eventObject);
};
var trackAutoBuyOrderTypeSelected = function(buyOrderType, stock) {
    trackAutoBuyAction({
        Action: "Auto Buy Set Order Type Selected",
        "Buy Order Type": buyOrderType,
        Stock: stock
    });
};
var trackAutoBuyTriggerPriceInfoSelected = function() {
    trackAutoBuyAction({
        Action: "Auto Buy Trigger Price Info Selected"
    });
};
/**
 *
 * @param {('≥' | '≤')} condition
 * @returns
 */ var trackAutoBuyTriggerConditionSelected = function(condition) {
    trackAutoBuyAction({
        Action: "Auto Buy Trigger Condition Selected",
        Condition: condition
    });
};
var trackAutoBuyOrderTypeInfoSelected = function(buyOrderType, stock) {
    trackAutoBuyAction({
        Action: "Auto Buy Order Type Info Selected",
        "Buy Order Type": buyOrderType,
        Stock: stock
    });
};
var trackAutoBuyTncSelected = function() {
    trackAutoBuyAction({
        Action: "Auto Buy Smart Order Terms & Conditions Selected"
    });
};
var trackAutoBuyOrderCanceled = function() {
    trackAutoBuyAction({
        Action: "Auto Buy Order Buy Canceled"
    });
};
var trackAutoBuyOrderPlaced = function() {
    trackAutoBuyAction({
        Action: "Auto Buy Buy Order Placed"
    });
};
var trackAutoBuyConfirmOrderCanceled = function(stock, buyOrderType, expiry, triggerPrice, buyPrice, lot) {
    trackAutoBuyAction({
        Action: "Auto Buy Buy Order Canceled",
        Stock: stock,
        "Buy Order Type": buyOrderType,
        Expiry: expiry,
        "Trigger Price": triggerPrice,
        "Buy Price": buyPrice,
        Lot: lot
    });
};
var trackAutoBuyOrderConfirmed = function(stock, buyOrderType, expiry, triggerPrice, buyPrice, lot) {
    trackAutoBuyAction({
        Action: "Auto Buy Buy Order Confirmed",
        Stock: stock,
        "Buy Order Type": buyOrderType,
        Expiry: expiry,
        "Trigger Price": triggerPrice,
        "Buy Price": buyPrice,
        Lot: lot
    });
};
var trackAutoBuyOrderDone = function() {
    trackAutoBuyAction({
        Action: "Auto Buy Buy Order Done"
    });
};
var trackAutoBuyCancelOrderSelected = function(stock, buyOrderType, expiry, triggerPrice, buyPrice, lot) {
    trackAutoBuyAction({
        Action: "Auto Buy Cancel Order Selected",
        Stock: stock,
        "Buy Order Type": buyOrderType,
        Expiry: expiry,
        "Trigger Price": triggerPrice,
        "Buy Price": buyPrice,
        Lot: lot
    });
};
var trackAutoBuyAmendSelected = function(stock, buyOrderType, expiry, triggerPrice, buyPrice, lot) {
    trackAutoBuyAction({
        Action: "Auto Buy Amend Selected",
        Stock: stock,
        "Buy Order Type": buyOrderType,
        Expiry: expiry,
        "Trigger Price": triggerPrice,
        "Buy Price": buyPrice,
        Lot: lot
    });
};
// #endregion Auto Buy
// #region Auto Sell
var trackAutoSellAutoOrderView = function() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Sell Auto Order Viewed");
};
/**
 *
 * @param {("Stop Loss"|"Take Profit")} type
 */ var trackAutoSellFormView = function(type) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Sell ".concat(type, " Viewed"));
};
/**
 *
 * @param {("Stop Loss"|"Take Profit")} type
 */ var trackAutoSellInfoView = function(type) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Sell ".concat(type, " Information Viewed"));
};
var trackAutoSellDetailOrderView = function() {
    clevertapEvent("Auto Sell Detail Auto Order Viewed");
};
/**
 *
 * @param {("Edit"|"Delete")} type
 */ var trackAutoSellAlterOrderView = function(type) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Sell ".concat(type, " Auto Order Viewed"));
};
var trackAutoSellAction = function(eventObject) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)("Auto Sell Action", eventObject);
};
/**
 *
 * @param {string} stock
 */ var trackAutoSellOrderSelected = function(stock) {
    trackAutoSellAction({
        Action: "Auto Sell Set Auto Order Selected",
        Stock: stock
    });
};
/**
 *
 * @param {("Take Profit"|"Stop Loss")} type
 * @param {string} stock
 */ var trackAutoSellOrderTypeSelected = function(type, stock) {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Type Selected",
        "Auto Sell Type": type,
        Stock: stock
    });
};
var trackAutoOrderCanceled = function() {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Canceled"
    });
};
/**
 *
 * @param {("Take Profit"|"Stop Loss")} type
 */ var trackAutoSellInfoSelected = function(type) {
    trackAutoSellAction({
        Action: "Auto Sell ".concat(type, " Information Selected")
    });
};
var trackAutoSellOrderQuantityAdjusted = function() {
    trackAutoSellAction({
        Action: "Auto Sell Sell Order Quantity Adjusted"
    });
};
/**
 *
 * @param {("Take Profit"|"Stop Loss")} type
 * @param {string} stock
 * @param {number} lot
 * @param {number} price
 * @param {string} tpPercentage
 * @param {string} slPercentage
 */ var trackAutoSellOrderConfirmed = function(type, stock, lot, price, gainPercentage) {
    trackAutoSellAction({
        Action: "Auto Sell Sell Order Confirmed",
        "Auto Sell Type": type,
        Stock: stock,
        Lot: lot,
        Price: price,
        "Take Profit Percentage": type === "Take Profit" ? gainPercentage : 0,
        "Stop Loss Percentage": type === "Stop Loss" ? gainPercentage : 0
    });
};
var trackAutoSellOrderCanceled = function() {
    trackAutoSellAction({
        Action: "Auto Sell Sell Order Canceled"
    });
};
var trackAutoSellOrderInfoClosed = function() {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Information Closed"
    });
};
var trackAutoSellOrderDetailClosed = function() {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Detail Closed"
    });
};
/**
 *
 * @param {("Add"|"Edit"|"Delete")} type
 */ var trackAutoSellAlterOrderSelected = function(type) {
    trackAutoSellAction({
        Action: "Auto Sell ".concat(type, " Auto Order Selected")
    });
};
var trackAutoSellDeleteCanceled = function() {
    trackAutoSellAction({
        Action: "Auto Sell Delete Canceled"
    });
};
var trackAutoSellOrderDeleted = function() {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Deleted"
    });
};
var trackAutoSellOrderTncSelected = function() {
    trackAutoSellAction({
        Action: "Auto Sell Auto Order Terms & Conditions Selected"
    });
}; // #endregion Auto Sell


/***/ }),

/***/ 91154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$V": function() { return /* binding */ clevertapDayTradeSortSelected; },
/* harmony export */   "$f": function() { return /* binding */ clevertapExerciseClicked; },
/* harmony export */   "$v": function() { return /* binding */ clevertapDayTradeOrderTypeSelected; },
/* harmony export */   "A2": function() { return /* binding */ clevertapBuyOrderViewed; },
/* harmony export */   "Am": function() { return /* binding */ clevertapDayTradeLeverageSelected; },
/* harmony export */   "As": function() { return /* binding */ clevertapOrderPlaced; },
/* harmony export */   "B0": function() { return /* binding */ clevertapSellOrderViewed; },
/* harmony export */   "C4": function() { return /* binding */ clevertapSetPriceAlertSelected; },
/* harmony export */   "C5": function() { return /* binding */ clevertapDayTradeTNCViewed; },
/* harmony export */   "CH": function() { return /* binding */ clevertapOrderQuantityAdjusted; },
/* harmony export */   "EQ": function() { return /* binding */ clevertapChangeStock; },
/* harmony export */   "F9": function() { return /* binding */ clevertapDayTradeSplitOrderSelected; },
/* harmony export */   "FH": function() { return /* binding */ clevertapSecuritiesTradingPinSubmitted; },
/* harmony export */   "HR": function() { return /* binding */ clevertapDayTradeActivationDismissed; },
/* harmony export */   "J2": function() { return /* binding */ clevertapOrderPreviewed; },
/* harmony export */   "L": function() { return /* binding */ clevertapDayTradeDebtRatioViewed; },
/* harmony export */   "LA": function() { return /* binding */ clevertapViewChartSelected; },
/* harmony export */   "LF": function() { return /* binding */ clevertapExerciseViewed; },
/* harmony export */   "Lx": function() { return /* binding */ clevertapPortfolioDetailExercise; },
/* harmony export */   "Nf": function() { return /* binding */ clevertapDayTradeLeverageOptionViewed; },
/* harmony export */   "Rs": function() { return /* binding */ clevertapOrderTabSelected; },
/* harmony export */   "SW": function() { return /* binding */ clevertapDayTradeDebtRatioSubmitted; },
/* harmony export */   "Sv": function() { return /* binding */ clevertapExchangeFee; },
/* harmony export */   "TD": function() { return /* binding */ clevertapDayTradeDebtRatioChipSelected; },
/* harmony export */   "Uj": function() { return /* binding */ clevertapExerciseSelected; },
/* harmony export */   "V8": function() { return /* binding */ clevertapDayTradeActivationViewed; },
/* harmony export */   "_3": function() { return /* binding */ clevertapOrderDetailAmendViewed; },
/* harmony export */   "_O": function() { return /* binding */ clevertapPortfolioCompanySell; },
/* harmony export */   "_h": function() { return /* binding */ clevertapDayTradeOrderDetailSelected; },
/* harmony export */   "bQ": function() { return /* binding */ clevertapOrderCanceled; },
/* harmony export */   "dQ": function() { return /* binding */ clevertapOrderReceived; },
/* harmony export */   "f0": function() { return /* binding */ clevertapPortfolioBuyMore; },
/* harmony export */   "fn": function() { return /* binding */ clevertapSecuritiesTradingPinViewed; },
/* harmony export */   "hA": function() { return /* binding */ clevertapOrderDetailCancelConfirmed; },
/* harmony export */   "in": function() { return /* binding */ clevertapOrderViewed; },
/* harmony export */   "jS": function() { return /* binding */ clevertapDayTradeAfterMarketViewed; },
/* harmony export */   "kt": function() { return /* binding */ clevertapOrderDetailViewed; },
/* harmony export */   "lH": function() { return /* binding */ clevertapDayTradeActivationSelected; },
/* harmony export */   "mD": function() { return /* binding */ clevertapPortfolioSell; },
/* harmony export */   "mf": function() { return /* binding */ clevertapOrderDetailCancel; },
/* harmony export */   "ng": function() { return /* binding */ clevertapSetVisibleBalance; },
/* harmony export */   "oZ": function() { return /* binding */ clevertapDayTradeLeverageActivationSelected; },
/* harmony export */   "p": function() { return /* binding */ clevertapDayTradeActivationSuccessSelected; },
/* harmony export */   "pl": function() { return /* binding */ clevertapDayTradeActivationSubmitted; },
/* harmony export */   "qj": function() { return /* binding */ clevertapPortfolioDetailViewed; },
/* harmony export */   "r8": function() { return /* binding */ clevertapAutoOrderOptionsViewed; },
/* harmony export */   "rP": function() { return /* binding */ clevertapDayTradeStockListViewed; },
/* harmony export */   "sW": function() { return /* binding */ clevertapExerciseError; },
/* harmony export */   "t3": function() { return /* binding */ clevertapDayTradeDebtRatioModalViewed; },
/* harmony export */   "tG": function() { return /* binding */ clevertapPortfolioOrderViewed; },
/* harmony export */   "v8": function() { return /* binding */ clevertapOrderDone; },
/* harmony export */   "vM": function() { return /* binding */ clevertapStockSelected; },
/* harmony export */   "xA": function() { return /* binding */ clevertapOrderDetailAmend; },
/* harmony export */   "xC": function() { return /* binding */ clevertapBuyError; },
/* harmony export */   "xh": function() { return /* binding */ clevertapOrderConfirmedSuccess; },
/* harmony export */   "xs": function() { return /* binding */ clevertapDayTradeActivationSuccessViewed; },
/* harmony export */   "y8": function() { return /* binding */ clevertapOrderConfirmed; },
/* harmony export */   "yr": function() { return /* binding */ clevertapPortfolioViewed; }
/* harmony export */ });
/* unused harmony exports generateSymbolType, clevertapTransactionOrderFailed, clevertapTransactionOrderFailedConfirmed, clevertapTransactionOrderAlert, clevertapBuyStockContinue */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var constants_trading__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83153);
/* harmony import */ var constants_clevertap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92124);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48028);
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42227);
/* harmony import */ var global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29097);
/* harmony import */ var _virtualTrading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29351);
// List of clevertap event for stockbit securities
// https://www.notion.so/stockbit/Stockbit-Buy-Sell-Order-Web-e129c61e0ae64d70abdb0d1811c5ec71
// Clevertap event is wrapped with high order function
// to separate concern with existing code.








// Symbol type for clevertap is different from
// exisitng API response
function generateSymbolType(symbol) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(symbol.split("-"), 2), symbolType = ref[1];
    if (!symbolType) {
        return "Normal";
    }
    if (symbolType.toUpperCase()[0] === "R") {
        return "Right";
    }
    if (symbolType.toUpperCase()[0] === "W") {
        return "Warrant";
    }
    return "";
}
function clevertapOrderDetailCancel() {
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading, symbol = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", orderType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "Buy";
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_CANCEL_ORDER_SELECTED */ .Le, {
        Type: type,
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol),
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType)
    });
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_CANCEL_ORDER_VIEWED */ .Tf);
}
function clevertapOrderDetailCancelConfirmed(param) {
    var symbol = param.symbol, orderType = param.orderType, expiry = param.expiry, leverage = param.leverage;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_CANCEL_ORDER_CONFIRMED */ .fR, {
        symbol: symbol,
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType),
        "Symbol Type": generateSymbolType(symbol),
        Expiry: expiry,
        "Leverage Type": leverage
    });
}
function clevertapOrderDetailAmend(param) {
    var _type = param.type, type = _type === void 0 ? _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading : _type, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_AMEND_SELECTED */ .fg, {
        Type: type,
        symbol: symbol,
        "Symbol Type": generateSymbolType(symbol)
    });
}
function clevertapOrderDetailAmendViewed(param) {
    var symbol = param.symbol, orderType = param.orderType, type = param.type;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_VIEWED */ .z8, {
        Symbol: symbol,
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType),
        "Symbol Type": generateSymbolType(symbol),
        Type: type
    });
}
function clevertapOrderQuantityAdjusted(param) {
    var symbol = param.symbol, orderType = param.orderType, adjustedType = param.adjustedType;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_QUANTITY_ADJUSTED */ .gW,
        params: {
            Type: adjustedType
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_QUANTITY_ADJUSTED */ .sR,
        params: {
            Type: adjustedType
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_QUANTITY_ADJUSTED */ .lK,
        params: {
            Symbol: symbol,
            Type: adjustedType,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_QUANTITY_ADJUSTED */ .lK,
        params: {
            Symbol: symbol,
            Type: adjustedType,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderPlaced(param) {
    var orderType = param.orderType, symbol = param.symbol, price = param.price, lot = param.lot, gainLoss = param.gainLoss, totalLot = param.totalLot, tradingBalancePercentage = param.tradingBalancePercentage, status = param.status, expiry = param.expiry, type = param.type, _orderTypeStatus = param.orderTypeStatus, orderTypeStatus = _orderTypeStatus === void 0 ? "Limit Order" : _orderTypeStatus, _splitOrder = param.splitOrder, splitOrder = _splitOrder === void 0 ? false : _splitOrder, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_PLACED */ .gg,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: lot,
            "% Trading Balance": tradingBalancePercentage,
            Status: status,
            Expiry: expiry,
            Type: type,
            "Symbol Type": generateSymbolType(symbol),
            "Balance Lot": dayTrade ? "Day Trade" : "Regular",
            "Order Type": orderTypeStatus,
            "Split Order": splitOrder
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_PLACED */ .vc,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: lot,
            "Gain/Loss %": gainLoss,
            "% Total Lot": totalLot,
            Expiry: expiry,
            Type: type,
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_PLACED */ .cG,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: lot,
            Status: status,
            Expiry: expiry,
            Type: type,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Leverage Type": dayTrade ? "Day Trade" : "Regular"
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_PLACED */ .cG,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: lot,
            Status: status,
            Expiry: expiry,
            Type: type,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Leverage Type": dayTrade ? "Day Trade" : "Regular"
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderPreviewed(param) {
    var symbol = param.symbol, orderType = param.orderType;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_PREVIEWED */ .L9,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_PREVIEWED */ .q7,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_PREVIEWED */ .Hb,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_PREVIEWED */ .Hb,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.EXERCISE */ .Jm.EXERCISE, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_ORDER_PREVIEWED */ .jG,
        params: {}
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderCanceled(param) {
    var symbol = param.symbol, price = param.price, shares = param.shares, orderType = param.orderType, type = param.type;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_CANCELED */ .lE,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Type: type
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_CANCELED */ .dT,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_CANCELED */ .iW,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_CANCELED */ .iW,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Symbol Type": generateSymbolType(symbol)
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.EXERCISE */ .Jm.EXERCISE, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_ORDER_CANCELED */ .a,
        params: {
            Symbol: symbol,
            "Exercise Type": generateSymbolType(symbol),
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderConfirmed(param) {
    var symbol = param.symbol, price = param.price, shares = param.shares, orderType = param.orderType, type = param.type, _expiry = param.expiry, expiry = _expiry === void 0 ? "Good for day" : _expiry, _orderTypeStatus = param.orderTypeStatus, orderTypeStatus = _orderTypeStatus === void 0 ? "Limit Order" : _orderTypeStatus, _splitOrder = param.splitOrder, splitOrder = _splitOrder === void 0 ? false : _splitOrder, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_CONFIRMED */ .ee,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Expiry: expiry,
            "Symbol Type": generateSymbolType(symbol),
            "Balance Lot": dayTrade ? "Day Trade" : "Regular",
            "Order Type": orderTypeStatus,
            "Split Order": splitOrder
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_CONFIRMED */ .ZF,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Type: type,
            Expiry: expiry,
            "Balance Lot": dayTrade ? "Day Trade" : "Regular"
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_CONFIRMED */ .E,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY),
            "Symbol Type": generateSymbolType(symbol),
            Type: type
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_CONFIRMED */ .E,
        params: {
            Symbol: symbol,
            "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL),
            "Symbol Type": generateSymbolType(symbol),
            Type: type
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.EXERCISE */ .Jm.EXERCISE, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_ORDER_CONFIRMED */ .Dn,
        params: {
            Symbol: symbol,
            "Exercise Type": generateSymbolType(symbol),
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderConfirmedSuccess(param) {
    var symbol = param.symbol, price = param.price, shares = param.shares, orderId = param.orderId, orderType = param.orderType, _expiry = param.expiry, expiry = _expiry === void 0 ? "Good for day" : _expiry;
    var currentUrl = window.location.pathname.toLowerCase();
    var source = "Other";
    if (currentUrl.includes("symbol")) {
        if (currentUrl.includes("chartbit")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.chartbit */ .CS.chartbit;
        } else {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.companyPage */ .CS.companyPage;
        }
    } else if (currentUrl.includes("stream") || currentUrl.includes("post")) {
        source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.predictionPost */ .CS.predictionPost;
    } else if (currentUrl.includes("portfolio")) {
        source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.portfolio */ .CS.portfolio;
    } else if (currentUrl.includes("watchlist")) {
        source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.watchlist */ .CS.watchlist;
    }
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_CONFIRMED_SUCCESS */ .p3,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Expiry: expiry,
            "Ordere Id": orderId,
            "Symbol Type": generateSymbolType(symbol),
            Source: source
        }
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_CONFIRMED_SUCCESS */ .LD,
        params: {
            Symbol: symbol,
            Price: price,
            Lot: shares / global_TradingModal_constant__WEBPACK_IMPORTED_MODULE_4__/* .lotSize */ .CQ,
            Expiry: expiry,
            "Ordere Id": orderId,
            "Symbol Type": generateSymbolType(symbol),
            Source: source
        }
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderReceived(param) {
    var orderType = param.orderType;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_RECEIVED */ .Hm,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_RECEIVED */ .n2,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_RECEIVED */ .ZN,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_RECEIVED */ .ZN,
        params: {}
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapOrderDone(param) {
    var orderType = param.orderType;
    var _obj;
    var configParams = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.BUY */ .Jm.BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_DONE */ .g1,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.SELL */ .Jm.SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_DONE */ .xc,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_BUY */ .Jm.AMEND_BUY, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_DONE */ .O9,
        params: {}
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_obj, constants_trading__WEBPACK_IMPORTED_MODULE_0__/* .ORDER_TYPE.AMEND_SELL */ .Jm.AMEND_SELL, {
        key: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AMEND_ORDER_DONE */ .O9,
        params: {}
    }), _obj);
    if (configParams[orderType] !== undefined) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(configParams[orderType].key, configParams[orderType].params);
    }
}
function clevertapExchangeFee(orderType) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXCHANGE_FEE_SELECTED */ .tI);
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXCHANGE_FEE_VIEWED */ ._e, {
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType)
    });
}
function clevertapChangeStock() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .CHANGE_STOCK_VIEWED */ .jr);
}
function clevertapBuyError() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ERROR_PAGE */ .IU, {
        Reason: "Insufficient Trading Limit"
    });
}
function clevertapPortfolioSell(param) {
    var _tradingType = param.tradingType, tradingType = _tradingType === void 0 ? _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading : _tradingType, source = param.source, gainLoss = param.gainLoss, symbol = param.symbol;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_SELL_STOCK_SELECTED */ .vf, {
        Type: tradingType,
        Source: source,
        "Gain/Loss %": gainLoss,
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol)
    });
}
function clevertapPortfolioCompanySell(symbol) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_COMPANY_SELL_STOCK_SELECTED */ .JW, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol)
    });
}
function clevertapPortfolioBuyMore(symbol, gainLoss) {
    var tradingType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_BUY_MORE_SELECTED */ ._O, {
        Symbol: symbol,
        "Gain / Loss %": gainLoss,
        Type: tradingType
    });
}
function clevertapViewChartSelected(symbol) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_VIEW_CHART_SELECTED */ .J1, {
        Symbol: symbol,
        Type: type
    });
}
function clevertapSetPriceAlertSelected(symbol) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_SET_PRICE_ALERT_SELECTED */ .ef, {
        Symbol: symbol,
        Type: type
    });
}
function clevertapPortfolioViewed() {
    var tradingType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading, portfolioType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .PORTFOLIOS_TYPE.regular */ .ub.regular;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_VIEWED */ .tA, {
        Type: tradingType,
        "Portfolio List": portfolioType
    });
}
function clevertapPortfolioOrderViewed() {
    var tradingType = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_TYPES.realTrading */ .gT.realTrading, filter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Order";
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_ORDER_VIEWED */ .zF, {
        Type: tradingType,
        Filter: (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(filter)
    });
}
function clevertapOrderViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_VIEWED */ .dz);
}
function clevertapOrderDetailViewed(param) {
    var orderType = param.orderType, status = param.status, rejectReason = param.rejectReason, expiry = param.expiry, symbol = param.symbol, type = param.type, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade, _dayTradeForceSell = param.dayTradeForceSell, dayTradeForceSell = _dayTradeForceSell === void 0 ? false : _dayTradeForceSell;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .ORDER_DETAIL_VIEWED */ .v9, {
        "Order Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(orderType),
        Status: status,
        "Reject Reason": rejectReason,
        Expiry: expiry,
        Symbol: symbol,
        Type: type,
        "Symbol Type": generateSymbolType(symbol),
        "Leverage Type": dayTrade ? "Day Trade" : "Regular",
        "Force Sell Check": dayTradeForceSell ? "Force Sell" : "Regular"
    });
}
function clevertapStockSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .STOCK_SELECTED */ .B);
}
function clevertapExerciseClicked(symbol) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_EXERCISE_CLICKED */ ._g, {
        Symbol: symbol
    });
}
function clevertapExerciseViewed(param) {
    var symbol = param.symbol, share = param.share;
    return (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_VIEWED */ .dW, {
        Symbol: symbol,
        "Exercise Type": generateSymbolType(symbol),
        Share: share
    });
}
function clevertapExerciseSelected(param) {
    var symbol = param.symbol, share = param.share, stockOnHandPercentage = param.stockOnHandPercentage;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_SELECTED */ .Nq, {
        Symbol: symbol,
        "Exercise Type": generateSymbolType(symbol),
        Share: share,
        "% Stock on Hand": stockOnHandPercentage
    });
}
function clevertapExerciseError() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .EXERCISE_ERROR_PAGE */ .Vm, {
        Reason: "Melebihi Cash on Hand"
    });
}
function clevertapTransactionOrderFailed() {
    clevertapEvent(TRANSACTION_ORDER_FAILED);
}
function clevertapTransactionOrderFailedConfirmed() {
    clevertapEvent(TRANSACTION_ORDER_FAILED_CONFIRMED);
}
function clevertapTransactionOrderAlert() {
    clevertapEvent(TRANSACTION_ORDER_ALERT);
}
function clevertapBuyStockContinue() {
    clevertapEvent(BUY_STOCK_CONTINUE);
}
function clevertapPortfolioDetailViewed(param) {
    var symbol = param.symbol, gainLoss = param.gainLoss, exerciseable = param.exerciseable, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_STOCK_DETAIL_VIEWED */ .kC, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol),
        "Gain/Loss %": gainLoss,
        Exercisable: exerciseable,
        "Leverage Type": dayTrade ? "Day Trade" : "Regular"
    });
}
function clevertapPortfolioDetailExercise(symbol) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .PORTFOLIO_DETAIL_EXERCISE_SELECTED */ .le, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol)
    });
}
function clevertapDayTradeActivationViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_VIEWED */ .jY);
}
function clevertapDayTradeTNCViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_TNC_VIEWED */ .hG);
}
function clevertapDayTradeActivationSuccessViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_SUCCESS_VIEWED */ .DQ);
}
function clevertapDayTradeActivationSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_SELECTED */ .Av
    });
}
function clevertapDayTradeActivationDismissed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_DISMISSED */ .wK
    });
}
function clevertapDayTradeActivationSubmitted() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_SUBMITTED */ .mX
    });
}
function clevertapDayTradeActivationSuccessSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTIVATION_SUCCESS_SELECTED */ .Go
    });
}
function clevertapDayTradeLeverageOptionViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_LEVERAGE_OPTION_VIEWED */ .zW);
}
function clevertapDayTradeLeverageActivationSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_LEVERAGE_ACTIVATION_SELECTED */ .TC
    });
}
function clevertapDayTradeAfterMarketViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ALERT_AFTER_MARKET_VIEWED */ .D1);
}
function clevertapDayTradeDebtRatioViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ALERT_DEBT_RATIO_VIEWED */ .nc);
}
function clevertapDayTradeDebtRatioSubmitted() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ALERT_DEBT_RATIO_SUBMITTED */ .Yu
    });
}
function clevertapDayTradeDebtRatioChipSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_DEBT_RATIO_CHIP_SELECTED */ .zt
    });
}
function clevertapDayTradeDebtRatioModalViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_DEBT_RATIO_MODAL_VIEWED */ .bK);
}
function clevertapDayTradeStockListViewed(param) {
    var _sourcePage = param.sourcePage, sourcePage = _sourcePage === void 0 ? "Company Page" : _sourcePage;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_STOCK_LIST_VIEWED */ .GK, {
        "Source Page": sourcePage
    });
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_STOCK_SORT_VIEWED */ .YM);
}
function clevertapDayTradeLeverageSelected(leverage) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_LEVERAGE_SELECTED */ .L7, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_LEVERAGE_SELECTED */ .L7,
        Leverage: leverage
    });
}
function clevertapDayTradeSortSelected() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_SORT_SELECTED */ .cc
    });
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ACTION */ .bt, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_SORT_APPLIED */ .Zy
    });
}
function clevertapDayTradeOrderTypeSelected(stock, orderType) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AUTO_BUY_ACTION */ .HM, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ORDER_TYPE_SELECTED */ .YB,
        Stock: stock,
        "Buy Order Type": orderType
    });
}
function clevertapDayTradeSplitOrderSelected(toggle) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .AUTO_BUY_ACTION */ .HM, {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_SPLIT_ORDER_SELECTED */ .CV,
        Toggle: toggle ? "On" : "Off"
    });
}
function clevertapDayTradeOrderDetailSelected(param) {
    var symbol = param.symbol, _dayTrade = param.dayTrade, dayTrade = _dayTrade === void 0 ? false : _dayTrade, _forcedSell = param.forcedSell, forcedSell = _forcedSell === void 0 ? false : _forcedSell;
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_ORDER_DETAIL_SELECTED */ .BY, {
        Symbol: symbol,
        "Leverage Type": dayTrade ? "Day Trade" : "Regular",
        "Force Sell Check": forcedSell ? "Force Sell" : "Regular"
    });
}
function clevertapSecuritiesTradingPinViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SECURITIES_TRADING_PIN_VIEWED */ .Hd);
}
function clevertapSecuritiesTradingPinSubmitted() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SECURITIES_TRADING_PIN_SUBMITTED */ .II, {
        Method: "PIN Input"
    });
}
function clevertapBuyOrderViewed(symbol, sourceForm) {
    var currentUrl = window.location.pathname.toLowerCase();
    var source = "Other";
    if (!sourceForm) {
        if (currentUrl.includes("symbol")) {
            if (currentUrl.includes("chartbit")) {
                source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.chartbit */ .CS.chartbit;
            } else {
                source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.companyPage */ .CS.companyPage;
            }
        } else if (currentUrl.includes("stream") || currentUrl.includes("post")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.predictionPost */ .CS.predictionPost;
        } else if (currentUrl.includes("portfolio")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.portfolio */ .CS.portfolio;
        } else if (currentUrl.includes("watchlist")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.watchlist */ .CS.watchlist;
        }
    }
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .BUY_ORDER_VIEWED */ .HA, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol),
        Source: source
    });
}
function clevertapSellOrderViewed(symbol, sourceForm) {
    var currentUrl = window.location.pathname.toLowerCase();
    var source = "Other";
    if (!sourceForm) {
        if (currentUrl.includes("symbol")) {
            if (currentUrl.includes("chartbit")) {
                source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.chartbit */ .CS.chartbit;
            } else {
                source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.companyPage */ .CS.companyPage;
            }
        } else if (currentUrl.includes("stream") || currentUrl.includes("post")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.predictionPost */ .CS.predictionPost;
        } else if (currentUrl.includes("portfolio")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.portfolio */ .CS.portfolio;
        } else if (currentUrl.includes("watchlist")) {
            source = _virtualTrading__WEBPACK_IMPORTED_MODULE_5__/* .VIRTUAL_TRADING_SOURCE.watchlist */ .CS.watchlist;
        }
    }
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SELL_ORDER_VIEWED */ .gE, {
        Symbol: symbol,
        "Symbol Type": generateSymbolType(symbol),
        Source: source
    });
}
function clevertapAutoOrderOptionsViewed() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SECURITIES_AUTO_ORDER_OPTIONS_VIEWED */ .YS);
}
function clevertapSetVisibleBalance() {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)(constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .DAY_TRADE_SET_VISIBLE_BALANCE */ .G2);
}
function clevertapOrderTabSelected(tab) {
    (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_2__/* .clevertapEvent */ .Lq)("Order Detail Action", {
        Action: constants_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .SECURITIES_ORDER_TAB_SELECTED */ .Oc,
        "Transaction Type": (0,utils_general__WEBPACK_IMPORTED_MODULE_3__/* .capitalizeFirstLetter */ .fm)(tab)
    });
}


/***/ }),

/***/ 29351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CS": function() { return /* binding */ VIRTUAL_TRADING_SOURCE; },
/* harmony export */   "SP": function() { return /* binding */ virtualTradingAction; },
/* harmony export */   "S_": function() { return /* binding */ SWITCH_TO_REAL_ACCOUNT_SOURCE; },
/* harmony export */   "Y0": function() { return /* binding */ ORDER_EXPIRY; },
/* harmony export */   "f9": function() { return /* binding */ virtualTradingNavigate; },
/* harmony export */   "gT": function() { return /* binding */ VIRTUAL_TRADING_TYPES; },
/* harmony export */   "ub": function() { return /* binding */ PORTFOLIOS_TYPE; }
/* harmony export */ });
/* unused harmony exports VIRTUAL_TRADING_NAVIGATE, VIRTUAL_TRADING_ACTION, SYMBOL_TYPES, ORDER_FILTER, virtualTradingEvents */
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48028);

var VIRTUAL_TRADING_NAVIGATE = {
    buyOrderViewed: "Buy Order Viewed",
    portfolioViewed: "Portfolio Viewed",
    sellOrderViewed: "Sell Order Viewed",
    portfolioOrderViewed: "Portfolio Order Viewed",
    orderDetailViewed: "Order Detail Viewed",
    amendOrderViewed: "Amend Order Viewed"
};
var VIRTUAL_TRADING_ACTION = {
    virtualTradingAction: "Virtual Trading Action",
    startTradingSelected: "Start Trading Selected",
    virtualTradingSelected: "Virtual Trading Selected",
    switchToRealTradingSelected: "Switch To Real Trading Selected",
    virtualTradingOrderbookSelected: "Virtual Trading Orderbook Selected",
    virtualTradingPortfolioSelected: "Virtual Trading Portfolio Selected",
    virtualTradingOrderSelected: "Virtual Trading Order Selected",
    buyOrderPlaced: "Buy Order Placed",
    buyOrderCanceled: "Buy Order Canceled",
    portfolioBuyMoreSelected: "Portfolio Buy More Selected",
    portfolioSellStockSelected: "Portfolio Sell Stock Selected",
    portfolioViewChartSelected: "Portfolio View Chart Selected",
    portfolioSetPriceAlert: "Portfolio Set Price Alert Selected",
    portfolioStockSelected: "Portfolio Stock Selected",
    sellOrderPlaced: "Sell Order Placed",
    orderDetailCancelOrderSelected: "Order Detail Cancel Order Selected",
    orderDetailAmendSelected: "Order Detail Amend Selected",
    amendOrderPlaced: "Amend Order Placed"
};
var VIRTUAL_TRADING_TYPES = {
    virtualTrading: "Virtual Trading",
    realTrading: "Real Trading"
};
var SYMBOL_TYPES = {
    right: "Right",
    warrant: "Warrant",
    normal: "Normal"
};
var VIRTUAL_TRADING_SOURCE = {
    watchlist: "Watchlist",
    portfolio: "Portfolio",
    predictionPost: "Prediction Post",
    companyPage: "Company Page",
    chartbit: "Chartbit"
};
var SWITCH_TO_REAL_ACCOUNT_SOURCE = {
    orderModal: "Order Modal",
    dropdownVirtualArea: "Dropdown 'Virtual Area'"
};
var ORDER_FILTER = {
    order: "Order",
    exercise: "Exercise",
    cashback: "Cashback"
};
var ORDER_EXPIRY = {
    goodForDay: "Good for day",
    goodTillCanceled: "Good till canceled"
};
var PORTFOLIOS_TYPE = {
    regular: "Regular",
    dayTrade: "Day Trade",
    both: "Both",
    none: "None"
};
var virtualTradingEvents = {
    onSwitchToVirtualTrading: function() {
        var action = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Switch To Virtual Selected";
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: action
        });
    }
};
var virtualTradingNavigate = {
    onBuyOrderViewes: function(Symbol, Source, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.buyOrderViewed, {
            Symbol: Symbol,
            Source: Source,
            Type: Type
        });
    },
    onPortfolioViewed: function(Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.portfolioViewed, {
            Type: Type
        });
    },
    onSellOrderViewed: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.sellOrderViewed, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onPortfolioOrderViewed: function(Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.portfolioOrderViewed, {
            Type: Type
        });
    },
    onOrderDetailViewed: function(param) {
        var OrderType = param.OrderType, Status = param.Status, _RejectReason = param.RejectReason, RejectReason = _RejectReason === void 0 ? "" : _RejectReason, Symbol = param.Symbol, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.orderDetailViewed, {
            "Order Type": OrderType,
            Status: Status,
            "Reject Reason": RejectReason,
            Symbol: Symbol,
            Type: Type
        });
    },
    onAmendOrderViewed: function(param) {
        var Symbol = param.Symbol, OrderType = param.OrderType, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_NAVIGATE.amendOrderViewed, {
            Symbol: Symbol,
            "Order Type": OrderType,
            Type: Type
        });
    }
};
var virtualTradingAction = {
    onStartTradingSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.startTradingSelected
        });
    },
    onVirtualTradingSelected: function(isStockbitSekuritas) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingSelected,
            "Is Stockbit Sekuritas": isStockbitSekuritas
        });
    },
    onSwitchToRealTradingSelected: function(Source, isStockbitSekuritas) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.switchToRealTradingSelected,
            Source: Source,
            "Is Stockbit Sekuritas": isStockbitSekuritas
        });
    },
    onVirtualTradingOrderbookSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingOrderbookSelected
        });
    },
    onVirtualTradingPortfolioSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingPortfolioSelected
        });
    },
    onVirtualTradingOrderSelected: function() {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.virtualTradingOrderSelected
        });
    },
    onBuyOrderPlaced: function(param) {
        var Symbol = param.Symbol, Price = param.Price, Lot = param.Lot, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.buyOrderPlaced, {
            Symbol: Symbol,
            Price: Price,
            Lot: Lot,
            Type: Type
        });
    },
    onBuyOrderCanceled: function(param) {
        var Symbol = param.Symbol, Price = param.Price, Lot = param.Lot, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.virtualTradingAction, {
            Action: VIRTUAL_TRADING_ACTION.buyOrderCanceled,
            Symbol: Symbol,
            Price: Price,
            Lot: Lot,
            Type: Type
        });
    },
    onPortfolioBuyMoreSelected: function(param) {
        var Symbol = param.Symbol, gainLossPercentage = param.gainLossPercentage, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioBuyMoreSelected, {
            Symbol: Symbol,
            "Gain / Loss %": gainLossPercentage,
            Type: Type
        });
    },
    onPortfolioSellStockSelected: function(Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioSellStockSelected, {
            Type: Type
        });
    },
    onPortfolioViewChartSelected: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioViewChartSelected, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onPortfolioSetPriceAlert: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioSetPriceAlert, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onPortfolioStockSelected: function(Symbol, Type) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.portfolioStockSelected, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onSellOrderPlaced: function(param) {
        var Symbol = param.Symbol, Price = param.Price, gainLossPercentage = param.gainLossPercentage, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.sellOrderPlaced, {
            Symbol: Symbol,
            Price: Price,
            "Gain / Loss %": gainLossPercentage,
            Type: Type
        });
    },
    onOrderDetailCancelOrderSelected: function(Symbol) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.orderDetailCancelOrderSelected, {
            Symbol: Symbol
        });
    },
    onOrderDetailAmendSelected: function(param) {
        var Symbol = param.Symbol, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.orderDetailAmendSelected, {
            Symbol: Symbol,
            Type: Type
        });
    },
    onAmendOrderPlaced: function(param) {
        var Symbol = param.Symbol, Price = param.Price, Type = param.Type;
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_0__/* .clevertapEvent */ .Lq)(VIRTUAL_TRADING_ACTION.amendOrderPlaced, {
            Symbol: Symbol,
            Price: Price,
            Type: Type
        });
    }
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    virtualTradingEvents: virtualTradingEvents
});


/***/ }),

/***/ 62974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q7": function() { return /* binding */ isFloat; },
/* harmony export */   "QV": function() { return /* binding */ roundNumber; },
/* harmony export */   "St": function() { return /* binding */ parseCountAbbrv2; },
/* harmony export */   "YA": function() { return /* binding */ parseNumberAbbrvNum; },
/* harmony export */   "rl": function() { return /* binding */ formatPercentage; },
/* harmony export */   "uf": function() { return /* binding */ formatNumber; },
/* harmony export */   "ym": function() { return /* binding */ parseCountThousand; }
/* harmony export */ });
/* unused harmony exports kNumberFormatter, bNumberFormatter, decideNumberFormatter, parseCountAbbrv3, parseCountThousandWithDecimalPlace, parsePureValueSep */
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable no-param-reassign */ /* eslint-disable arrow-body-style */ /* eslint-disable radix */ 
/*
  Count length of given decimal
*/ function countLengthDecimal(num) {
    var match = "".concat(num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (!match) {
        return 0;
    }
    return Math.max(0, // Number of digits right of decimal point.
    (match[1] ? match[1].length : 0) - // Adjust for scientific notation.
    (match[2] ? +match[2] : 0));
}
/*
  Get random integer from in range of min to max value
*/ function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
/**
 * Get total digit of a number
 * @param {number} num
 */ function getNumberDigit(num) {
    var netral = Math.abs(num);
    return netral.toString().length;
}
/**
 * Shorten thousands number
 * @param {number} num
 * @param {number} fixed
 * @param {boolean} symbol
 */ function kNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, withComa = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number;
    var nd = getNumberDigit(num);
    if (nd > 3) {
        number = (num / (nd > 5 ? 100000 : 1000)).toFixed(fixed);
        if (!withComa) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0");
        } else if (withComa) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(typeof withComa === "string" ? withComa : "0,0.00");
        }
        if (symbol) {
            number += "K";
        }
    } else {
        number = num;
    }
    return number;
}
/**
 * Shorten long number and add suffix M
 * @param {number} num - Long number
 * @param {number} fixed - Decimal
 * @param {boolean} symbol - Flag to add symbol suffix
 */ function mNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var number;
    var decide = false; // is decide need number
    if (getNumberDigit(num) > 6) decide = true;
    if (decide) {
        number = (num / 1000000).toFixed(fixed);
        if (symbol) {
            number += "M";
        }
    } else {
        number = num;
    }
    return number;
}
/**
 * Shorten long number and add suffix B
 * @param {number} num - Long number
 * @param {number} fixed - Decimal number
 * @param {boolean} symbol - Flag to add symbol suffix
 */ function bNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, formatDot = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number = (num / 1000000000).toFixed(fixed);
    if (symbol) {
        if (formatDot) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0.0");
        } else {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0[.]0");
        }
        number += "B";
    }
    return number;
}
function tNumberFormatter(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var number = (num / 1000000000000).toFixed(fixed);
    if (symbol) {
        number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0.0");
        number += "T";
    }
    return number;
}
/**
 * Function to decide which number formatter should be used based on
 * the number length
 * @param {number} num
 * @param {boolean} withThousands
 * @param {boolean} formatDot
 */ function decideNumberFormatter(num, withThousands, formatDot) {
    var numberDigit = getNumberDigit(num);
    if (numberDigit > 12 && formatDot) return tNumberFormatter;
    if (numberDigit > 9) return bNumberFormatter;
    if (withThousands) {
        if (numberDigit > 6) return mNumberFormatter;
        return kNumberFormatter;
    }
    return mNumberFormatter;
}
/**
 * Number formatter wrapper
 * @param {Object} params
 * @param {*} params.num - Number to be formatted
 * @param {number} params.fixed - Decimal place
 * @param {boolean=} params.symbol - If formatted number has symbol suffix
 * @param {boolean=} params.withThousands - If decided to format thousands number
 * @param {*=} params.formatDot - Using dot in formatting
 * @returns {string | number} -formatted number
 */ function numberFormatter(param) {
    var num = param.num, fixed = param.fixed, _symbol = param.symbol, symbol = _symbol === void 0 ? true : _symbol, _withThousands = param.withThousands, withThousands = _withThousands === void 0 ? false : _withThousands, _formatDot = param.formatDot, formatDot = _formatDot === void 0 ? false : _formatDot;
    var formatter = decideNumberFormatter(num, withThousands, Boolean(formatDot));
    return formatter(num, fixed, symbol, formatDot);
}
var char_count = function(str, letter) {
    var letter_Count = 0;
    for(var position = 0; position < str.length; position += 1){
        if (str.charAt(position) === letter) {
            letter_Count += 1;
        }
    }
    return letter_Count;
};
var roundNumber = function(number, format) {
    var nFormat = format.split(".");
    var multiplier = 1;
    if (nFormat.length > 1) {
        var getDecimal = nFormat.pop();
        var decimal = char_count(getDecimal, "0");
        multiplier = Math.pow(10, decimal);
    }
    var nNumber = (number >= 0 ? Math.floor : Math.ceil)(number * multiplier) / multiplier;
    return nNumber;
};
var isFloat = function(n1) {
    return Number(n1) % 1 !== 0;
};
var processNumber = function(number, format, showTrailingZero) {
    var formattedNumber = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(format);
    var roundingNumber = formattedNumber;
    var splitNumber = formattedNumber.split(".");
    var isDecimal = splitNumber.length > 1;
    if (!showTrailingZero) {
        if (isDecimal) {
            roundingNumber = formattedNumber.replace(/(\.0+|0+)$/, "");
        } else if (splitNumber.length) {
            // eslint-disable-next-line prefer-destructuring
            roundingNumber = splitNumber[0];
        }
    }
    return roundingNumber;
};
var formatNumber = function(number) {
    var rounding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0,0", showTrailingZero = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var roundingNumber = rounding ? roundNumber(number, format) : number;
    var newNumber = processNumber(roundingNumber, format, showTrailingZero);
    return newNumber;
};
var formatPercentage = function(number) {
    var rounding = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, format = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "0.00", showTrailingZero = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (number === Infinity) number = 0;
    var roundingNumber = rounding ? roundNumber(number, format) : number;
    var newNumber = processNumber(roundingNumber, format, showTrailingZero);
    return "".concat(newNumber, "%");
};
var parseLot = function(lot) {
    return Math.round(lot / 100);
};
var parseCountAbbrv3 = function(number, decPlaces) {
    var abbreviation = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, withDecimal = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, withMinusSymbol = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var result = 0;
    var minus = false;
    var newNumber = number;
    // eslint-disable-next-line eqeqeq
    if (newNumber && newNumber.toString().indexOf("-") == 0) {
        minus = true;
    }
    newNumber = Math.ceil(newNumber);
    if (!decPlaces) decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    var abbrev;
    // Enumerate number abbreviations
    // eslint-disable-next-line default-case
    switch(abbreviation){
        case 1:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M",
                "B",
                "T"
            ];
            break;
        case 2:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M",
                "B"
            ];
            break;
        case 3:
            // Enumerate number abbreviations
            abbrev = [
                "K",
                "M"
            ];
            break;
        case 4:
            // Enumerate number abbreviations
            abbrev = [
                "K"
            ];
            break;
    }
    // Go through the array backwards, so we do the largest first
    // eslint-disable-next-line no-plusplus
    for(var i = abbrev.length - 1; i >= 0; i--){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= newNumber) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            newNumber = Math.round(newNumber * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (newNumber === 1000 && i < abbrev.length - 1) {
                newNumber = 1;
                // eslint-disable-next-line no-plusplus
                i++;
            }
            var format = withDecimal ? "0,0[.]0" : "0,0";
            newNumber = numeral__WEBPACK_IMPORTED_MODULE_0___default()(newNumber).format(format);
            if (minus) {
                newNumber = withMinusSymbol ? "-".concat(newNumber) : "(".concat(newNumber, ")");
            }
            // Add the letter for the abbreviation
            newNumber += "".concat(abbrev[i]);
            break;
        }
    }
    if (number) {
        var numString = newNumber.toString();
        result = numString;
    }
    return result;
};
var isNum = function(n1) {
    return !Number.isNaN(parseFloat(n1)) && Number.isFinite(n1);
};
var addPlusOrMinus2 = function(value) {
    if (!isNum(value)) {
        return value;
    }
    var formattedValue = numeral__WEBPACK_IMPORTED_MODULE_0___default()(value).value();
    var newValue = parseFloat(formattedValue);
    if (formattedValue !== 0) {
        newValue = formattedValue < 0 ? numeral__WEBPACK_IMPORTED_MODULE_0___default()(newValue).format("0,0") : "+".concat(numeral__WEBPACK_IMPORTED_MODULE_0___default()(newValue).format("0,0"));
    }
    return typeof newValue !== "string" ? String(newValue) : newValue;
};
var parseCountThousand = function(num, withdot) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    // let sep = ','
    try {
        if (withdot) {
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
        }
        return removeCountDotThousand(num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator));
    } catch (e) {
        return num;
    }
};
var parseCountThousandWithDecimalPlace = function(num) {
    var decimalPlace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    // let sep = ','
    try {
        return removeCountDotThousand(num.toLocaleString());
    } catch (e) {
        return num;
    }
};
function parsePureValueSep(pv) {
    var thoSep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ",";
    // console.log('::-- parsePureValue ', {pv, thoSep})
    if (typeof pv !== "number") pv = parseFloat(pv);
    return parseFloat(pv.toFixed(2)).toLocaleString("en-US");
}
var parseCountAbbrv2 = function(number, decPlaces) {
    var thoSep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",", enableK = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var result = 0;
    if (typeof decPlaces !== "number") decPlaces = 3;
    // 2 decimal places => 100, 3 => 1000, etc
    decPlaces = Math.pow(10, decPlaces);
    // Enumerate number abbreviations
    var abbrev = [
        "K",
        "M",
        "B"
    ];
    var oldNumber = number;
    // Go through the array backwards, so we do the largest first
    for(var i = abbrev.length - 1; i >= 0; i--){
        // Convert array index to "1000", "1000000", etc
        var size = Math.pow(10, (i + 1) * 3);
        // If the number is bigger or equal do the abbreviation
        if (size <= number) {
            // Here, we multiply by decPlaces, round, and then divide by decPlaces.
            // This gives us nice rounding to a particular decimal place.
            number = Math.round(number * decPlaces / size) / decPlaces;
            // Handle special case where we round up to the next abbreviation
            if (number == 1000 && i < abbrev.length - 1) {
                number = 1;
                i++;
            }
            // Add the letter for the abbreviation
            number += "".concat(abbrev[i]);
            break;
        }
    }
    var raw = [];
    if (number) {
        number = number.toString();
        raw = number.split(" ");
        if (raw[0] && raw[1]) {
            // console.log('::-- row raw ', parsePureValueSep(raw[0], thoSep));
            result = parsePureValueSep(raw[0], thoSep);
            if (raw[1] === "K" && !enableK) {
                result = parseFloat(oldNumber);
                result = parsePureValueSep(result, thoSep);
            } else {
                result = "".concat(result, " ").concat(raw[1]);
            }
        } else {
            result = number;
        }
    }
    //   if(number) {
    // result = number.replace('.', ',')
    //   }
    return result;
};
function parseNumberAbbrvNum(val, format) {
    var number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(val);
    var formatted = number.format(format);
    return formatted;
}
var parseCountAbbrv4 = function(param) {
    var value = param.value, decPlaces = param.decPlaces, _abbreviation = param.abbreviation, abbreviation = _abbreviation === void 0 ? 1 : _abbreviation, _withDecimal = param.withDecimal, withDecimal = _withDecimal === void 0 ? false : _withDecimal, _withMinusSymbol = param.withMinusSymbol, withMinusSymbol = _withMinusSymbol === void 0 ? false : _withMinusSymbol;
    return parseCountAbbrv3(value, decPlaces, abbreviation, withDecimal, withMinusSymbol);
};
/**
 * Shorten thousands number
 * @param {number} num
 * @param {number} fixed
 * @param {boolean} symbol
 * @param {boolean} withComma
 */ function kNumberFormatterV2(num) {
    var fixed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, symbol = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, withComma = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var number;
    var nd = getNumberDigit(num);
    if (nd > 3) {
        number = (num / 1000).toFixed(fixed);
        if (!withComma) {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format("0,0");
        } else {
            number = numeral__WEBPACK_IMPORTED_MODULE_0___default()(number).format(typeof withComma === "string" ? withComma : "0,0.0");
        }
        if (symbol) {
            number += "K";
        }
    } else {
        number = num;
    }
    return number;
}
var numberFormat = function(param) {
    var value = param.value, decimals = param.decimals, _decimalPoint = param.decimalPoint, decimalPoint = _decimalPoint === void 0 ? "." : _decimalPoint, _thousandSeparator = param.thousandSeparator, thousandSeparator = _thousandSeparator === void 0 ? "," : _thousandSeparator;
    //  discuss at: http://phpjs.org/functions/number_format/
    // original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // improved by: davook
    // improved by: Brett Zamir (http://brett-zamir.me)
    // improved by: Brett Zamir (http://brett-zamir.me)
    // improved by: Theriault
    // improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
    // bugfixed by: Michael White (http://getsprink.com)
    // bugfixed by: Benjamin Lupton
    // bugfixed by: Allan Jensen (http://www.winternet.no)
    // bugfixed by: Howard Yeend
    // bugfixed by: Diogo Resende
    // bugfixed by: Rival
    // bugfixed by: Brett Zamir (http://brett-zamir.me)
    //  revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
    //  revised by: Luke Smith (http://lucassmith.name)
    //    input by: Kheang Hok Chin (http://www.distantia.ca/)
    //    input by: Jay Klehr
    //    input by: Amir Habibi (http://www.residence-mixte.com/)
    //    input by: Amirouche
    //   example 1: number_format(1234.56);
    //   returns 1: '1,235'
    //   example 2: number_format(1234.56, 2, ',', ' ');
    //   returns 2: '1 234,56'
    //   example 3: number_format(1234.5678, 2, '.', '');
    //   returns 3: '1234.57'
    //   example 4: number_format(67, 2, ',', '.');
    //   returns 4: '67,00'
    //   example 5: number_format(1000);
    //   returns 5: '1,000'
    //   example 6: number_format(67.311, 2);
    //   returns 6: '67.31'
    //   example 7: number_format(1000.55, 1);
    //   returns 7: '1,000.6'
    //   example 8: number_format(67000, 5, ',', '.');
    //   returns 8: '67.000,00000'
    //   example 9: number_format(0.9, 0);
    //   returns 9: '1'
    //  example 10: number_format('1.20', 2);
    //  returns 10: '1.20'
    //  example 11: number_format('1.20', 4);
    //  returns 11: '1.2000'
    //  example 12: number_format('1.2000', 3);
    //  returns 12: '1.200'
    //  example 13: number_format('1 000,50', 2, '.', ' ');
    //  returns 13: '100 050.00'
    //  example 14: number_format(1e-8, 8, '.', '');
    //  returns 14: '0.00000001'
    var newNumber = value;
    var newDecimals = decimals;
    newNumber = "".concat(newNumber).replace(/[^0-9+\-Ee.]/g, "");
    var number = !isFinite(+newNumber) ? 0 : +newNumber;
    var prec = !isFinite(+newDecimals) ? 0 : Math.abs(newDecimals);
    var sep = thousandSeparator;
    var dec = decimalPoint;
    var sum = "";
    var toFixedFix = function toFixedFix(num, precision) {
        var power = Math.pow(10, precision);
        return "".concat((Math.round(num * power) / power).toFixed(precision));
    };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    sum = (prec ? toFixedFix(number, prec) : "".concat(Math.round(n))).split(".");
    if (sum[0].length > 3) {
        sum[0] = sum[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((sum[1] || "").length < prec) {
        sum[1] = sum[1] || "";
        sum[1] += new Array(prec - sum[1].length + 1).join("0");
    }
    return sum.join(dec);
};
var removeCountDotThousand = function(num) {
    if (!num.includes(".")) return num;
    num = numberFormat({
        value: num,
        decimals: 2
    });
    // pembulatan next index
    return num;
};
var isDecimal = function(result) {
    if (result > Math.floor(result)) {
        return true;
    }
    return false;
};
/* harmony default export */ __webpack_exports__["ZP"] = ({
    countLengthDecimal: countLengthDecimal,
    getRandomInt: getRandomInt,
    decideNumberFormatter: decideNumberFormatter,
    numberFormatter: numberFormatter,
    bNumberFormatter: bNumberFormatter,
    mNumberFormatter: mNumberFormatter,
    kNumberFormatter: kNumberFormatter,
    parseCountAbbrv3: parseCountAbbrv3,
    parseLot: parseLot,
    addPlusOrMinus2: addPlusOrMinus2,
    parseCountAbbrv4: parseCountAbbrv4,
    kNumberFormatterV2: kNumberFormatterV2,
    numberFormat: numberFormat,
    isDecimal: isDecimal,
    parseCountAbbrv2: parseCountAbbrv2
});


/***/ })

}]);